import { createContext, useContext, useState, useEffect, useCallback, useMemo } from 'react';

export const SUPPORTED_LANGUAGES = [
  { code: 'pt-BR', label: 'Português', short: 'PT' },
  { code: 'en-US', label: 'English', short: 'EN' },
  { code: 'es-ES', label: 'Español', short: 'ES' }
];

const STORAGE_KEY = 'gph_lang';
const STORAGE_SHORT_KEY = 'gph_lang_short';
const DEFAULT_LANGUAGE = 'pt-BR';

const LANGUAGE_FALLBACK_TEXT = {
  'pt-BR': 'Texto indisponível',
  'en-US': 'Text unavailable',
  'es-ES': 'Texto no disponible'
};

const LEGACY_TO_CANONICAL = {
  pt: 'pt-BR', en: 'en-US', es: 'es-ES',
  'pt-br': 'pt-BR', 'en-us': 'en-US', 'es-es': 'es-ES'
};

const CANONICAL_TO_SHORT = {
  'pt-BR': 'pt', 'en-US': 'en', 'es-ES': 'es'
};

export const AI_LANGUAGE_INSTRUCTION = {
  'pt-BR': 'Responda sempre em português do Brasil. Use linguagem clara, direta e natural para jogadores brasileiros.',
  'en-US': 'Always respond in English. Use clear, direct and natural language for FPS mobile players.',
  'es-ES': 'Responde siempre en español. Usa un lenguaje claro, directo y natural para jugadores de FPS mobile.'
};

const ptBR = {

  "landing_hero_badge": "IA para jogadores competitivos de FPS mobile",
  "landing_hero_title": "Pare de jogar igual bot.",
  "landing_hero_subtitle": "A Mi descobre o erro da sua mira, indica o ajuste e te guia no próximo treino.",
  "landing_primary_cta": "Assinar Pro por R$29,99",
  "landing_secondary_cta": "Testar grátis",
  "landing_hero_microcopy": "Menos que um lanche. Mais útil que trocar sensi pela 14ª vez.",
  "landing_badge_diag": "Diagnóstico de mira",
  "landing_badge_sensi": "Ajuste de sensibilidade",
  "landing_badge_training": "Treino guiado",
  "landing_badge_analysis": "Análise de gameplay",
  "landing_pain_title": "O problema não é jogar pouco. É treinar no escuro.",
  "landing_pain_1_title": "Mira sobe no spray",
  "landing_pain_1_desc": "Você compensa no dedo, mas não sabe se o erro é controle ou sensibilidade.",
  "landing_pain_2_title": "Sensi muda toda hora",
  "landing_pain_2_desc": "Hoje 120, amanhã 95, depois copia a de alguém. Estratégia zero.",
  "landing_pain_3_title": "Treino sem direção",
  "landing_pain_3_desc": "Você joga muito, mas repete o mesmo erro como se fosse aquecimento.",
  "landing_solution_title": "A Mi corta o achismo.",
  "landing_solution_desc": "O Game Pro Hub conecta diagnóstico, sensibilidade, treino e análise em um fluxo simples.",
  "landing_sol_step_1": "1. Fale o problema",
  "landing_sol_step_2": "2. Receba o diagnóstico",
  "landing_sol_step_3": "3. Ajuste sua base",
  "landing_sol_step_4": "4. Treine o ponto fraco",
  "landing_sol_step_5": "5. Analise sua gameplay",
  "landing_sol_cta": "Começar agora",
  "landing_pro_title": "O Free mostra o começo. O Pro libera o ciclo completo.",
  "landing_pro_value": "Pro por R$29,99/mês",
  "landing_pro_value_sub": "R$29,99/mês",
  "landing_pro_b1": "Diagnóstico com IA",
  "landing_pro_b2": "Ajustes de sensibilidade",
  "landing_pro_b3": "Treinos guiados pela Mi",
  "landing_pro_b4": "Análise de gameplay",
  "landing_pro_b5": "Comunidade oficial no WhatsApp",
  "landing_pro_b6": "Suporte e Comunidade",
  "landing_pro_microcopy": "Se você já gastou mais que isso em skin, dá para investir na mira.",
  "landing_7day_title": "7 dias para parar de jogar no chute.",
  "landing_7day_desc": "Um plano simples para sair do ciclo: perder, mudar sensi, repetir.",
  "landing_7d_1": "Dia 1 — Descubra o erro",
  "landing_7d_2": "Dia 2 — Ajuste sua base",
  "landing_7d_3": "Dia 3 — Treine o ponto fraco",
  "landing_7d_4": "Dia 4 — Valide na prática",
  "landing_7d_5": "Dia 5 — Analise sua gameplay",
  "landing_7d_6": "Dia 6 — Corrija o erro principal",
  "landing_7d_7": "Dia 7 — Repita com mais precisão",
  "landing_7day_cta": "Iniciar meu plano Pro",
  "landing_community_title": "Você não precisa descobrir tudo sozinho.",
  "landing_community_desc": "Entre na comunidade oficial do Game Pro Hub no WhatsApp, tire dúvidas e acompanhe atualizações.",
  "landing_comm_btn": "Entrar na comunidade",
  "landing_comm_whatsapp_title": "Comunidade oficial no WhatsApp",
  "landing_comm_whatsapp_desc": "Troque ideias com outros jogadores competitivos de FPS mobile.",
  "landing_comm_support_title": "Suporte Prioritário",
  "landing_comm_support_desc": "Tire dúvidas e receba orientação contínua no ecossistema.",
  "landing_faq_title": "Dúvidas frequentes",
  "landing_faq_q1": "Serve para qualquer FPS mobile?",
  "landing_faq_a1": "Sim. O foco é mira, sensibilidade, treino e análise de gameplay.",
  "landing_faq_q2": "Preciso ser avançado?",
  "landing_faq_a2": "Não. Você fala o problema e a Mi indica o próximo passo.",
  "landing_faq_q3": "Quanto custa o Pro?",
  "landing_faq_a3": "R$29,99 por mês.",
  "landing_faq_q4": "Posso cancelar?",
  "landing_faq_a4": "Sim, conforme o fluxo atual da plataforma.",
  "landing_faq_q5": "Tem suporte?",
  "landing_faq_a5": "Sim. Você conta com a comunidade oficial no WhatsApp e suporte prioritário para tirar dúvidas.",
  "landing_final_title": "Pare de mudar sensi no desespero.",
  "landing_final_subtitle": "Entre no Game Pro Hub, siga o plano da Mi e treine com direção.",
  "landing_final_cta_sec": "Criar conta grátis",
  "auth_title": "Acesse sua conta",
  "auth_subtitle": "Entre ou crie sua conta para continuar.",
  "auth_player_name": "Nome de Jogador",
  "auth_your_nickname": "Seu Nickname",
  "auth_email": "E-mail",
  "auth_password": "Senha",
  "auth_login": "Entrar",
  "auth_create_account": "Criar Conta",
  "auth_or": "Ou",
  "auth_continue_google": "Continuar com Google",
  "auth_new_account": "Criar Nova Conta",
  "auth_have_account": "Já Tenho Conta",
  "auth_title_sign_in": "Entrar",
  "auth_title_register": "Criar Conta",
  "auth_subtitle_sign_in": "Acesse sua conta",
  "auth_subtitle_register": "Preencha para começar",
  "auth_email_placeholder": "Seu e-mail",
  "auth_password_placeholder": "Sua senha",
  "auth_missing_credentials": "Preencha todos os campos.",
  "auth_sync_error": "Erro na sincronização.",
  "auth_invalid_credentials": "Credenciais inválidas.",
  "auth_already_have_account": "Já tem conta? Entrar",
  "auth_no_account": "Não tem conta? Criar",
  "auth_secure_access": "ACESSO SEGURO",
  "auth_error_generic": "Não conseguimos entrar agora. Tente novamente.",
  "auth_error_fill_email_password": "Preencha seu e-mail e senha.",
  "auth_error_email_in_use": "Este e-mail já tem uma conta. Use Entrar com e-mail.",
  "auth_error_check_credentials": "Não conseguimos entrar agora. Confira e tente novamente.",
  "auth_error_weak_password": "Use uma senha com pelo menos 6 caracteres.",
  "auth_error_invalid_email": "Digite um e-mail válido.",
  "auth_error_reset_email_required": "Digite seu e-mail para recuperar a senha.",
  "auth_error_user_not_found": "Não encontramos uma conta com esse e-mail.",
  "auth_error_reset_failed": "Não conseguimos enviar o e-mail agora. Tente novamente.",
  "auth_safety_badge": "Seguro, direto e sem senha do jogo",
  "auth_headline": "Treine para evoluir, evolua para vencer",
  "auth_subheadline": "Entre, escolha seu jogo e receba ajuda para ajustar sua mira e treinar melhor.",
  "auth_benefits_aria": "Benefícios do Game Pro Hub",
  "auth_benefit_aim": "Corrija sua mira",
  "auth_benefit_training": "Receba treinos simples",
  "auth_benefit_progress": "Acompanhe sua evolução",
  "auth_microcopy": "A Mi te ajuda a entender o que mexer e como treinar.",
  "auth_panel_aria": "Login e cadastro",
  "auth_reset_eyebrow": "Recuperar senha",
  "auth_reset_title": "Vamos te mandar um link",
  "auth_reset_desc": "Digite o e-mail da sua conta para receber as instruções.",
  "auth_sending": "Enviando...",
  "auth_send_link": "Enviar link",
  "auth_email_sent_title": "E-mail enviado",
  "auth_email_sent_desc": "Confira sua caixa de entrada e o spam.",
  "auth_back_to_login": "Voltar para o login",
  "auth_free_account": "Conta grátis",
  "auth_welcome_back": "Bem-vindo de volta",
  "auth_create_free_account": "Criar conta grátis",
  "auth_email_login": "Entrar com e-mail",
  "auth_register_desc": "Comece pelo Google ou use e-mail e senha.",
  "auth_login_desc": "Continue sua evolução no Game Pro Hub.",
  "auth_google": "Entrar com Google",
  "auth_or_email": "ou use e-mail",
  "auth_hide_password": "Ocultar senha",
  "auth_show_password": "Mostrar senha",
  "auth_forgot_password": "Esqueceu a senha?",
  "auth_entering": "Entrando...",
  "auth_switch_aria": "Alternar login e cadastro",
  "auth_create_account_short": "Criar conta",
  "auth_login_short": "Entrar",
  "auth_terms_microcopy": "Ao continuar, você concorda com os termos da plataforma.",
  "auth_trust_note": "Não pedimos senha do jogo nem acesso externo à sua conta.",
  "auth_errors": {
    "auth/email-already-in-use": "Este email já está cadastrado. Faça login.",
    "auth/invalid-email": "Email inválido.",
    "auth/user-not-found": "Usuário não encontrado. Crie uma conta.",
    "auth/wrong-password": "Senha incorreta.",
    "auth/weak-password": "Senha muito fraca. Use no mínimo 6 caracteres.",
    "auth/too-many-requests": "Muitas tentativas. Tente novamente mais tarde.",
    "auth/network-request-failed": "Erro de conexão. Verifique sua internet.",
    "auth/user-disabled": "Conta desativada. Entre em contato com o suporte.",
    "auth/invalid-credential": "Email ou senha incorretos.",
    "auth/operation-not-allowed": "Operação não permitida.",
    "auth/account-exists-with-different-credential": "Este email já está em uso com outro método de login.",
    "default": "Erro ao processar. Tente novamente."
  },
  "hub_welcome": "Bem-vindo,",
  "hub_subtitle": "Sua jornada para o pro",
  "hub_analyses": "Análises",
  "hub_coins": "Acesso Premium",
  "hub_average": "Média",
  "hub_analyze_new": "Analisar Nova Jogada",
  "hub_recharge": "Recarregar Acesso Premium",
  "hub_recent": "Últimas Análises",
  "hub_today": "Hoje",
  "nav_home": "Inicio",
  "nav_hub": "Inicio",
  "nav_coach": "Coach",
  "nav_sensi": "Sensi-IA",
  "nav_sensi_short": "Sensi",
  "nav_tools": "Ferramentas",
  "nav_tools_short": "Ferram.",
  "nav_training": "Treinos",
  "nav_chat": "Chat",
  "nav_history": "Evolução",
  "nav_profile": "Perfil",
  "nav_pricing": "Planos",
  "onboarding_step_game": "Etapa 1 de 3",
  "onboarding_step_problem": "Etapa 2 de 3",
  "onboarding_step_action": "Etapa 3 de 3",
  "onboarding_game_question": "Qual jogo voce quer melhorar?",
  "onboarding_game_subtitle": "A Mi usa isso para abrir a ferramenta certa no primeiro acesso.",
  "onboarding_game_pubg": "FPS Mobile (Alpha)",
  "onboarding_game_freefire": "FPS Mobile (Beta)",
  "onboarding_game_codm": "FPS Mobile (Gamma)",
  "onboarding_problem_question": "Qual seu maior problema hoje?",
  "onboarding_problem_subtitle": "Escolha o sintoma principal. O app vai sugerir o primeiro passo.",
  "onboarding_problem_shaking": "Mira tremendo",
  "onboarding_problem_spray": "Spray subindo",
  "onboarding_problem_sensitivity": "Sensibilidade estranha",
  "onboarding_problem_training": "Nao sei treinar",
  "onboarding_problem_analysis": "Quero analisar minha gameplay",
  "onboarding_action_question": "O que voce quer fazer agora?",
  "onboarding_action_subtitle": "Vamos direto para uma ferramenta de valor, sem te deixar perdido.",
  "onboarding_action_adjust": "Ajustar sensibilidade",
  "onboarding_action_diagnose": "Diagnosticar minha mira",
  "onboarding_action_train": "Treinar mecanica",
  "onboarding_action_analyze": "Analisar gameplay",
  "onboarding_action_guide": "Me guiar",
  "home_guided_title": "Inicio",
  "home_guided_subtitle": "Fale o problema. A Mi indica o proximo passo.",
  "home_next_step_badge": "Proximo passo",
  "home_next_step_title": "Seu proximo passo",
  "home_next_step_desc": "Melhore sua mira comecando pelo ajuste mais importante agora.",
  "home_next_step_cta": "Comecar diagnostico",
  "home_checkpoint_account_created": "Vamos encontrar o melhor caminho para sua mira.",
  "home_checkpoint_first_result": "Voce ja gerou valor",
  "home_first_result_desc": "Continue o ciclo: ajuste, diagnostique, treine e analise.",
  "home_aha_badge": "Aha moment em poucos minutos",
  "home_hero_title": "Plano rapido da Mi.",
  "home_hero_desc": "Diagnostico primeiro. Treino depois. Analise quando precisar.",
  "home_start_free_adjustment": "Comecar meu ajuste gratis",
  "home_continue_evolution": "Continuar minha evolucao",
  "home_mi_guide_title": "O que esta acontecendo com sua mira?",
  "home_mi_guide_subtitle": "Escreva em poucas palavras ou toque em um sintoma.",
  "home_mi_guide_placeholder": "Ex: spray sobe, mira treme, nao sei treinar...",
  "home_mi_guide_cta": "Gerar plano da Mi",
  "home_mi_guide_quick_chips": "Sintomas rapidos",
  "home_chip_aim_rising": "Mira sobe",
  "home_chip_aim_shaking": "Mira treme",
  "home_chip_bad_spray": "Spray ruim",
  "home_chip_training": "Nao sei treinar",
  "home_chip_analysis": "Analisar gameplay",
  "home_mi_plan_title": "Plano da Mi",
  "home_mi_plan_quick_title": "Plano rapido da Mi",
  "home_mi_plan_default": "Comece pela Sensi-IA. Depois valide sua base e treine o ajuste.",
  "home_mi_plan_continue": "Continue pela Sensi-IA. Depois treine o ajuste na Coach.",
  "home_mi_plan_sensitivity": "Crie uma base segura. Depois valide na pratica com a Sensi-IA.",
  "home_mi_plan_training": "Abra um treino recomendado. Depois valide execucao com a Mi Analise.",
  "home_mi_plan_analysis": "Envie gameplay, encontre o ponto fraco e abra um treino recomendado.",
  "home_mi_plan_aim": "Diagnostique a mira primeiro. Se precisar, recalculamos a base depois.",
  "home_quick_tools_title": "Ferramentas rapidas",
  "home_tool_sensi_title": "Sensi-IA",
  "home_tool_sensi_desc": "Descubra o erro da mira.",
  "home_tool_calculator_title": "Calculadora",
  "home_tool_calculator_desc": "Crie uma base segura.",
  "home_tool_coach_title": "Coach",
  "home_tool_coach_desc": "Treine o ponto fraco.",
  "home_tool_analysis_title": "Mi Analise",
  "home_tool_analysis_desc": "Analise gameplay.",
  "home_plan_tool_calculator": "Calculadora",
  "home_plan_short_base": "Criar base",
  "home_plan_short_validate": "Validar ajuste",
  "home_plan_short_train": "Treinar ajuste",
  "home_plan_short_training": "Abrir treino",
  "home_plan_short_analysis": "Validar execucao",
  "home_plan_short_adjust_if_needed": "Ajustar se precisar",
  "home_plan_short_send_video": "Enviar gameplay",
  "home_plan_short_weakness": "Encontrar ponto fraco",
  "home_plan_short_open_training": "Abrir treino",
  "home_plan_short_diagnose": "Diagnosticar",
  "home_plan_short_recalculate": "Recalcular base",
  "home_open_sensi": "Abrir Sensi-IA",
  "home_open_calculator": "Abrir Calculadora",
  "home_open_coach": "Abrir Coach",
  "home_open_analysis": "Abrir Mi Analise",
  "home_cycle_label": "Ciclo Game Pro Hub",
  "home_cycle_adjust": "Ajustar",
  "home_cycle_diagnose": "Diagnosticar",
  "home_cycle_train": "Treinar",
  "home_cycle_analyze": "Analisar",
  "home_intent_title": "O que voce quer melhorar hoje?",
  "home_intent_subtitle": "Uma escolha. Um proximo passo claro.",
  "home_intent_adjust_sensitivity": "Ajustar sensibilidade",
  "home_intent_adjust_sensitivity_desc": "Crie uma base segura para o seu jogo.",
  "home_intent_find_aim_issue": "Descobrir erro da mira",
  "home_intent_find_aim_issue_desc": "Use a Sensi-IA para entender o que mexer.",
  "home_intent_train_mechanics": "Treinar mecanica",
  "home_intent_train_mechanics_desc": "Abra a Coach e siga uma rotina curta.",
  "home_intent_analyze_gameplay": "Analisar gameplay",
  "home_intent_analyze_gameplay_desc": "Envie um video e receba leitura da Mi.",
  "home_intent_guide_me": "Me guiar",
  "home_intent_guide_me_desc": "Comece pelo diagnostico de maior valor.",
  "home_evolution_plan_title": "Seu plano de evolucao",
  "home_evolution_plan_subtitle": "Ajustar -> diagnosticar -> treinar -> analisar -> repetir.",
  "home_plan_step_adjust": "Ajustar sensibilidade",
  "home_plan_tools_calculators": "Calculadora FPS Mobile (Alpha) / FPS Mobile (Beta)",
  "home_plan_step_diagnose": "Diagnosticar sua mira",
  "home_plan_tool_sensi": "Sensi-IA",
  "home_plan_step_train": "Treinar com a Mi Coach",
  "home_plan_tool_coach": "Mi Coach",
  "home_plan_step_analyze": "Analisar sua gameplay",
  "home_plan_tool_mi_analysis": "Mi Analise",
  "home_status_available": "Disponivel",
  "home_status_initial_free": "Inicial gratis",
  "home_status_preview": "Preview gratis",
  "home_status_preview_pro": "Preview gratis / completo no Pro",
  "home_status_pro": "Pro",
  "home_status_pro_active": "Pro ativo",
  "home_status_recommended": "Recomendado",
  "home_status_sensi": "Via Sensi-IA",
  "home_first_value_title": "Primeiro valor",
  "home_first_value_desc": "Receba uma recomendacao util antes de qualquer paywall contextual.",
  "home_pro_strip_title": "Plano completo de evolucao",
  "home_pro_strip_desc": "Voce ja encontra o primeiro ajuste gratis. O Pro libera o ciclo completo: Sensi-IA, Mi Coach e Mi Analise.",
  "home_pro_strip_cta": "Desbloquear Pro",
  "community_cta_title": "Comunidade Game Pro Hub",
  "community_cta_description": "Esta em duvida sobre qual ajuste usar? Entre na comunidade oficial.",
  "community_cta_button": "Entrar",
  "chat_title": "MiraIA • Coach",
  "chat_subtitle": "Consultoria técnica em tempo real",
  "chat_cost": "1 coin por mensagem",
  "chat_placeholder": "Digite sua dúvida tática...",
  "chat_empty_title": "MiraIA • Coach Pronta",
  "chat_empty_subtitle": "Faça perguntas sobre estratégias, mira, posicionamento e mais.",
  "analysis_title": "Análise de Gameplay",
  "analysis_upload_title": "Envie Seu Vídeo",
  "analysis_upload_subtitle": "MP4, MOV, AVI, MKV - até 100MB",
  "analysis_upload_btn": "Selecionar Vídeo",
  "analysis_cost": "Custo: Requer Acesso Premium",
  "analysis_analyzing": "Analisando sua gameplay...",
  "analysis_wait": "A IA • está processando seu vídeo. Isso pode levar alguns minutos.",
  "analysis_start": "Analisar Gameplay",
  "analysis_result_title": "Resultado da Análise",
  "analysis_new": "Nova Análise",
  "analysis_see_details": "Ver detalhes",
  "history_title": "Evolução",
  "history_subtitle": "Reveja sua evolução",
  "history_empty": "Nenhuma análise ainda",
  "history_unknown_date": "Data desconhecida",
  "settings_profile": "Perfil",
  "settings_role_admin": "Administrador",
  "settings_role_user": "Jogador",
  "settings_edit": "Editar",
  "settings_save": "Salvar",
  "settings_cancel": "Cancelar",
  "settings_name": "Nome",
  "settings_photo_url": "URL da foto",
  "settings_change_photo": "Alterar foto",
  "settings_logout": "Sair da Conta",
  "settings_admin_panel": "Painel Admin",
  "settings_admin_subtitle": "Gestão e KPIs",
  "settings_language_section_title": "Idioma do app",
  "settings_language_section_subtitle": "Preferência global de interface e IA",
  "settings_main_game_title": "Jogo Principal",
  "settings_main_game_subtitle": "Define Coach e Sensi ativos",
  "settings_save_game": "Salvar jogo",
  "settings_back_to_hub": "Continuar na Coach",
  "referral_title": "Indique e Ganhe",
  "referral_subtitle": "Ganhe 15% em comissão de cada compra do indicado",
  "referral_subtitle_user": "Ganhe Acesso Premium por cada indicação!",
  "referral_your_link": "Seu link de indicação",
  "referral_share": "Compartilhar Link",
  "referral_referred": "Indicados",
  "referral_earned": "Coins Ganhos",
  "referral_info": "Seu amigo ganha +5 coins extras de boas-vindas. Você ganha 15% de comissão em R$ de cada compra dele.",
  "referral_info_user": "Seu amigo ganha +5 coins extras de boas-vindas. Você ganha 5 Acesso Premium por cada indicação confirmada.",
  "referral_share_text": "Use meu link e ganhe 5 Acesso Premium extras de boas-vindas!",
  "referral_share_now": "COMPARTIR AGORA",
  "pricing_title": "Recarregue Seus Coins",
  "pricing_subtitle": "Créditos para usar a IA • Coach",
  "pricing_coins": "coins",
  "pricing_buy": "Comprar",
  "pricing_popular": "Popular",
  "pricing_best": "Melhor Custo",
  "pricing_processing": "Processando...",
  "pricing_page_title": "Planos e Valores",
  "pricing_page_subtitle": "Escolha o melhor plano para sua jornada pro",
  "pricing_tab_plans": "Planos Mensais",
  "pricing_tab_packages": "Pacotes Avulsos",
  "pricing_subscribe": "Assinar",
  "pricing_current_plan": "Plano Atual",
  "pricing_subscription_info": "Assinatura mensal. Cancele quando quiser. Coins creditados na renovação.",
  "pricing_cancel_sub": "Cancelar Assinatura",
  "pricing_cancel_confirm": "Tem certeza? Você ainda terá acesso até o fim do período.",
  "pricing_cancel_success": "Assinatura será cancelada ao fim do período.",
  "pricing_active_plan": "Plano Ativo",
  "pricing_next_renewal": "Próxima renovação",
  "pricing_access_until": "Acesso até",
  "pricing_status_canceling": "Cancelamento agendado",
  "pricing_manage_sub": "Gerenciar Assinatura",
  "error_credits_title": "Créditos Insuficientes",
  "error_credits_msg": "Você precisa de mais Acesso Premium para usar este recurso.",
  "error_credits_buy": "Comprar Acesso Premium",
  "error_credits_close": "Fechar",
  "error_analysis_title": "Erro na análise",
  "error_retry": "Tentar novamente",
  "error_close": "Fechar",
  "error_upload_video": "Erro ao enviar vídeo",
  "error_analysis_unavailable": "Análise indisponível",
  "admin_title": "Painel Admin",
  "admin_choose": "O que você deseja visualizar?",
  "admin_revenue": "Receita e KPIs",
  "admin_revenue_desc": "Métricas financeiras e de performance",
  "admin_users": "Gerenciar Usuários",
  "admin_users_desc": "Controle de acessos e créditos",
  "admin_back": "Voltar",
  "admin_kpis": "KPIs",
  "admin_total_users": "Total Usuários",
  "admin_total_revenue": "Receita Total",
  "admin_total_analyses": "Total Análises",
  "admin_avg_credits": "Média Créditos",
  "admin_user_list": "Lista de Usuários",
  "admin_search": "Buscar por email...",
  "admin_role": "Role",
  "admin_credits": "Créditos",
  "admin_actions": "Ações",
  "admin_edit": "Editar",
  "admin_add_credits": "Adicionar Créditos",
  "admin_amount": "Quantidade",
  "admin_confirm": "Confirmar",
  "loading_text": "Carregando...",
  "common_game_pro_hub": "GAME PRO HUB",
  "lang_label": "Idioma",
  "language_updated": "Idioma atualizado",
  "language_update_failed": "Falha ao atualizar idioma.",
  "status_label_coach": "Coach",
  "status_label_sensi": "Sensi-IA",
  "status_unknown": "Status indisponível",
  "status_retest_required": "Novo teste recomendado",
  "status_completed": "Concluído",
  "status_processing": "Processando",
  "status_failed": "Falhou",
  "status_pending": "Aguardando",
  "status_insufficient_evidence": "Evidência insuficiente",
  "status_low_confidence": "Baixa confiança",
  "status_done": "Concluído",
  "status_queued": "Na fila",
  "status_uploading": "Enviando",
  "hub_stories_recent": "STORIES RECENTES",
  "hub_stories_subtitle": "Reveja os principais pontos das suas análises.",
  "hub_mi_plan": "PLANO DA MI",
  "hub_last_analysis": "ÚLTIMA ANÁLISE",
  "hub_sensi_status": "STATUS SENSI-IA",
  "hub_training_recommended": "TREINO RECOMENDADO",
  "hub_real_evolution": "EVOLUÇÃO REAL",
  "hub_recent_history": "HISTÓRICO RECENTE",
  "hub_quick_actions": "AÇÕES RÁPIDAS",
  "hub_no_recent_analysis": "Sem análise recente",
  "hub_first_analysis_cta": "Faça sua primeira análise",
  "hub_stories_empty": "Conclua uma análise para gerar stories de desempenho.",
  "hub_plan_priority": "Prioridade atual",
  "hub_plan_next_action": "Próxima ação",
  "hub_plan_reason": "Motivo",
  "hub_no_analysis_yet": "Sem análise ainda",
  "hub_last_activity": "Últimas atividades",
  "hub_summary_fast": "Resumo rápido",
  "hub_metrics_player": "Métricas do jogador",
  "hub_choose_next_step": "Escolha o próximo passo",
  "hub_open_analysis": "Abrir análise",
  "hub_view_all": "Ver tudo",
  "hub_focus": "Foco",
  "hub_why_this_training": "Por que esse treino",
  "hub_confidence": "Confiança",
  "hub_retake_test": "Refazer teste",
  "hub_view_result": "Ver resultado",
  "hub_optimize_sensi": "Otimizar sensi",
  "hub_start_now": "Iniciar agora",
  "hub_no_data_enough": "Sem dados suficientes",
  "hub_trainings_done": "Treinos executados",
  "hub_streak": "Sequência",
  "hub_strongest_point": "Ponto mais forte",
  "hub_weakest_point": "Ponto mais fraco",
  "hub_no_summary_available": "Sem resumo disponível.",
  "hub_no_activity_yet": "Sem atividade recente registrada.",
  "hub_no_detailed_adjustments": "Sem ajustes detalhados",
  "hub_no_analysis_release": "Envie uma análise para liberar diagnóstico e recomendações da Mi.",
  "hub_first_analysis_plan": "Faça sua primeira análise para a Mi montar seu plano.",
  "hub_first_analysis_history": "Assim que você concluir uma análise, o histórico aparece aqui.",
  "hub_analyze_gameplay": "Analisar gameplay",
  "hub_start_training": "Iniciar treino",
  "hub_recharge_coins": "Recarregar Acesso Premium",
  "hub_send_analysis_for_mi": "Envie uma nova análise para receber orientação da Mi.",
  "history_untitled": "Análise sem título",
  "settings_language_saved": "Idioma atualizado.",
  "settings_display_name": "Nome de exibição",
  "settings_display_name_placeholder": "Seu nome no game",
  "settings_profile_updated": "Perfil atualizado!",
  "settings_empty_name": "Nome não pode estar vazio!",
  "settings_connection_error": "Erro de conexão.",
  "settings_max_photo_size": "Máximo 5MB.",
  "settings_main_game_updated": "Jogo principal atualizado!",
  "settings_main_game_failed": "Falha ao atualizar jogo principal.",
  "settings_account_preferences": "Conta e Preferências",
  "settings_account_summary": "Dados da conta",
  "settings_section_account": "Conta",
  "settings_section_subscription": "Assinatura",
  "settings_section_tools": "Ferramentas",
  "settings_section_support": "Suporte",
  "settings_section_configuration": "Configurações",
  "settings_active_subscription": "Assinatura ativa",
  "settings_plan_payment": "Plano e pagamento",
  "settings_premium_status": "Status premium",
  "settings_payment_pending": "Pagamento pendente",
  "settings_next_renewal": "Próxima renovação",
  "settings_processing": "Processando...",
  "settings_become_pro": "Torne-se Pro",
  "settings_renew_pro": "Renovar Pro",
  "settings_plan_free": "Free",
  "settings_plan_free_desc": "Plano gratuito",
  "settings_plan_pro_monthly": "Pro Mensal",
  "settings_plan_pro_annual": "Pro Anual",
  "settings_plan_pro_lifetime": "Apoiador Vitalicio",
  "settings_plan_pro_lifetime_desc": "Voce tem acesso vitalicio aos recursos Pro do Game Pro Hub.",
  "settings_plan_lifetime_status": "Acesso Pro permanente",
  "settings_lifetime_purchase_date": "Compra vitalicia",
  "settings_plan_pro_expired": "Pro expirado",
  "settings_plan_pro_expired_desc": "Seu acesso Pro terminou.",
  "settings_plan_single_payment": "Pagamento único",
  "settings_plan_status_free": "Free",
  "settings_plan_status_expired": "Expirado",
  "settings_logout_short": "Sair",
  "email_verify_title": "Confirme seu e-mail",
  "email_verify_subtitle": "Enviamos um link de ativação para sua conta. Confirme o e-mail para liberar seu acesso ao Game Pro Hub.",
  "email_verify_sent_to": "Link enviado para",
  "email_verify_instruction": "Abra sua caixa de entrada e clique no link de confirmação. Se não encontrar, verifique também o spam ou lixo eletrônico.",
  "email_verify_cta": "Já confirmei meu e-mail",
  "email_verify_resend": "Reenviar link",
  "email_verify_resent": "Link reenviado. Confira sua caixa de entrada.",
  "email_verify_back_login": "Voltar ao login",
  "terms_title": "Términos legales",
  "terms_subtitle": "Protocolo de privacidad y seguridad",
  "terms_user_terms": "Términos de uso",
  "terms_privacy": "Privacidad",
  "terms_not_loaded": "Términos no cargados.",
  "terms_scroll_bottom": "Desplázate hasta el final",
  "terms_acceptance_text": "He leído y acepto íntegramente los Términos de Uso y la Política de Privacidad.",
  "terms_accept_continue": "Aceptar y continuar",
  "terms_syncing": "Sincronizando términos...",
  "terms_accept_error": "Error al aceptar los términos.",
  "app_payment_confirmed": "Sucesso! O pagamento foi confirmado e seu acesso está liberado.",
  "app_payment_processing": "Pagamento em processamento. O acesso será liberado assim que concluído pelo Stripe.",
  "app_payment_received": "Pagamento recebido! Seu acesso será sincronizado em instantes.",
  "app_payment_error": "Erro ao processar pagamento.",
  "app_subscription_error": "Erro ao processar assinatura.",
  "app_privileged_no_charge": "Conta ADM/PARCEIRO com acesso total gratuito. Nenhuma cobrança é necessária.",
  "app_privileged_no_subscription": "Conta ADM/PARCEIRO com acesso total gratuito. Nenhuma assinatura é necessária.",
  "app_privileged_calculator_unlocked": "Conta ADM/PARCEIRO com acesso total gratuito. A calculadora já está liberada.",
  "app_privileged_no_purchase": "Conta ADM/PARCEIRO com acesso total gratuito. Nenhuma compra é necessária.",
  "app_pubg_lifetime_error": "Erro ao iniciar compra da Calculadora vitalícia.",
  "app_freefire_lifetime_error": "Erro ao iniciar compra da Calculadora FPS Mobile (Beta) vitalícia.",
  "checkout_error_open": "Nao foi possivel abrir o checkout agora. Tente novamente.",
  "checkout_error_unavailable_product": "Este produto nao esta disponivel no momento.",
  "checkout_error_connection": "Falha de conexao. Verifique sua internet e tente novamente.",
  "app_video_too_large": "Vídeo muito grande! O limite é de 200MB (aprox. 2 min).",
  "app_premium_required": "Acesso premium necessário para continuar.",
  "app_view_plans": "Ver planos",
  "app_pubg_calc_title": "Calculadora FPS Mobile (Alpha)",
  "app_pubg_calc_subtitle": "Pro: 15 usos mensais. Vitalício: uso ilimitado.",
  "app_freefire_calc_title": "Calculadora FPS Mobile (Beta)",
  "app_freefire_calc_subtitle": "Pro: 5 usos mensais. Vitalício: uso ilimitado.",
  "app_back": "Voltar",
  "app_analysis_starting": "Iniciando protocolos de análise...",
  "app_file_too_large_title": "Arquivo muito grande",
  "app_coach_video_limit_message": "O limite para vídeos na Mi Coach é de {{maxMb}}MB para garantir o processamento da IA. Reduza ou comprima o vídeo.",
  "app_mi_analysis_title": "Mi Análise",
  "app_mi_analysis_ready": "Mi Análise pronta",
  "app_syncing_mi": "Sincronizando com a Mi...",
  "app_insufficient_balance": "Saldo insuficiente.",
  "app_email_not_verified_title": "E-mail não verificado",
  "app_email_not_verified_coach": "Verifique seu e-mail antes de usar a Coach.",
  "app_coach_pro_required_message": "Essa análise precisa de **Acesso Pro** para rodar.\n\n{{costMsg}}\n\nEla mostra exatamente onde você precisa melhorar.",
  "app_coach_credit_required_message": "Essa análise custa **{{cost}} Acesso Pro**.\n\nSeu saldo atual: **{{credits}} Acesso Pro**.\n\nAdquira mais Acesso Pro para continuar.",
  "app_coach_credit_error_message": "Essa análise custa **{{cost}} Acesso Pro**.\n\n{{error}}\n\nAdquira mais Acesso Pro para continuar.",
  "app_analysis_background_sync": "A análise continua em segundo plano. Você pode manter a tela aberta.",
  "app_analysis_in_progress_reason": "Análise em andamento ({{reason}})...",
  "app_analysis_monitor_fallback": "Monitor em fallback: sincronizando status da análise...",
  "app_analysis_processing_failed": "Falha no processamento da análise.",
  "app_analyzing": "Analisando...",
  "app_connection_restored_analysis": "Conexão retomada. Reconectando análise...",
  "app_connection_restored_sensi": "Conexão retomada. Reconectando monitor da sensi...",
  "app_critical_error_detected": "Detectado erro crítico.",
  "app_job_syncing": "Sincronizando status...",
  "app_mi_context_alert": "ALERTA",
  "app_mi_context_analyzed": "ANALISADO",
  "app_mi_context_coach": "ANÁLISE VÍDEO",
  "app_mi_context_hub": "HUB CENTRAL",
  "app_mi_context_tools": "FERRAMENTAS",
  "app_mi_context_os": "MI OS",
  "app_mi_context_processing": "PROCESSANDO",
  "app_mi_context_profile": "CONFIGURAÇÕES",
  "app_mi_context_sensi": "OTIMIZADOR",
  "app_mi_context_syncing": "SINCRONIZANDO",
  "app_mi_context_system": "SISTEMA OPERACIONAL",
  "app_mi_context_training": "MÓDULO TREINO",
  "app_mi_msg_coach": "Pronta para revisar sua partida.",
  "app_mi_msg_hub": "Monitorando seu desempenho...",
  "app_mi_msg_tools": "Escolha uma ferramenta para o proximo passo.",
  "app_mi_msg_profile": "Gerenciando protocolos de conta.",
  "app_mi_msg_sensi": "Calibrando padrões balísticos...",
  "app_mi_msg_training": "Qual o foco da rotina hoje?",
  "app_mi_syncing": "Mi sincronizando...",
  "app_mi_waiting_for_you": "Mi te esperando.",
  "app_privileged_retry": "Acesso privilegiado detectado. Tente novamente.",
  "app_realtime_monitor_permission_fallback": "Permissão do monitor em tempo real falhou. Usando sincronização segura por polling.",
  "app_realtime_monitor_polling_fallback": "Monitor em tempo real indisponível. Sincronizando por polling.",
  "app_reconnecting_after_return": "Reconectando após retorno ao app...",
  "app_reconnecting_analysis_count": "Reconectando análise... tentativa {{count}}",
  "app_reconnecting_analysis_monitor": "Reconectando monitor de análise...",
  "app_reconnecting_sensi_after_return": "Reconectando sensi após retorno ao app...",
  "app_reconnecting_sensi_count": "Reconectando sensi... tentativa {{count}}",
  "app_reconnecting_sensi_monitor": "Reconectando monitor de sensi...",
  "app_sensi_background_sync": "A Sensi-IA continua em segundo plano. Mantenha a tela aberta para sincronizar.",
  "app_sensi_ballistic_start": "Iniciando calibração balística...",
  "app_sensi_diagnose_failed": "Não foi possível gerar o diagnóstico agora.",
  "app_sensi_diagnosis_ready": "Diagnóstico da Sensi-IA pronto.",
  "app_sensi_duplicate_processing": "Análise de sensi já em processamento.",
  "app_sensi_in_progress_reason": "Sensi em andamento ({{reason}})...",
  "app_sensi_monitor_unavailable": "Monitor de sensi indisponível.",
  "app_sensi_processing_failed": "Falha no processamento da sensi.",
  "app_sensi_reading_report": "A Mi está lendo seu relato...",
  "app_sensi_refinement_ready": "Refinamento pronto.",
  "app_sensi_report_failed": "Não foi possível concluir a análise por relato.",
  "app_sensi_select_video_or_no_video": "Selecione um vídeo ou continue sem vídeo.",
  "app_sensi_status_syncing": "Sincronizando status da Sensi-IA...",
  "app_sensi_video_limit_message": "O limite para vídeos da Sensi-IA é de {{maxMb}}MB para manter o processamento estável.",
  "app_sensi_video_received_validation": "Vídeo recebido. Validando e enviando para análise...",
  "app_syncing": "Sincronizando...",
  "app_terms_acceptance_failed": "Falha ao registrar aceitação dos termos ({{status}}).",
  "app_user_not_authenticated": "Usuário não autenticado.",
  "chat_connection_error_markdown": "Tive um problema de conexão agora. Tente novamente em alguns segundos.",
  "chat_connection_error_short": "Erro de conexão.",
  "chat_connection_retry": "Conexão instável. Tente novamente em alguns segundos.",
  "chat_network_error": "Erro de rede. Verifique sua conexão.",
  "chat_temporary_issue": "Sinto muito, tive um problema temporário. Tente novamente.",
  "local_terms_privacy_content": "# Política de Privacidade – Game Pro Hub\n\nÚltima atualização: 01/04/2026\n\nEsta política explica como tratamos seus dados pessoais para operar o Game Pro Hub.\n\n## 1. Dados coletados\n* Nome e e-mail via Firebase Auth.\n* Informações de pagamento processadas pelo Stripe. Não armazenamos dados de cartão.\n* Vídeos e dados de gameplay enviados para análise da Mi.\n* Histórico de treinos, análises e evolução.\n\n## 2. Finalidade\nUsamos os dados para personalizar recomendações, processar pagamentos, liberar acesso e gerar relatórios de evolução.\n\n## 3. Compartilhamento\nNão vendemos seus dados. Compartilhamos apenas com provedores essenciais como Google Cloud/Firebase, Stripe e serviços de IA usados no processamento.\n\n## 4. Seus direitos\nVocê pode solicitar acesso, correção, anonimização ou exclusão dos seus dados, conforme a legislação aplicável.\n\n## 5. Segurança\nUsamos conexão segura, controles de acesso e práticas de proteção para reduzir riscos de uso indevido.",
  "local_terms_privacy_title": "Política de Privacidade",
  "local_terms_user_content": "# Termos de Uso – Game Pro Hub\n\nÚltima atualização: 01/04/2026\n\nAo usar o Game Pro Hub, você declara que leu e concorda com estes termos.\n\n## 1. Objeto\nA plataforma oferece calculadoras, treinos, análises e recomendações para melhorar desempenho em jogos como FPS Mobile (Alpha), FPS Mobile (Beta) e FPS Mobile (Gamma).\n\n## 2. Conta\nVocê é responsável pelas informações fornecidas e pela segurança da sua conta. Não é permitido compartilhar acesso ou criar contas para abuso.\n\n## 3. Pagamentos\nAssinaturas e compras são processadas pelo Stripe. Cancelamentos interrompem cobranças futuras conforme as regras do plano contratado.\n\n## 4. Conduta\nÉ proibido tentar burlar sistemas, explorar falhas, copiar conteúdo sem autorização ou usar a plataforma de forma abusiva.\n\n## 5. Propriedade intelectual\nConteúdos, fluxos, métodos e materiais do Game Pro Hub pertencem à plataforma ou aos seus licenciadores.\n\n## 6. Privacidade\nSeus dados são tratados conforme a política de privacidade e a legislação aplicável.\n\n## 7. Aceite\nO uso continuado da plataforma confirma sua aceitação destes termos.",
  "local_terms_user_title": "Termos de Uso",
  "sensi_free_limit_message": "Você usou suas análises grátis da Sensi-IA. Assine o Pro para continuar.",
  "sensi_feedback_save_retry": "Não foi possível salvar seu feedback agora. Tente novamente.",
  "sensi_refine_retry": "Não foi possível gerar o próximo ajuste agora. Tente novamente.",
  "sensi_select_video_to_continue": "Selecione um vídeo para continuar.",
  "sensi_selected_problems": "Problemas selecionados",
  "sensi_unsupported_video_format": "Formato não compatível. Envie um MP4, MOV de iPhone ou WebM.",
  "sensi_values_summary": "Resumo dos valores",
  "pricing_access": "Acesso",
  "pricing_auto_unlock": "Liberação automática após confirmação",
  "pricing_benefits_summary": "Resumo dos benefícios",
  "pricing_buy_now": "Comprar agora",
  "pricing_clear_price": "Preço claro, sem surpresa",
  "pricing_clear_cost_short": "Preço claro",
  "pricing_coin_rate_suffix": "{{value}} coin/val",
  "pricing_fast_activation": "Ativação rápida",
  "pricing_freefire_lifetime_fallback_title": "Calculadora FPS Mobile (Beta) vitalícia",
  "pricing_full_access": "Acesso completo",
  "pricing_full_ai_calculator_access": "Acesso total a IA e Calculadora",
  "pricing_gph_access": "Acesso Game Pro Hub",
  "pricing_gph_plans": "Planos Game Pro Hub",
  "pricing_no_plan_available": "Nenhum plano disponível no momento.",
  "pricing_one_time_payment": "Pagamento único",
  "pricing_one_time_purchase": "Compra avulsa",
  "pricing_per_month_short": "/mês",
  "pricing_plans_access": "Planos e acesso",
  "pricing_pro_access": "Acesso Pro",
  "pricing_pro_subscription": "Assinatura Pro",
  "pricing_pubg_lifetime_fallback_title": "Calculadora FPS Mobile (Alpha) vitalícia",
  "pricing_purchase_assurances": "Garantias da compra",
  "pricing_secure_checkout": "Checkout seguro",
  "pricing_secure_stripe": "Pagamento seguro via Stripe",
  "pricing_product_unavailable": "Indisponivel no momento",
  "pricing_amount_loading": "Carregando preco...",
  "pricing_amount_unavailable_retry": "Preco indisponivel no momento. Tente novamente.",
  "pricing_catalog_error_notice": "Preco indisponivel no momento. Tente novamente.",
  "pricing_value_description": "Assinatura Pro ou Calculadora FPS Mobile (Alpha) vitalícia em compra única.",
  "pricing_subscribe_pro": "Assinar Pro",
  "pricing_equivalent_monthly": "Equivale a {{value}}.",
  "sensi_access": "Acesso",
  "sensi_access_blocked": "Acesso bloqueado",
  "sensi_access_pro_released": "Uso Pro liberado",
  "sensi_action_increase": "Aumente",
  "sensi_action_increase_infinitive": "Aumentar",
  "sensi_action_reduce": "Reduza",
  "sensi_action_reduce_infinitive": "Reduzir",
  "sensi_adjustment_count": "{{count}} ajustes",
  "sensi_aim_question": "O que está errado com sua mira?",
  "sensi_aim_question_desc": "Marque o que você sente durante a mira ou o spray.",
  "sensi_aim_report": "Relato da mira",
  "sensi_already_processing": "Análise de sensi já em processamento.",
  "sensi_analysis_slow_notice": "Se demorar mais que o normal, mantenha esta tela aberta. A Mi continua processando.",
  "sensi_analysis_stopped": "Análise parada",
  "sensi_analysis_stopped_desc": "Não conseguimos concluir a análise agora.",
  "sensi_analyze": "Analisar",
  "sensi_analyzing_sensitivity": "Analisando sua sensibilidade",
  "sensi_analyzing_sensitivity_desc": "A Mi está lendo seu relato e preparando um ajuste seguro.",
  "sensi_apply_only_this_adjustment": "Aplique apenas este ajuste antes de testar novamente.",
  "sensi_attached": "Anexado",
  "sensi_calibration_success": "Sua calibração foi concluída com sucesso.",
  "sensi_change_sentence": "{{action}} {{field}} em {{points}} pontos.",
  "sensi_confidence_label": "Confiança {{label}}",
  "sensi_confidence_plain": "Confiança",
  "sensi_context_desc": "Detalhes sobre sua gameplay e o cenário do teste.",
  "sensi_context_title": "Contexto do teste",
  "sensi_continue": "Continuar",
  "sensi_continue_without_video": "Continuar sem vídeo",
  "sensi_continue_without_video_desc": "A Mi usa seu relato para gerar um ajuste seguro.",
  "sensi_control_gyro": "Giroscópio",
  "sensi_control_method": "Método de controle",
  "sensi_control_touch": "Dedo",
  "sensi_copy_adjust": "{{label}}: {{action}}",
  "sensi_copy_adjust_with_values": "{{label}}: {{action}} ({{current}} -> {{target}})",
  "sensi_copy_increase_points": "aumentar {{points}} pontos",
  "sensi_copy_insufficient_evidence": "{{label}}: sem evidência suficiente",
  "sensi_copy_keep_almost_same_values": "{{label}}: manter quase igual ({{current}} -> {{target}})",
  "sensi_copy_keep_as_is": "{{label}}: manter como está",
  "sensi_copy_reduce_points": "reduzir {{points}} pontos",
  "sensi_current_values": "Valores atuais",
  "sensi_current_values_desc": "Preencha os campos que deseja calibrar.",
  "sensi_diagnose": "Diagnosticar",
  "sensi_diagnosis_summary_default": "A Mi encontrou um padrão de mira para testar com segurança.",
  "sensi_diagnosis_title": "Diagnóstico da Sensi-IA",
  "sensi_do_not_close": "Não feche esta tela durante a análise.",
  "sensi_duration": "Duração",
  "sensi_duration_5_10": "5 a 10 minutos",
  "sensi_expected_coverage": "O que o vídeo deve mostrar",
  "sensi_expected_coverage_desc": "Mostre a mira, o spray e a distância do teste para aumentar a precisão.",
  "sensi_feedback_heavy": "Ficou pesada",
  "sensi_feedback_improved": "Melhorou",
  "sensi_feedback_slow": "Ficou lenta",
  "sensi_feedback_msg_improved": "Boa. Mantenha esse ajuste e faça mais um treino antes de mudar qualquer coisa.",
  "sensi_feedback_msg_same": "Beleza. Esse retorno ajuda a Mi a escolher o próximo passo.",
  "sensi_feedback_msg_worse": "Entendi. Não mexa em mais nada agora. A Mi vai usar isso no próximo ajuste.",
  "sensi_feedback_notes_placeholder": "Opcional: conte o que você sentiu depois do treino...",
  "sensi_feedback_now_drops": "Agora desce",
  "sensi_feedback_overshoots": "Passa do alvo",
  "sensi_feedback_question": "Depois do treino, como ficou sua mira?",
  "sensi_feedback_same": "Ficou igual",
  "sensi_feedback_saving": "Salvando...",
  "sensi_feedback_shakes": "Treme",
  "sensi_feedback_shakes_strong": "Treme muito",
  "sensi_feedback_still_rises": "Ainda sobe",
  "sensi_feedback_worse": "Piorou",
  "sensi_final_review": "Revisão final",
  "sensi_fine_tune_active": "Ajuste fino ativo",
  "sensi_fine_tune_extra_weight": "A Mi vai dar mais peso a esse retorno.",
  "sensi_fine_tune_good": "Perfeito, ficou boa!",
  "sensi_fine_tune_good_value": "Ficou boa",
  "sensi_finish_failed": "Não foi possível concluir a análise.",
  "sensi_flow_intro_item_scope_swap": "Use o mesmo scope do problema",
  "sensi_flow_intro_item_target": "Teste em alvo fixo",
  "sensi_flow_intro_item_video": "Vídeo é opcional",
  "sensi_flow_intro_item_wall": "Relate o sintoma principal",
  "sensi_flow_intro_title": "Ajuste sua mira com a Mi",
  "sensi_focus_label": "Foco",
  "sensi_follow_protocol_before_recalibrate": "Siga este protocolo no jogo antes de recalibrar.",
  "sensi_free_limit_desc": "Você atingiu o limite grátis da Sensi-IA neste mês.",
  "sensi_free_limit_title": "Limite grátis atingido",
  "sensi_free_remaining": "{{remaining}}/{{limit}} grátis",
  "sensi_free_remaining_verbose": "{{remaining}} de {{limit}} análises grátis disponíveis",
  "sensi_game_question": "Qual jogo você quer ajustar?",
  "sensi_game_question_desc": "Escolha o jogo para a Mi montar o contexto certo.",
  "sensi_generate_next_adjustment": "Gerar próximo ajuste da Mi",
  "sensi_generating_next_adjustment": "Gerando próximo ajuste...",
  "sensi_generic_sensitivity": "sensibilidade",
  "sensi_goal_desc": "Escolha o foco para a recomendação ficar mais precisa.",
  "sensi_goal_title": "Qual é o objetivo do ajuste?",
  "sensi_guided_flow": "Fluxo guiado MiraIA",
  "sensi_high_confidence": "Alta confiança",
  "sensi_how_to_calibrate_aim": "Como calibrar sua mira",
  "sensi_how_to_test": "Como testar",
  "sensi_initial_card_1_desc": "Conte o que acontece com a mira.",
  "sensi_initial_card_1_title": "Relate o problema",
  "sensi_initial_card_2_desc": "Informe arma, scope, distância e valores atuais.",
  "sensi_initial_card_2_title": "Passe o contexto",
  "sensi_initial_card_3_desc": "Receba um ajuste conservador e um treino prático.",
  "sensi_initial_card_3_title": "Teste com segurança",
  "sensi_initial_subtitle": "Ajuste de sensibilidade por relato ou vídeo",
  "sensi_initial_title_prefix": "Protocolo",
  "sensi_insufficient_evidence": "sem evidência suficiente",
  "sensi_jitter_stability": "Trepidação / estabilidade",
  "sensi_keep_current_adjustment": "Mantenha o ajuste atual.",
  "sensi_keep_other_sensitivities": "Não altere outras sensibilidades neste ciclo.",
  "sensi_keep_reason": "Isso evita mexer em muitos valores ao mesmo tempo.",
  "sensi_keep_specific_fields": "Não altere {{fields}} neste ciclo.",
  "sensi_legacy_all_good_desc": "A análise não encontrou erros grosseiros. Recomendamos manter os valores atuais e refinar em treino.",
  "sensi_legacy_all_good_title": "Tudo certo na base",
  "sensi_legacy_conservative_desc": "Não conseguimos dados perfeitos no vídeo. A Mi recomendou uma base segura para você começar.",
  "sensi_legacy_conservative_title": "Ajuste conservador",
  "sensi_legacy_feedback_desc": "Isso vai preparar a Mi para a próxima calibração.",
  "sensi_legacy_feedback_title": "Testou? O que achou?",
  "sensi_legacy_increase_scope": "Aumente {{points}} pontos nesta mira para reduzir atraso na aquisição do alvo.",
  "sensi_legacy_micro_adjustment": "Microajuste fino. Aplique e valide com uma sequência curta de confirmação.",
  "sensi_legacy_reduce_scope": "Reduza {{points}} pontos nesta mira para controlar excesso e melhorar estabilidade.",
  "sensi_legacy_result_desc": "A Mi analisou seu perfil e gerou uma recomendação precisa baseada nos seus movimentos em combate.",
  "sensi_legacy_result_title": "Sua sensi foi ajustada",
  "sensi_legacy_retest_hint": "Refaça este teste com spray dedicado e sem cortes para calibrar com segurança.",
  "sensi_legacy_stability_desc": "Houve muita trepidação e excesso de correção. Isso indica sensibilidade um pouco alta para o seu controle motor atual.",
  "sensi_legacy_stability_title": "Falta de estabilidade com {{scope}}",
  "sensi_legacy_tracking_delay_desc": "Sua mira demorou para acompanhar o alvo. Isso geralmente indica sensibilidade baixa, forçando você a arrastar demais o dedo/gyro.",
  "sensi_legacy_tracking_delay_title": "Atraso na aquisição de alvo com {{scope}}",
  "sensi_location": "Local",
  "sensi_marked_count": "{{count}} marcados",
  "sensi_mi_diagnosis": "Diagnóstico da Mi",
  "sensi_missing": "Pendente",
  "sensi_new_training": "Novo treino",
  "sensi_next_question_default": "Depois de testar, diga se melhorou, piorou ou ficou igual.",
  "sensi_no_numeric_values": "Nenhum valor numérico foi preenchido.",
  "sensi_no_video": "Sem vídeo",
  "sensi_not_informed": "Não informado",
  "sensi_number_placeholder": "Ex: 50",
  "sensi_objectives": "Objetivos",
  "sensi_observe_prefix": "Observe",
  "sensi_opencv_tracking_confidence": "Confiança do rastreio OpenCV:",
  "sensi_optional_placeholder": "Opcional",
  "sensi_other_sensitivity_values": "outras sensibilidades",
  "sensi_points_label": "{{points}} pontos",
  "sensi_pubg_diagnosis": "Diagnóstico FPS Mobile (Alpha)",
  "sensi_pubg_precision_mode": "Modo de precisão FPS Mobile (Alpha)",
  "sensi_pubg_precision_desc": "A Mi cruzou vídeo, arma, scope, distância e seu modo de controle.",
  "sensi_pull_precision": "Precisão da puxada",
  "sensi_recalibrate_now": "Recalibrar agora",
  "sensi_recording_protocol": "Protocolo de gravação",
  "sensi_redo_diagnosis": "Refazer diagnóstico",
  "sensi_increased": "Aumentou",
  "sensi_reduced": "Reduziu",
  "sensi_refinement_hero_desc": "A Mi usou seu feedback para montar o próximo ajuste seguro.",
  "sensi_report_hero_desc": "A Mi analisou seu relato e montou um ajuste seguro para testar agora.",
  "sensi_report_only_mode": "Modo sem vídeo",
  "sensi_report_only_mode_desc": "A análise vai seguir apenas com seu relato. Você pode voltar e mandar vídeo se quiser.",
  "sensi_return_later": "Depois volte",
  "sensi_review": "Revisar",
  "sensi_save_and_copy_all": "Salvar e copiar tudo",
  "sensi_saved_and_copied": "Salvo e copiado",
  "sensi_screen_subtitle": "Ajuste de sensibilidade por relato ou vídeo",
  "sensi_send_video": "Mandar vídeo para ajudar a Mi",
  "sensi_send_video_desc": "O vídeo entra como evidência extra para aumentar a precisão.",
  "sensi_start_calibration": "Começar calibração",
  "sensi_step_counter": "Etapa {{current}} de {{total}}",
  "sensi_step_game": "Jogo",
  "sensi_step_game_subtitle": "Escolha o jogo para calibrar",
  "sensi_step_goal": "Relato",
  "sensi_step_goal_subtitle": "Conte o que acontece com sua mira",
  "sensi_step_context": "Contexto",
  "sensi_step_context_subtitle": "Informe arma, scope e distância",
  "sensi_step_values": "Valores",
  "sensi_step_values_subtitle": "Passe suas sensibilidades atuais",
  "sensi_step_video_optional": "Vídeo opcional",
  "sensi_step_video_optional_subtitle": "Escolha analisar com ou sem vídeo",
  "sensi_step_review": "Revisão",
  "sensi_step_review_subtitle": "Confirme tudo antes da análise",
  "sensi_step_prefix": "Etapa {{step}}: {{title}}",
  "sensi_success_criterion": "Critério de sucesso",
  "sensi_success_criterion_desc": "Faça 10 sprays longos (40m a 60m). A configuração está calibrada se pelo menos 7 sprays concentrarem a maioria dos tiros no tronco do alvo.",
  "sensi_symptom_aim_drops": "Minha mira desce",
  "sensi_symptom_aim_rises": "Minha mira sobe",
  "sensi_symptom_aim_shakes": "Minha mira treme",
  "sensi_symptom_cannot_track_enemy": "Minha mira não acompanha o inimigo",
  "sensi_symptom_close_range_difficulty": "Erro de perto",
  "sensi_symptom_first_bullets_miss": "Erro nas primeiras balas",
  "sensi_symptom_gyro_difficulty": "Dificuldade com gyro",
  "sensi_symptom_long_range_difficulty": "Erro de longe",
  "sensi_symptom_mid_range_difficulty": "Erro em média distância",
  "sensi_symptom_mid_spray_lost": "Perco o controle no meio do spray",
  "sensi_symptom_no_gyro_difficulty": "Não uso gyro",
  "sensi_symptom_overshoots_target": "Minha mira passa do inimigo",
  "sensi_symptom_placeholder": "Ex: minha mira sobe depois das primeiras balas...",
  "sensi_symptom_spray_opens_horizontal": "Meu spray abre para os lados",
  "sensi_symptom_spray_opens_vertical": "Meu spray abre para cima/baixo",
  "sensi_tab_analysis": "Sensi-IA",
  "sensi_tab_analysis_desc": "Diagnóstico",
  "sensi_tab_pubg_calc": "FPS Mobile (Alpha)",
  "sensi_tab_pubg_calc_desc": "Calculadora",
  "sensi_tap_to_attach_video": "Toque para anexar vídeo",
  "sensi_technical_reason": "Justificativa técnica",
  "sensi_test_and_return_later": "Testar e voltar depois",
  "sensi_test_before_change": "Teste antes de mexer",
  "sensi_test_same_scenario": "Teste em treino ou arena mantendo o mesmo cenário do relato.",
  "sensi_test_weapon": "Arma em teste",
  "sensi_today_training": "Treino de hoje",
  "sensi_tracking_label": "Rastreio",
  "sensi_training_mode": "Modo Treino",
  "sensi_training_step_note": "Anote se a mira subiu, desceu, tremeu ou ficou estável.",
  "sensi_training_step_only_adjustment": "Aplique somente o ajuste recomendado.",
  "sensi_training_step_reps": "Faça 10 repetições controladas.",
  "sensi_training_step_same_scope": "Use o mesmo scope e a mesma distância do teste.",
  "sensi_tutorial_start": "Entendido, vamos começar",
  "sensi_tutorial_step_keep_center": "Tente manter a mira fixa no centro do alvo.",
  "sensi_tutorial_step_no_edits": "Evite cortes ou edições no vídeo original.",
  "sensi_tutorial_step_red_dot": "Realize um spray de 30 tiros com Red Dot.",
  "sensi_tutorial_step_scopes": "Repita o spray com mira 2x, 3x, 4x e 6x.",
  "sensi_tutorial_step_weapon": "Arme-se com sua arma favorita no modo treino.",
  "sensi_validation_test": "Teste de validação",
  "sensi_validation_training": "Treino de validação",
  "sensi_vertical_recoil": "Recuo vertical",
  "sensi_video": "Vídeo",
  "sensi_video_confirmed_title": "O que o vídeo ajudou a confirmar",
  "sensi_video_effect_default": "O vídeo foi usado como apoio para ajustar a confiança da análise.",
  "sensi_video_failed_continued": "O vídeo falhou, mas a análise continuou pelo relato",
  "sensi_video_fallback": "Vídeo em fallback",
  "sensi_video_hero_desc": "A Mi analisou seu relato com o vídeo como apoio para aumentar a precisão.",
  "sensi_video_physical_measurement": "Medição física do vídeo",
  "sensi_video_question": "Quer mandar um vídeo?",
  "sensi_video_question_desc": "Não precisa. Mas se você mandar, a Mi entende melhor sua mira.",
  "sensi_video_selected": "Vídeo selecionado",
  "sensi_video_support": "Vídeo usado como apoio",
  "sensi_waiting_evidence": "Aguardando evidência",
  "sensi_weapon_placeholder": "Ex: M416",
  "sensi_what_change": "O que mexer",
  "sensi_what_change_now": "O que mexer agora",
  "sensi_what_changed": "O que mudou",
  "sensi_what_keep": "O que não mexer agora",
  "sensi_what_mi_saw": "O que a Mi percebeu",
  "sensi_what_mi_saw_now": "O que a Mi percebeu agora",
  "sensi_processing_received": "Relato recebido",
  "sensi_processing_received_desc": "A Mi está organizando seu contexto de mira.",
  "sensi_processing_validated": "Dados validados",
  "sensi_processing_validated_desc": "Conferindo jogo, arma, scope e valores atuais.",
  "sensi_processing_signals": "Sinais da mira",
  "sensi_processing_signals_desc": "Identificando o sintoma principal e o canal correto.",
  "sensi_processing_stability": "Segurança do ajuste",
  "sensi_processing_stability_desc": "Limitando a recomendação para não mexer em valores demais.",
  "sensi_processing_recommendation": "Treino e ajuste",
  "sensi_processing_recommendation_desc": "Montando o ajuste e o treino de hoje.",
  "sensi_processing_finalizing": "Finalizando",
  "sensi_processing_finalizing_desc": "Preparando seu diagnóstico.",
  "sensi_diag_vertical_under": "Sua mira está subindo durante o spray.",
  "sensi_diag_vertical_over": "Sua mira está descendo durante o spray.",
  "sensi_diag_instability": "Sua mira está tremendo ou instável.",
  "sensi_diag_overshoot": "Sua mira está passando do alvo.",
  "sensi_diag_tracking_lag": "Sua mira não acompanha o inimigo.",
  "sensi_diag_vertical_spread": "Seu spray está abrindo na vertical.",
  "sensi_diag_horizontal_issue": "Seu spray está abrindo para os lados.",
  "sensi_diag_first_bullets": "O erro aparece nas primeiras balas.",
  "sensi_diag_mid_spray": "Você perde o controle no meio do spray.",
  "sensi_diag_close_range": "A dificuldade aparece de perto.",
  "sensi_diag_mid_range": "A dificuldade aparece em média distância.",
  "sensi_diag_long_range": "A dificuldade aparece de longe.",
  "sensi_diag_gyro_mismatch": "O controle com gyro precisa de ajuste fino.",
  "sensi_diag_no_gyro": "O controle sem gyro precisa de uma base mais estável.",
  "sensi_diag_improved_keep": "O ajuste melhorou sua mira.",
  "sensi_diag_still_rising": "A mira ainda está subindo.",
  "sensi_diag_now_drops": "A mira começou a descer.",
  "sensi_diag_after_shakes": "A mira começou a tremer.",
  "sensi_diag_too_heavy": "A mira ficou pesada.",
  "sensi_diag_after_overshoot": "A mira passou do alvo depois do ajuste.",
  "sensi_diag_same_symptom": "O sintoma continuou igual.",
  "sensi_diag_worsened": "O ajuste anterior piorou o controle.",
  "sensi_diag_default": "A Mi encontrou um padrão para testar com segurança.",
  "sensi_evidence_strong": "evidência forte",
  "sensi_evidence_moderate": "evidência moderada",
  "sensi_evidence_limited": "evidência limitada",
  "sensi_retest_recommended": "novo teste recomendado",
  "sensi_limited_evidence_estimate": "estimativa com evidência limitada",
  "sensi_precise_calibration": "calibração precisa",
  "sensi_no_data": "sem dados",
  "sensi_no_evidence": "sem evidência",
  "sensi_overflick_detected": "excesso de flick detectado",
  "sensi_retest_hint_label": "dica de reteste",
  "sensi_spray_segments_detected": "segmentos de spray detectados",
  "sensi_insufficient_scope_metrics": "métricas insuficientes para esta mira",
  "sensi_missing_scope_adjustment": "sem dados de ajuste para esta mira",
  "sensi_scope_not_detected_video": "esta mira não foi identificada no vídeo",
  "sensi_few_spray_moments": "poucos momentos de disparo detectados",
  "sensi_reliable_evidence": "evidência confiável",
  "sensi_helper_pubg_camera_no_scope": "Velocidade da câmera sem ADS. Afeta pré-mira e entrada no alvo.",
  "sensi_helper_pubg_red_dot": "Controle principal para combate curto e médio com Red Dot/Holo.",
  "sensi_helper_pubg_scope2x": "Ajusta tracking e recoil em média distância com 2x.",
  "sensi_helper_pubg_scope3x": "Importante para sprays em média distância e controle lateral.",
  "sensi_helper_pubg_scope4x": "Sensibilidade crítica para sprays longos e estabilidade do recuo.",
  "sensi_helper_pubg_scope6x": "Use valor conservador para evitar tremedeira em longa distância.",
  "sensi_helper_pubg_scope8x": "Campo de precisão extrema. Ajustes devem ser mínimos.",
  "sensi_helper_pubg_ads": "Controle durante disparo sem mira ampliada (hipfire/ADS base).",
  "sensi_helper_pubg_gyro": "Resposta geral do giroscópio antes e durante alinhamento inicial.",
  "sensi_helper_pubg_gyro_fire": "Giroscópio durante spray. Priorize se o recuo sobe ou oscila no tiro.",
  "sensi_helper_ff_general": "Base da puxada e resposta geral da mira no FPS Mobile (Beta).",
  "sensi_helper_ff_red_dot": "Campo mais sensível para capa e ajuste fino de puxada.",
  "sensi_helper_ff_scope2x": "Tracking e controle em média distância.",
  "sensi_helper_ff_scope4x": "Longa distância com foco em estabilidade.",
  "sensi_helper_ff_sniper": "Precisão de AWM/sniper. Ajustes pequenos evitam excesso.",
  "sensi_helper_ff_free_look": "Movimento de câmera para leitura de ambiente (não é recoil).",
  "sensi_helper_cod_camera_standard": "Velocidade de câmera sem disparo no modo padrão.",
  "sensi_helper_cod_camera_ads": "Câmera durante ADS para aquisição de alvo.",
  "sensi_helper_cod_camera_tactical": "Câmera com mira tática/scope para média distância.",
  "sensi_helper_cod_camera_sniper": "Câmera para sniper e alinhamento fino.",
  "sensi_helper_cod_firing_standard": "Sensibilidade durante disparo sem mira especial.",
  "sensi_helper_cod_firing_ads": "Disparo em ADS. Campo principal de recoil no FPS Mobile (Gamma).",
  "sensi_helper_cod_firing_tactical": "Disparo com mira tática/scope.",
  "sensi_helper_cod_firing_sniper": "Disparo sniper, exige microajuste conservador.",
  "sensi_helper_cod_gyro_standard": "Giro base para câmera padrão.",
  "sensi_helper_cod_gyro_ads": "Gyro durante ADS.",
  "sensi_helper_cod_gyro_tactical": "Gyro para mira tática/scope.",
  "sensi_helper_cod_gyro_sniper": "Gyro no sniper. Evite valores agressivos.",
  "sensi_helper_cod_fov": "Campo de visão. Pode alterar percepção de velocidade da mira.",
  "app_cancel": "Cancelar",
  "coach_access_blocked": "Acesso bloqueado",
  "coach_access_full_library": "Libere trilhas, treinos completos e progresso salvo para evoluir com rotina.",
  "coach_adjust_filters": "Ajuste os filtros para ver outros treinos da biblioteca.",
  "coach_all_categories": "Todas categorias",
  "coach_all_levels": "Todos níveis",
  "coach_all_statuses": "Todos status",
  "coach_any_duration": "Qualquer duração",
  "coach_avoid": "Evite",
  "coach_choose_game_library": "Escolha um jogo para ver trilhas e treinos publicados.",
  "coach_common_mistakes": "Erros comuns",
  "coach_complete_onboarding_tracks": "Complete o onboarding para ordenar as trilhas.",
  "coach_complete_training_question": "Concluir treino?",
  "coach_completed": "Concluído",
  "coach_completed_plural": "Concluídos",
  "coach_completed_tracks": "Trilhas completadas",
  "coach_completed_trainings": "Treinos concluídos",
  "coach_completion_rate": "Taxa de conclusão",
  "coach_configure": "Configurar",
  "coach_configure_profile": "Configurar perfil",
  "coach_configure_profile_hint": "Configure seu perfil para recomendações melhores.",
  "coach_configure_profile_tracks": "Configure seu perfil para receber trilhas.",
  "coach_days_count": "{{count}} dias",
  "coach_default_tip": "Faça o treino devagar primeiro. Quando acertar limpo, aumente a velocidade.",
  "coach_duration_medium": "21 a 30 min",
  "coach_duration_short": "Até 20 min",
  "coach_error_load_library": "Não foi possível carregar a biblioteca da Mi Coach agora.",
  "coach_error_open_track": "Não foi possível abrir esta trilha agora.",
  "coach_error_open_training": "Não foi possível abrir este treino agora.",
  "coach_error_save_profile": "Não foi possível salvar seu perfil agora. Tente novamente em instantes.",
  "coach_error_sync_progress": "Não foi possível sincronizar seu progresso agora.",
  "coach_error_update_saved": "Não foi possível atualizar seus salvos agora.",
  "coach_error_load_state": "Não foi possível carregar seu perfil da Coach. Tente novamente.",
  "coach_error_load_state_title": "Perfil da Coach indisponível",
  "coach_try_again": "Tentar novamente",
  "coach_expected_learning": "Você deve aprender",
  "coach_filter_hint": "Filtre por categoria, nível ou status.",
  "coach_finish": "Concluir",
  "coach_finished_training_tracks": "Trilhas de treino finalizadas",
  "coach_for_who": "Para quem é",
  "coach_for_you": "Para você",
  "coach_free": "Free",
  "coach_first_training_free_badge": "Primeiro treino liberado",
  "coach_start_free_training": "Começar treino gratuito",
  "coach_full_content": "conteúdo completo",
  "coach_full_pubg_library": "Acesso total aos treinos da Coach",
  "coach_game_fallback": "Jogo",
  "coach_game_library": "Biblioteca de jogos",
  "coach_goal_prefix": "Meta",
  "coach_greeting": "Olá, {{name}}!",
  "coach_tagline": "Treinos, trilhas e evolução",
  "coach_tagline_mobile": "Treinos e evolução",
  "coach_continue_training": "Continuar treino",
  "coach_level_advanced": "Avançado",
  "coach_level_beginner": "Iniciante",
  "coach_level_competitive": "Competitivo",
  "coach_level_intermediate": "Intermediário",
  "coach_library_for_game": "Biblioteca {{game}}",
  "coach_library_games": "Jogos da biblioteca",
  "coach_loading_detail": "Carregando detalhe...",
  "coach_loading_subtitle": "Sincronizando biblioteca e progresso.",
  "coach_loading_title": "Carregando Mi Coach",
  "coach_manage_subscription": "Gerenciar assinatura",
  "coach_mark_completed": "Marcar como concluído",
  "coach_mark_pending": "Marcar como pendente",
  "coach_mark_pending_question": "Marcar como pendente?",
  "coach_mark_pending_short": "Marcar pendente",
  "coach_mi_coach_pro": "Mi Coach Pro",
  "coach_mi_tip": "Dica da Mi",
  "coach_minutes_per_day": "{{minutes}} min/dia",
  "coach_month_suffix": "/mês",
  "coach_nav_games": "Jogos",
  "coach_nav_home": "Início",
  "coach_nav_library": "Biblioteca",
  "coach_nav_more": "Mais",
  "coach_more_title": "Mais opções da Coach",
  "coach_more_desc_active": "Acesse atalhos e ajustes da sua rotina.",
  "coach_more_desc_free": "Seu treino gratuito continua aqui. Recursos avançados ficam no Pro.",
  "coach_more_profile": "Meu perfil da Coach",
  "coach_more_profile_desc": "Veja seu foco atual e o treino recomendado.",
  "coach_more_profile_setup_desc": "Configure seu primeiro perfil para receber uma trilha.",
  "coach_more_games_desc": "Troque o contexto da biblioteca por jogo.",
  "coach_more_progress_desc": "Veja progresso, conclusões e categorias.",
  "coach_more_saved_desc": "Continue os treinos que você marcou.",
  "coach_more_retake_desc": "Recalibre a trilha com novas respostas.",
  "coach_more_retake_locked_desc": "Refazer o perfil da Coach e recalibrar a trilha é recurso Pro.",
  "coach_more_unlock": "Desbloquear Pro",
  "coach_nav_progress": "Progresso",
  "coach_nav_saved": "Salvos",
  "coach_nav_tracks": "Trilhas",
  "coach_next": "Próximo",
  "coach_no_completed_trainings": "Sem treinos concluídos ainda",
  "coach_no_completed_trainings_desc": "Abra um treino premium e marque como concluído quando cumprir os passos.",
  "coach_no_fixed_time": "Sem tempo fixo",
  "coach_no_training_found": "Nenhum treino encontrado",
  "coach_nothing_saved": "Nada salvo por enquanto",
  "coach_objective": "Objetivo",
  "coach_of_library": "da biblioteca",
  "coach_of_total": "de {{total}}",
  "coach_open_training": "Abrir treino",
  "coach_open_training_eyebrow": "Treino aberto",
  "coach_open_youtube": "Abrir no YouTube",
  "coach_overall_evolution": "Evolução geral",
  "coach_pending_plural": "Pendentes",
  "coach_premium": "Premium",
  "coach_prerequisites": "Pré-requisitos",
  "coach_pro_active": "Pro ativo",
  "coach_pro_subscription": "Assinatura Pro",
  "coach_processing_answers": "Respostas recebidas",
  "coach_processing_libraries": "Bibliotecas por jogo mapeadas",
  "coach_processing_progress": "Progresso pronto para salvar",
  "coach_processing_title": "Analisando seu perfil",
  "coach_processing_tracks": "Trilhas existentes selecionadas",
  "coach_profile_pending": "Perfil pendente",
  "coach_progress_by_category": "Progresso por categoria",
  "coach_progress_percent": "Progresso {{percent}}%",
  "coach_progress_saved_hint": "Seu histórico fica salvo mesmo sem acesso premium ativo.",
  "coach_progress_trainings_count": "{{completed}}/{{total}} treinos",
  "coach_published_trainings_count": "{{count}}+ treinos publicados",
  "coach_reactivate_access": "Reativar acesso",
  "coach_reactivate_full_access": "Reative para acessar o conteúdo completo da biblioteca.",
  "coach_recent_achievements": "Conquistas recentes",
  "coach_recommended": "Recomendada",
  "coach_recommended_tracks": "Trilhas recomendadas",
  "coach_redo_onboarding": "Refazer onboarding",
  "coach_save_continue": "Salvar / continuar",
  "coach_save_from_library": "Salve treinos da biblioteca para continuar depois.",
  "coach_save_training": "Salvar treino",
  "coach_saved_continue": "Salvos / continuar",
  "coach_saved_trainings": "Treinos salvos",
  "coach_saved_trainings_desc": "Continue os treinos que você marcou.",
  "coach_search_reference": "Buscar referência",
  "coach_search_training": "Buscar treino",
  "coach_sections_aria": "Seções da Mi Coach",
  "coach_sign_in_desc": "Use sua conta Game Pro Hub para salvar perfil, progresso e treinos.",
  "coach_sign_in_title": "Entre na sua conta",
  "coach_start_now": "Começar agora",
  "coach_step_by_step": "Passo a passo",
  "coach_step_counter": "{{current}} de {{total}}",
  "coach_subscribe_now": "Liberar Coach Pro",
  "coach_subscription_inactive": "Sua assinatura não está ativa.",
  "coach_success_criteria": "Como saber se fez certo",
  "coach_support_material": "Material de apoio",
  "coach_support_material_desc": "Use antes do treino para entender o fundamento e depois para corrigir detalhes.",
  "coach_support_reference_avoid": "Evite focar apenas em sensibilidade sem compreender a lógica por trás da mecânica.",
  "coach_support_reference_label": "Referência",
  "coach_support_reference_learning": "Compreender o conceito estratégico do treino e aplicá-lo de forma consciente nas partidas.",
  "coach_support_reference_title": "Pesquisar conceito e checklist",
  "coach_support_reference_watch": "Estude a teoria deste fundamento, focando no posicionamento prévio, na retícula e no checklist de execução.",
  "coach_support_unavailable": "Material indisponível para este treino.",
  "coach_support_video_avoid": "Evite highlights com edições rápidas que impedem ver o posicionamento inicial.",
  "coach_support_video_label": "Vídeo técnico",
  "coach_support_video_learning": "Entender o tempo de reação e os ajustes físicos necessários durante o treino.",
  "coach_support_video_title": "Ver demonstração prática",
  "coach_support_video_watch": "Observe a execução visual da mecânica, focando no posicionamento de mira e no ritmo dos disparos.",
  "coach_total_mastered_trainings": "Total de treinos dominados",
  "coach_track_detail": "Detalhe da trilha",
  "coach_track_trainings": "Treinos da trilha",
  "coach_tracks_and_progress": "Trilhas e progresso",
  "coach_tracks_label": "trilhas",
  "coach_training_count_plus": "{{count}}+ treinos",
  "coach_training_objective": "Objetivo do treino",
  "coach_training_progress": "Progresso de treinamento",
  "coach_trainings_found": "{{count}} treinos encontrados",
  "coach_trainings_label": "treinos",
  "coach_updating_library": "Atualizando biblioteca...",
  "coach_view_all": "Ver todas",
  "coach_welcome_eyebrow": "Biblioteca inteligente de treinos",
  "coach_welcome_subtitle": "Escolha uma biblioteca, uma trilha ou siga as recomendações da Mi.",
  "coach_welcome_title": "Treinos para evoluir no seu jogo.",
  "coach_what_to_watch": "O que observar",
  "coach_onboarding_game_eyebrow": "Escolha do jogo",
  "coach_onboarding_game_title": "Qual jogo você joga?",
  "coach_onboarding_game_subtitle": "Escolha a biblioteca principal.",
  "coach_onboarding_game_pubg_desc": "Recoil, CQC, rotação, cover e ranqueada.",
  "coach_onboarding_game_cod_desc": "Recoil, tracking, ranked MP e battle royale.",
  "coach_onboarding_game_ff_desc": "Capa, rush, x1, shotgun e ranqueada.",
  "coach_onboarding_level_eyebrow": "Nível atual",
  "coach_onboarding_level_title": "Qual é o seu nível atual?",
  "coach_onboarding_level_subtitle": "Isso calibra a dificuldade das trilhas.",
  "coach_onboarding_level_beginner_desc": "Estou começando agora.",
  "coach_onboarding_level_intermediate_desc": "Tenho experiência e quero consistência.",
  "coach_onboarding_level_advanced_desc": "Jogo regularmente e busco ajuste fino.",
  "coach_onboarding_level_competitive_desc": "Busco performance em ranked ou scrim.",
  "coach_onboarding_pain_eyebrow": "Maior dificuldade",
  "coach_onboarding_pain_title": "Qual é sua maior dificuldade?",
  "coach_onboarding_pain_subtitle": "Escolha a dor que mais aparece nas partidas.",
  "coach_pain_recoil": "Mira / Recoil",
  "coach_pain_recoil_desc": "Spray sobe, treme ou foge do alvo.",
  "coach_pain_movement": "Movimentação",
  "coach_pain_movement_desc": "Perco trocas por entrada ou strafe ruim.",
  "coach_pain_close_range": "CQC / Rush",
  "coach_pain_close_range_desc": "Morro em casas, corredores e curta distância.",
  "coach_pain_positioning": "Posicionamento",
  "coach_pain_positioning_desc": "Morro aberto ou sem cover.",
  "coach_pain_decision": "Tomada de decisão",
  "coach_pain_decision_desc": "Forço duelo errado ou demoro para resetar.",
  "coach_pain_mental": "Foco / Tilt",
  "coach_pain_mental_desc": "Oscilo depois de erro ou derrota.",
  "coach_onboarding_objective_eyebrow": "Objetivo",
  "coach_onboarding_objective_title": "Qual é o seu objetivo?",
  "coach_onboarding_objective_subtitle": "A recomendação usa trilhas existentes.",
  "coach_objective_rank_up": "Subir de patente",
  "coach_objective_rank_up_desc": "Treinar para ganhar consistência na ranked.",
  "coach_objective_consistency": "Ser mais consistente",
  "coach_objective_consistency_desc": "Reduzir oscilação entre partidas.",
  "coach_objective_better_kd": "Melhorar K/D",
  "coach_objective_better_kd_desc": "Vencer mais duelos sem promessa garantida.",
  "coach_objective_competitive": "Jogar competitivo",
  "coach_objective_competitive_desc": "Ajustar decisão, squad e pressão.",
  "coach_onboarding_time_eyebrow": "Tempo disponível",
  "coach_onboarding_time_title": "Quanto tempo você pode treinar por dia?",
  "coach_onboarding_time_subtitle": "A duração ajuda a priorizar trilhas.",
  "coach_time_30": "Até 30 minutos",
  "coach_time_30_desc": "Blocos curtos e objetivos.",
  "coach_time_60": "30 a 60 minutos",
  "coach_time_60_desc": "Rotina equilibrada.",
  "coach_time_90": "1 a 2 horas",
  "coach_time_90_desc": "Mais repetições por categoria.",
  "coach_time_120": "2 horas ou mais",
  "coach_time_120_desc": "Volume alto de treino.",
  "coach_onboarding_setup_eyebrow": "Dispositivo / setup",
  "coach_onboarding_setup_title": "Qual seu dispositivo e configuração?",
  "coach_onboarding_setup_subtitle": "Ajuste para recomendações ideais.",
  "coach_setup_device": "Dispositivo",
  "coach_setup_mobile": "Celular",
  "coach_setup_fps": "FPS do dispositivo",
  "coach_setup_connection": "Conexão",
  "coach_setup_mobile_data": "Dados móveis",
  "coach_onboarding_style_eyebrow": "Estilo de jogo",
  "coach_onboarding_style_title": "Como você costuma jogar?",
  "coach_onboarding_style_subtitle": "Isso muda a ordem das trilhas.",
  "coach_style_aggressive": "Agressivo",
  "coach_style_aggressive_desc": "Procuro entrada e primeiro contato.",
  "coach_style_balanced": "Equilibrado",
  "coach_style_balanced_desc": "Alterno luta, cover e rotação.",
  "coach_style_tactical": "Tático",
  "coach_style_tactical_desc": "Priorizo informação, posição e zona.",
  "sensi_feedback_missing_session": "Sessão Sensi não encontrada para salvar feedback.",
  "sensi_feedback_auth_required": "Entre novamente para salvar seu feedback.",
  "sensi_feedback_save_failed": "Não foi possível salvar seu feedback agora.",
  "sensi_refine_missing_session": "Sessão Sensi não encontrada para gerar refinamento.",
  "sensi_refine_auth_required": "Entre novamente para gerar o próximo ajuste.",
  "sensi_refine_failed": "Não foi possível gerar o próximo ajuste agora.",
  "sensi_good_config_alert": "Configuração marcada como boa. Teste em partidas reais antes de recalibrar.",
  "mi_analysis_invalid_video_type": "Envie apenas vídeos MP4, MOV ou WEBM.",
  "mi_analysis_video_too_large": "O vídeo excede o limite máximo de 200MB.",
  "video_trim_timeout": "Não foi possível cortar este trecho. Tente selecionar um trecho menor.",
  "video_trim_failed": "Falha ao processar vídeo. Verifique sua conexão e tente novamente.",
  "legal_terms_created": "Termos criados com sucesso! Ative manualmente quando pronto.",
  "legal_terms_activated": "Versão ativada! Todos os usuários precisarão aceitar novamente.",
  "legal_error_prefix": "Erro:",
  "legal_activate_confirm": "ATENÇÃO: Ativar \"{{termType}} {{termVersion}}\" forçará TODOS os usuários a aceitar novamente.\n\nDeseja continuar?",
  "settings_support_title": "Precisa de ajuda?",
  "settings_support_subtitle": "Fale com o suporte oficial do Game Pro Hub pelo WhatsApp.",
  "settings_support_cta": "Chamar suporte",
  "settings_section_community": "Comunidade",
  "settings_community_title": "Entre na comunidade oficial",
  "settings_community_desc": "Receba novidades, treinos, avisos e troque ideia com outros players do Game Pro Hub.",
  "settings_community_cta": "Entrar na comunidade",
  "settings_copy_link_prompt": "Copie seu link:",
  "settings_partner_referrals": "Indicados",
  "settings_partner_earnings": "Ganhos (R$)",
  "settings_control_panel": "Painel de Controle",
  "settings_control_panel_desc": "Gerenciar sistema e rede",
  "settings_partner_panel": "Painel do Parceiro",
  "settings_partner_panel_desc": "Gerenciar indicações e comissões",
  "arena_title": "Ferramentas",
  "arena_subtitle": "Ferramentas táticas para {{game}}.",
  "arena_coach_title": "Coach IA",
  "arena_coach_desc": "Biblioteca, trilhas e análise tática por jogo.",
  "arena_sensi_title": "Sensi-IA",
  "arena_sensi_desc": "Ajuste sua sensibilidade por relato ou vídeo.",
  "arena_pubg_calculator_title": "Calculadora FPS Mobile (Alpha)",
  "arena_pubg_calculator_desc": "Calcule uma base de sensibilidade para FPS Mobile (Alpha).",
  "arena_freefire_calculator_title": "Calculadora FPS Mobile (Beta)",
  "arena_new_badge": "Novo",
  "arena_freefire_calculator_desc": "Calcule a sensibilidade ideal sem o uso de IA.",
  "arena_mi_analysis_title": "Mi Análise",
  "arena_mi_analysis_desc": "Envie um trecho da sua gameplay e receba um diagnóstico da Mi.",
  "arena_subscribe_pro": "Assinar Pro",
  "arena_subscribe_pro_desc": "Libere Coach completa, Sensi-IA e recursos premium.",
  "arena_pro_active": "Plano Pro Ativo",
  "arena_pro_active_desc": "Recursos premium liberados.",
  "arena_recommended_title": "Recomendado para Você",
  "arena_tools_title": "Ferramentas & Análise",
  "arena_premium_title": "Assinatura",
  "dashboard_no_records": "Sem registros",
  "dashboard_now": "Agora mesmo",
  "dashboard_hours_ago": "há {{count}}h",
  "dashboard_days_ago": "há {{count}} dias",
  "dashboard_recruit": "RECRUTA",
  "dashboard_pro_score": "Pro Score",
  "dashboard_points_abbr": "pts",
  "dashboard_progressive_system": "Sistema Progressivo",
  "dashboard_last_sessions": "Últimas 3 sessões analisadas",
  "dashboard_active_aim_telemetry": "Telemetria de mira ativa",
  "dashboard_optimized": "Otimizado",
  "dashboard_skill_matrix": "Matriz de Habilidades",
  "dashboard_best_recorded": "Melhor registro",
  "dashboard_syncing_sensors": "Sincronizando sensores neurais...",
  "training_syncing_library": "Sincronizando biblioteca...",
  "training_library_title": "Biblioteca Mi",
  "training_recruit": "Recruta",
  "training_modules": "Módulos",
  "training_completed": "Concluídos",
  "training_search_placeholder": "Buscar treino...",
  "training_completed_empty": "Conclua treinos para liberar favoritos",
  "training_no_available": "Nenhum treino disponível para este jogo no momento.",
  "training_back": "Voltar",
  "training_total_progress": "Progresso total",
  "training_of": "de",
  "training_level": "Nível",
  "training_not_found": "Treino não encontrado",
  "training_level_1": "Iniciante",
  "training_level_2": "Intermediário",
  "training_level_3": "Avançado",
  "training_mi_recommendation": "Recomendação da Mi",
  "training_focus_title": "O que você vai treinar",
  "training_focus_fallback": "Foco na execução perfeita do movimento e na correção de vícios.",
  "training_why_title": "Por que isso importa",
  "training_why_fallback": "Pequenos erros nesse fundamento são a principal causa de mortes bobas durante as partidas.",
  "training_how_title": "Como fazer",
  "training_success_title": "Como saber se fez certo",
  "training_success_fallback": "O movimento deve fluir sem travamentos e você deve conseguir eliminar o alvo sem perder vida.",
  "training_common_error_title": "Erro comum",
  "training_common_error_fallback": "Fazer o movimento rápido demais antes de focar na precisão.",
  "training_mi_tip": "Dica da Mi",
  "training_pro_reference": "Referência Pro",
  "training_complete": "Concluir treinamento ✓",
  "training_mark_done": "Marcar como feito ⚡",
  "training_validate_execution": "Validar execução",
  "training_validate_execution_desc": "Envie um vídeo da sua prática para a Mi validar sua técnica.",
  "training_analyze_with_mi": "Analisar com Mi",
  "training_group_core": "Treinos Core",
  "training_group_advanced": "Habilidades avançadas",
  "training_group_competitive": "Nível competitivo",
  "training_group_system": "Sistema e aquecimento",
  "training_cat_aim_name": "Mira e precisão",
  "training_cat_aim_desc": "Flick shots, tracking e micro-ajustes",
  "training_cat_recoil_name": "Controle de recoil",
  "training_cat_recoil_desc": "Spray control e padrões de recuo",
  "training_cat_movement_name": "Movimentação",
  "training_cat_movement_desc": "Strafing, crouch e jiggle peek",
  "training_cat_peek_name": "Peek e ângulos",
  "training_cat_peek_desc": "Shoulder peek e ângulos táticos",
  "training_cat_positioning_name": "Posicionamento",
  "training_cat_positioning_desc": "Cobertura, terreno elevado e zonas",
  "training_cat_crosshair_name": "Crosshair Placement",
  "training_cat_crosshair_desc": "Pre-aim e posição de mira",
  "training_cat_prefire_name": "Pre-fire e reação",
  "training_cat_prefire_desc": "Timing e reaction drills",
  "training_cat_cqb_name": "Combate próximo",
  "training_cat_cqb_desc": "CQB, hipfire e room clearing",
  "training_cat_ranged_name": "Combate médio/longo",
  "training_cat_ranged_desc": "DMR, sniper e bullet drop",
  "training_cat_clutch_name": "Cenários de clutch",
  "training_cat_clutch_desc": "1vN e gestão de recursos",
  "training_cat_rotation_name": "Rotação e zona",
  "training_cat_rotation_desc": "Zone prediction e rotas seguras",
  "training_cat_entry_name": "Entry fragging",
  "training_cat_entry_desc": "Primeiro contato e trade kills",
  "training_cat_pressure_name": "Alta pressão",
  "training_cat_pressure_desc": "End-game e decisões sob pressão",
  "training_cat_warmup_name": "Aquecimento",
  "training_cat_warmup_desc": "Rotinas pre-game completas",
  "training_cat_consistency_name": "Consistência",
  "training_cat_consistency_desc": "Correção de erros e hábitos",
  "training_impact": "Impacto",
  "training_result_exceptional": "Excepcional",
  "training_result_very_good": "Muito bom",
  "training_result_good": "Bom",
  "training_result_regular": "Regular",
  "training_result_needs_improvement": "Precisa melhorar",
  "training_result_critical": "Crítico",
  "training_result_ai": "Resultado da análise IA",
  "training_evaluated_skills": "Skills avaliadas",
  "training_detailed_analysis": "Análise detalhada",
  "training_strengths": "Pontos fortes",
  "training_weaknesses": "Pontos fracos",
  "training_practical_corrections": "Correções práticas",
  "training_next_recommended": "Próximo treino recomendado",
  "training_ask_coach": "Perguntar ao Coach",
  "training_new_training": "Novo treino",
  "training_default_name": "treino",
  "training_coach_context": "Acabei de fazer o treino \"{{trainingName}}\" e recebi score {{score}}/100.\nMeus pontos fracos: {{weaknesses}}.\nQuero entender melhor o que posso fazer para melhorar especificamente nesses pontos.",
  "story_solid_performance": "Desempenho sólido.",
  "story_room_to_improve": "Tem espaço para evoluir.",
  "story_time_to_adjust": "Hora de ajustar.",
  "story_weakest_point": "Ponto mais fraco: {{label}}",
  "story_focus_first": "Foque aqui primeiro para evoluir mais rápido.",
  "story_main_insight": "Insight principal",
  "story_no_detail": "Sem análise detalhada neste trecho.",
  "story_metrics": "Suas métricas",
  "story_second_insight": "Segundo insight",
  "story_train_weakest": "Treine o ponto mais fraco.",
  "story_fix_now": "Bora corrigir isso agora?",
  "story_previous": "Story anterior",
  "story_continue": "Continuar",
  "story_pause": "Pausar",
  "story_next": "Próximo story",
  "story_paused": "Pausado",
  "story_mi_summary": "Resumo da Mi",
  "story_correction": "Correção",
  "story_action_fallback": "Aplique o ajuste e valide em um novo teste.",
  "kpi_aim": "Mira",
  "kpi_positioning": "Posicionamento",
  "kpi_decision": "Decisão",
  "kpi_timing": "Timing",
  "kpi_movement": "Movimento",
  "kpi_recoil": "Recoil",
  "pubg_calc_professional_title": "Calculadora profissional",
  "pubg_calc_professional_desc": "Use uma sensibilidade base e gere todas as outras configurações instantaneamente.",
  "pubg_access_lifetime_active": "Vitalício ativo: uso ilimitado",
  "pubg_access_unlimited": "Acesso liberado: ilimitado",
  "pubg_access_pro_month": "{{count}}/15 cálculos este mês",
  "pubg_access_free_count": "{{count}}/2 cálculos grátis",
  "pubg_access_free_weapons": "Free libera M416 e Honey Badger",
  "pubg_device_not_informed": "Aparelho não informado",
  "pubg_control_gyro": "Giroscópio",
  "pubg_control_camera": "Lente / Câmera ao mirar",
  "pubg_control_mode": "Modo de controle",
  "pubg_primary_weapon": "Arma principal",
  "pubg_other_weapons": "Outras armas...",
  "pubg_base_scope": "Mira base conhecida",
  "pubg_perfect_value": "Valor de sensibilidade perfeita",
  "pubg_device_model": "Modelo do aparelho",
  "pubg_optional_recommended": "Opcional, recomendado",
  "pubg_device_placeholder": "Ex: iPhone 17, Poco X6 Pro, Galaxy S26, Redmi Note 12...",
  "pubg_generating_panel": "Gerando painel...",
  "pubg_calculate_config": "Calcular configuração",
  "pubg_unlock_lifetime": "Desbloquear acesso vitalício",
  "pubg_generated": "Gerado",
  "pubg_result_title": "Resultado FPS Mobile (Alpha)",
  "pubg_result_subtitle": "Valores calculados a partir da sua mira base.",
  "pubg_recalculate": "Recalcular",
  "pubg_base_used": "Base usada",
  "pubg_recommended_config": "Configuração recomendada",
  "pubg_scope": "Mira",
  "pubg_value": "Valor",
  "pubg_type": "Tipo",
  "pubg_copy_config": "Copiar configuração",
  "pubg_fine_tune_sensi": "Ajuste fino com Sensi-IA",
  "pubg_test_tip": "Teste os valores no treino por 5 min. Se a mira subir, descer ou tremer, use a Sensi-IA para refinar.",
  "pubg_calc_summary": "Resumo do cálculo",
  "pubg_base_value": "Valor base",
  "pubg_mode": "Modo",
  "pubg_weapon": "Arma",
  "pubg_device": "Aparelho",
  "pubg_tag_adjusted": "Ajustado",
  "pubg_tag_base": "Base",
  "pubg_tag_control": "Controle",
  "pubg_tag_precision": "Precisão",
  "pubg_tag_long_range": "Longa distância",
  "pubg_desc_rotation_precision": "Recomendado para rotação e precisão.",
  "pubg_desc_first_person": "Recomendado para controle em primeira pessoa.",
  "pubg_desc_short_scope": "Valor principal para mira curta.",
  "pubg_desc_short_medium_spray": "Ajustado para spray curto e médio.",
  "pubg_desc_mid_range": "Ajustado para controle em média distância.",
  "pubg_desc_smooth_moves": "Use com movimentos mais suaves.",
  "pubg_desc_stability": "Ideal para controle mais estável.",
  "pubg_desc_light_consistent": "Use com movimentos leves e consistentes.",
  "pubg_desc_training_test": "Valor recomendado para testar no treino.",
  "pubg_desc_base_value": "Valor base informado.",
  "pubg_pro_lifetime": "PRO / VITALÍCIO",
  "pubg_locked": "Bloqueado",
  "pubg_error_value_range": "O valor perfeito deve estar entre 1 e 500.",
  "pubg_error_scope_pro": "Essa mira é recurso Pro. Use Red Dot ou 2x grátis.",
  "pubg_error_access": "Falha ao validar acesso. Tente novamente.",
  "pubg_error_calculate": "Erro ao calcular. Tente novamente.",
  "pubg_notice_generated": "Painel gerado com sucesso.",
  "pubg_error_session": "Sessão expirada. Entre novamente.",
  "pubg_error_connection": "Falha de conexão. Tente novamente em instantes.",
  "pubg_copy_title": "Minha sensibilidade FPS Mobile (Alpha) - Game Pro Hub",
  "pubg_free_copy_note": "Apenas miras Red Dot e 2x inclusas na degustação Free. Adquira a Calculadora FPS Mobile (Alpha) Vitalícia no Game Pro Hub para todas as miras.",
  "pubg_notice_copied": "Valores copiados.",
  "pubg_error_copy": "Não foi possível copiar.",
  "security_eyebrow": "Segurança",
  "security_title": "Segurança no Game Pro Hub",
  "security_subtitle": "Protegemos sua conta, seus pagamentos e seus dados para que você foque em evoluir no jogo.",
  "security_payments_title": "Pagamentos seguros",
  "security_payments_text": "Pagamentos são processados pela Stripe. O Game Pro Hub não armazena dados completos de cartão.",
  "security_access_title": "Acesso protegido",
  "security_access_text": "A autenticação usa provedores seguros e não pedimos senha da sua conta do jogo.",
  "security_data_title": "Dados usados com responsabilidade",
  "security_data_text": "Usamos dados enviados por você apenas para entregar análise, treino, histórico e suporte da plataforma.",
  "security_infra_title": "Infraestrutura monitorada",
  "security_infra_text": "O backend roda com serviços monitorados e fluxos de webhook validados antes de liberar acesso.",
  "security_transparency_title": "Transparência",
  "security_transparency_text": "Price IDs ficam no backend e o acesso pago depende de confirmação validada, nunca apenas da tela de sucesso.",
  "security_privacy_title": "Boas práticas de privacidade",
  "security_privacy_text": "Evite enviar dados sensíveis nos vídeos. Em caso de dúvida, fale com o suporte oficial.",
  "security_notice_title": "Aviso honesto",
  "security_notice_text": "Nenhum sistema promete segurança absoluta, mas trabalhamos para reduzir riscos e corrigir problemas com rapidez.",
  "security_faq_title": "Perguntas rápidas",
  "security_faq_account_q": "Preciso conectar minha conta do jogo?",
  "security_faq_account_a": "Não. O Game Pro Hub funciona sem conectar sua conta do jogo.",
  "security_faq_payment_q": "Quem processa o pagamento?",
  "security_faq_payment_a": "A Stripe processa o checkout e envia confirmações seguras para o backend.",
  "security_faq_support_q": "Como falo com suporte?",
  "security_faq_support_a": "Use o card de suporte no Perfil ou o WhatsApp oficial do Game Pro Hub.",
  "security_cta_badge": "Pronto para evoluir",
  "security_cta_title": "Crie sua conta com segurança.",
  "security_cta_text": "Entre no hub e use a Mi para treinar melhor sem entregar acesso à sua conta do jogo.",
  "security_cta": "Criar conta com segurança",
  "security_have_account": "Já possui conta?",
  "security_back_app": "Volte ao app.",
  "mi_analysis_paywall_desc": "Envie uma partida curta e receba diagnóstico tático, erros por momento e próximos treinos recomendados.",
  "mi_analysis_subscribe_pro": "Assinar Pro",
  "mi_analysis_processing_title": "Mi Análise em andamento",
  "mi_analysis_waiting_queue": "Aguardando na fila de processamento...",
  "mi_analysis_header_subtitle": "Diagnóstico técnico de gameplay para {{game}}",
  "mi_analysis_upload_title": "Envie sua gameplay",
  "mi_analysis_upload_desc": "Use um trecho com combate real, decisão tática ou erro que você quer entender.",
  "mi_analysis_select_video": "Selecionar vídeo",
  "mi_analysis_formats": "MP4, MOV ou WEBM até 200MB",
  "mi_analysis_confirm_title": "Confirmar envio",
  "mi_analysis_confirm_desc": "A Mi vai analisar vídeo, contexto do jogo e histórico recente.",
  "mi_analysis_file_size": "Tamanho: {{size}} MB",
  "mi_analysis_change_video": "Trocar vídeo",
  "mi_analysis_sending": "Enviando...",
  "mi_analysis_send": "Enviar para Mi Análise",
  "mi_analysis_history_title": "Histórico de Mi Análise",
  "mi_analysis_no_date": "Sem data",
  "mi_analysis_history_fallback": "Análise de gameplay",
  "mi_analysis_report": "Relatório",
  "mi_analysis_empty": "Nenhuma análise anterior registrada. Envie seu primeiro vídeo acima.",
  "mi_analysis_back_arena": "Ferramentas",
  "celebration_training_complete": "Treino completo!",
  "celebration_next_training": "Próximo treino",
  "celebration_close": "Fechar"
};
const enUS = {

  "landing_hero_badge": "AI for competitive mobile FPS players",
  "landing_hero_title": "Stop playing like a bot.",
  "landing_hero_subtitle": "Mi discovers your aim flaw, indicates the adjustment and guides your next drill.",
  "landing_primary_cta": "Subscribe Pro for R$29,99",
  "landing_secondary_cta": "Try for free",
  "landing_hero_microcopy": "Less than a snack. More useful than changing sensitivity for the 14th time.",
  "landing_badge_diag": "Aim diagnosis",
  "landing_badge_sensi": "Sensitivity adjustment",
  "landing_badge_training": "Guided drill",
  "landing_badge_analysis": "Gameplay analysis",
  "landing_pain_title": "The problem isn't playing little. It's training in the dark.",
  "landing_pain_1_title": "Aim rises during spray",
  "landing_pain_1_desc": "You compensate with your finger, but don't know if the flaw is control or sensitivity.",
  "landing_pain_2_title": "Sensitivity changes constantly",
  "landing_pain_2_desc": "Today 120, tomorrow 95, then copying someone else's. Zero strategy.",
  "landing_pain_3_title": "Directionless training",
  "landing_pain_3_desc": "You play a lot, but repeat the exact same flaw as if warming up.",
  "landing_solution_title": "Mi cuts the guesswork.",
  "landing_solution_desc": "Game Pro Hub connects diagnosis, sensitivity, drill and analysis into a simple workflow.",
  "landing_sol_step_1": "1. State the problem",
  "landing_sol_step_2": "2. Get diagnosis",
  "landing_sol_step_3": "3. Adjust baseline",
  "landing_sol_step_4": "4. Train weak point",
  "landing_sol_step_5": "5. Analyze gameplay",
  "landing_sol_cta": "Start now",
  "landing_pro_title": "Free shows the start. Pro unlocks the complete cycle.",
  "landing_pro_value": "Pro for R$29,99/month",
  "landing_pro_value_sub": "R$29,99/mo",
  "landing_pro_b1": "AI aim diagnosis",
  "landing_pro_b2": "Sensitivity adjustments",
  "landing_pro_b3": "Mi guided drills",
  "landing_pro_b4": "Gameplay analysis",
  "landing_pro_b5": "Official WhatsApp community",
  "landing_pro_b6": "Support and Community",
  "landing_pro_microcopy": "If you already spent more than that on skins, you can invest in your aim.",
  "landing_7day_title": "7 days to stop shooting in the dark.",
  "landing_7day_desc": "A simple plan to break the cycle: lose, change sensitivity, repeat.",
  "landing_7d_1": "Day 1 — Discover the flaw",
  "landing_7d_2": "Day 2 — Adjust your baseline",
  "landing_7d_3": "Day 3 — Train the weak point",
  "landing_7d_4": "Day 4 — Validate in practice",
  "landing_7d_5": "Day 5 — Analyze gameplay",
  "landing_7d_6": "Day 6 — Fix core mistake",
  "landing_7d_7": "Day 7 — Repeat with higher precision",
  "landing_7day_cta": "Start my Pro plan",
  "landing_community_title": "You don't have to figure it all out alone.",
  "landing_community_desc": "Join the official Game Pro Hub WhatsApp community, ask questions and track updates.",
  "landing_comm_btn": "Join community",
  "landing_comm_whatsapp_title": "Official WhatsApp community",
  "landing_comm_whatsapp_desc": "Exchange thoughts with other competitive mobile FPS players.",
  "landing_comm_support_title": "Priority Support",
  "landing_comm_support_desc": "Get answers to your questions and ongoing guidance in our ecosystem.",
  "landing_faq_title": "Frequently Asked Questions",
  "landing_faq_q1": "Does it work for any mobile FPS?",
  "landing_faq_a1": "Yes. Focus is aim, sensitivity, drills and gameplay analysis.",
  "landing_faq_q2": "Do I need to be advanced?",
  "landing_faq_a2": "No. You state the problem and Mi indicates the next step.",
  "landing_faq_q3": "How much does Pro cost?",
  "landing_faq_a3": "R$29,99 per month.",
  "landing_faq_q4": "Can I cancel?",
  "landing_faq_a4": "Yes, following the standard platform workflow.",
  "landing_faq_q5": "Is there support?",
  "landing_faq_a5": "Yes. You have access to the official WhatsApp community and priority support for questions.",
  "landing_final_title": "Stop changing sensitivity in despair.",
  "landing_final_subtitle": "Enter Game Pro Hub, follow Mi's plan and train with direction.",
  "landing_final_cta_sec": "Create free account",
  "auth_title": "Access your account",
  "auth_subtitle": "Sign in or create your account to continue.",
  "auth_player_name": "Player Name",
  "auth_your_nickname": "Your Nickname",
  "auth_email": "E-mail",
  "auth_password": "Password",
  "auth_login": "Sign In",
  "auth_create_account": "Create Account",
  "auth_or": "Or",
  "auth_continue_google": "Continue with Google",
  "auth_new_account": "Create New Account",
  "auth_have_account": "Already Have an Account",
  "auth_title_sign_in": "Sign In",
  "auth_title_register": "Create Account",
  "auth_subtitle_sign_in": "Access your account",
  "auth_subtitle_register": "Fill in to start",
  "auth_email_placeholder": "Your email",
  "auth_password_placeholder": "Your password",
  "auth_missing_credentials": "Fill all fields.",
  "auth_sync_error": "Sync error.",
  "auth_invalid_credentials": "Invalid credentials.",
  "auth_already_have_account": "Have an account? Sign in",
  "auth_no_account": "No account? Create one",
  "auth_secure_access": "SECURE ACCESS",
  "auth_error_generic": "We could not sign you in right now. Try again.",
  "auth_error_fill_email_password": "Enter your email and password.",
  "auth_error_email_in_use": "This email already has an account. Use Sign in with email.",
  "auth_error_check_credentials": "We could not sign you in right now. Check your details and try again.",
  "auth_error_weak_password": "Use a password with at least 6 characters.",
  "auth_error_invalid_email": "Enter a valid email.",
  "auth_error_reset_email_required": "Enter your email to reset your password.",
  "auth_error_user_not_found": "We could not find an account with that email.",
  "auth_error_reset_failed": "We could not send the email right now. Try again.",
  "auth_safety_badge": "Safe, direct, and no game password",
  "auth_headline": "Train to evolve, evolve to win",
  "auth_subheadline": "Sign in, choose your game, and get help adjusting your aim and training better.",
  "auth_benefits_aria": "Game Pro Hub benefits",
  "auth_benefit_aim": "Fix your aim",
  "auth_benefit_training": "Get simple drills",
  "auth_benefit_progress": "Track your progress",
  "auth_microcopy": "Mi helps you understand what to change and how to train.",
  "auth_panel_aria": "Login and sign up",
  "auth_reset_eyebrow": "Reset password",
  "auth_reset_title": "We will send you a link",
  "auth_reset_desc": "Enter your account email to receive the instructions.",
  "auth_sending": "Sending...",
  "auth_send_link": "Send link",
  "auth_email_sent_title": "Email sent",
  "auth_email_sent_desc": "Check your inbox and spam folder.",
  "auth_back_to_login": "Back to login",
  "auth_free_account": "Free account",
  "auth_welcome_back": "Welcome back",
  "auth_create_free_account": "Create free account",
  "auth_email_login": "Sign in with email",
  "auth_register_desc": "Start with Google or use email and password.",
  "auth_login_desc": "Continue your progress in Game Pro Hub.",
  "auth_google": "Sign in with Google",
  "auth_or_email": "or use email",
  "auth_hide_password": "Hide password",
  "auth_show_password": "Show password",
  "auth_forgot_password": "Forgot password?",
  "auth_entering": "Signing in...",
  "auth_switch_aria": "Switch login and sign up",
  "auth_create_account_short": "Create account",
  "auth_login_short": "Sign in",
  "auth_terms_microcopy": "By continuing, you agree to the platform terms.",
  "auth_trust_note": "We never ask for your game password or external access to your account.",
  "auth_errors": {
    "auth/email-already-in-use": "This email is already registered. Please sign in.",
    "auth/invalid-email": "Invalid email.",
    "auth/user-not-found": "User not found. Create an account.",
    "auth/wrong-password": "Incorrect password.",
    "auth/weak-password": "Weak password. Use at least 6 characters.",
    "auth/too-many-requests": "Too many attempts. Try again later.",
    "auth/network-request-failed": "Connection error. Check your internet.",
    "auth/user-disabled": "Account disabled. Contact support.",
    "auth/invalid-credential": "Incorrect email or password.",
    "auth/operation-not-allowed": "Operation not allowed.",
    "auth/account-exists-with-different-credential": "This email is already in use with another login method.",
    "default": "Processing error. Try again."
  },
  "hub_welcome": "Welcome,",
  "hub_subtitle": "Your journey to pro",
  "hub_analyses": "Analyses",
  "hub_coins": "Acesso Premium",
  "hub_average": "Average",
  "hub_analyze_new": "Analyze New Gameplay",
  "hub_recharge": "Recharge AI-Coins",
  "hub_recent": "Recent Analyses",
  "hub_today": "Today",
  "nav_home": "Home",
  "nav_hub": "Home",
  "nav_coach": "Coach",
  "nav_sensi": "Sensi-IA",
  "nav_sensi_short": "Sensi",
  "nav_tools": "Tools",
  "nav_tools_short": "Tools",
  "nav_training": "Training",
  "nav_chat": "Chat",
  "nav_history": "Evolution",
  "nav_profile": "Profile",
  "nav_pricing": "Plans",
  "onboarding_step_game": "Step 1 of 3",
  "onboarding_step_problem": "Step 2 of 3",
  "onboarding_step_action": "Step 3 of 3",
  "onboarding_game_question": "Which game do you want to improve?",
  "onboarding_game_subtitle": "Mi uses this to open the right tool on your first session.",
  "onboarding_game_pubg": "FPS Mobile (Alpha)",
  "onboarding_game_freefire": "FPS Mobile (Beta)",
  "onboarding_game_codm": "FPS Mobile (Gamma)",
  "onboarding_problem_question": "What is your biggest problem today?",
  "onboarding_problem_subtitle": "Pick the main symptom. The app will suggest the first step.",
  "onboarding_problem_shaking": "Shaky aim",
  "onboarding_problem_spray": "Spray rising",
  "onboarding_problem_sensitivity": "Sensitivity feels wrong",
  "onboarding_problem_training": "I do not know how to train",
  "onboarding_problem_analysis": "I want to analyze my gameplay",
  "onboarding_action_question": "What do you want to do now?",
  "onboarding_action_subtitle": "We will send you straight to a useful tool.",
  "onboarding_action_adjust": "Adjust sensitivity",
  "onboarding_action_diagnose": "Diagnose my aim",
  "onboarding_action_train": "Train mechanics",
  "onboarding_action_analyze": "Analyze gameplay",
  "onboarding_action_guide": "Guide me",
  "home_guided_title": "Home",
  "home_guided_subtitle": "Tell Mi the problem. She points to the next step.",
  "home_next_step_badge": "Next step",
  "home_next_step_title": "Your next step",
  "home_next_step_desc": "Improve your aim by starting with the most important adjustment now.",
  "home_next_step_cta": "Start diagnosis",
  "home_checkpoint_account_created": "Let us find the best path for your aim.",
  "home_checkpoint_first_result": "You already created value",
  "home_first_result_desc": "Continue the cycle: adjust, diagnose, train, and analyze.",
  "home_aha_badge": "Aha moment in minutes",
  "home_hero_title": "Mi quick plan.",
  "home_hero_desc": "Diagnose first. Train next. Analyze when needed.",
  "home_start_free_adjustment": "Start my free adjustment",
  "home_continue_evolution": "Continue my evolution",
  "home_mi_guide_title": "What is happening with your aim?",
  "home_mi_guide_subtitle": "Write a few words or tap a symptom.",
  "home_mi_guide_placeholder": "Example: spray rises, aim shakes, I do not know how to train...",
  "home_mi_guide_cta": "Generate Mi's plan",
  "home_mi_guide_quick_chips": "Quick symptoms",
  "home_chip_aim_rising": "Aim rises",
  "home_chip_aim_shaking": "Aim shakes",
  "home_chip_bad_spray": "Bad spray",
  "home_chip_training": "I do not know how to train",
  "home_chip_analysis": "Analyze gameplay",
  "home_mi_plan_title": "Mi's plan",
  "home_mi_plan_quick_title": "Mi quick plan",
  "home_mi_plan_default": "Start with Sensi-IA. Then validate your base and train the adjustment.",
  "home_mi_plan_continue": "Continue with Sensi-IA. Then train the adjustment in Coach.",
  "home_mi_plan_sensitivity": "Create a safe baseline. Then validate it with Sensi-IA.",
  "home_mi_plan_training": "Open a recommended drill. Then validate execution with Mi Analysis.",
  "home_mi_plan_analysis": "Send gameplay, find the weak point, and open a recommended drill.",
  "home_mi_plan_aim": "Diagnose aim first. If needed, recalculate the baseline after.",
  "home_quick_tools_title": "Quick tools",
  "home_tool_sensi_title": "Sensi-IA",
  "home_tool_sensi_desc": "Find the aim issue.",
  "home_tool_calculator_title": "Calculator",
  "home_tool_calculator_desc": "Create a safe base.",
  "home_tool_coach_title": "Coach",
  "home_tool_coach_desc": "Train the weak point.",
  "home_tool_analysis_title": "Mi Analysis",
  "home_tool_analysis_desc": "Analyze gameplay.",
  "home_plan_tool_calculator": "Calculator",
  "home_plan_short_base": "Create base",
  "home_plan_short_validate": "Validate adjustment",
  "home_plan_short_train": "Train adjustment",
  "home_plan_short_training": "Open drill",
  "home_plan_short_analysis": "Validate execution",
  "home_plan_short_adjust_if_needed": "Adjust if needed",
  "home_plan_short_send_video": "Send gameplay",
  "home_plan_short_weakness": "Find weak point",
  "home_plan_short_open_training": "Open drill",
  "home_plan_short_diagnose": "Diagnose",
  "home_plan_short_recalculate": "Recalculate base",
  "home_open_sensi": "Open Sensi-IA",
  "home_open_calculator": "Open Calculator",
  "home_open_coach": "Open Coach",
  "home_open_analysis": "Open Mi Analysis",
  "home_cycle_label": "Game Pro Hub cycle",
  "home_cycle_adjust": "Adjust",
  "home_cycle_diagnose": "Diagnose",
  "home_cycle_train": "Train",
  "home_cycle_analyze": "Analyze",
  "home_intent_title": "What do you want to improve today?",
  "home_intent_subtitle": "One choice. One clear next step.",
  "home_intent_adjust_sensitivity": "Adjust sensitivity",
  "home_intent_adjust_sensitivity_desc": "Create a safe baseline for your game.",
  "home_intent_find_aim_issue": "Find the aim issue",
  "home_intent_find_aim_issue_desc": "Use Sensi-IA to understand what to change.",
  "home_intent_train_mechanics": "Train mechanics",
  "home_intent_train_mechanics_desc": "Open Coach and follow a short routine.",
  "home_intent_analyze_gameplay": "Analyze gameplay",
  "home_intent_analyze_gameplay_desc": "Send a video and receive Mi's review.",
  "home_intent_guide_me": "Guide me",
  "home_intent_guide_me_desc": "Start with the highest-value diagnosis.",
  "home_evolution_plan_title": "Your evolution plan",
  "home_evolution_plan_subtitle": "Adjust -> diagnose -> train -> analyze -> repeat.",
  "home_plan_step_adjust": "Adjust sensitivity",
  "home_plan_tools_calculators": "FPS Mobile (Alpha) / FPS Mobile (Beta) Calculator",
  "home_plan_step_diagnose": "Diagnose your aim",
  "home_plan_tool_sensi": "Sensi-IA",
  "home_plan_step_train": "Train with Mi Coach",
  "home_plan_tool_coach": "Mi Coach",
  "home_plan_step_analyze": "Analyze your gameplay",
  "home_plan_tool_mi_analysis": "Mi Analysis",
  "home_status_available": "Available",
  "home_status_initial_free": "Initial free",
  "home_status_preview": "Free preview",
  "home_status_preview_pro": "Free preview / complete on Pro",
  "home_status_pro": "Pro",
  "home_status_pro_active": "Pro active",
  "home_status_recommended": "Recommended",
  "home_status_sensi": "Via Sensi-IA",
  "home_first_value_title": "First value",
  "home_first_value_desc": "Receive a useful recommendation before any contextual paywall.",
  "home_pro_strip_title": "Complete evolution plan",
  "home_pro_strip_desc": "You find the first adjustment for free. Pro unlocks the full cycle: Sensi-IA, Mi Coach, and Mi Analysis.",
  "home_pro_strip_cta": "Unlock Pro",
  "community_cta_title": "Game Pro Hub Community",
  "community_cta_description": "Not sure which adjustment to use? Join the official community.",
  "community_cta_button": "Join",
  "chat_title": "Mi Coach",
  "chat_subtitle": "Real-time technical coaching",
  "chat_cost": "1 coin per message",
  "chat_placeholder": "Ask your tactical question...",
  "chat_empty_title": "Mi Coach Ready",
  "chat_empty_subtitle": "Ask about strategies, aim, positioning and more.",
  "analysis_title": "Gameplay Analysis",
  "analysis_upload_title": "Upload Your Video",
  "analysis_upload_subtitle": "MP4, MOV, AVI, MKV - up to 100MB",
  "analysis_upload_btn": "Select Video",
  "analysis_cost": "Cost: 3 AI-Coins per analysis",
  "analysis_analyzing": "Analyzing your gameplay...",
  "analysis_wait": "AI is processing your video. This may take a few minutes.",
  "analysis_start": "Analyze Gameplay",
  "analysis_result_title": "Analysis Result",
  "analysis_new": "New Analysis",
  "analysis_see_details": "See details",
  "history_title": "Evolution",
  "history_subtitle": "Review your evolution",
  "history_empty": "No analyses yet",
  "history_unknown_date": "Unknown date",
  "settings_profile": "Profile",
  "settings_role_admin": "Administrator",
  "settings_role_user": "Player",
  "settings_edit": "Edit",
  "settings_save": "Save",
  "settings_cancel": "Cancel",
  "settings_name": "Name",
  "settings_photo_url": "Photo URL",
  "settings_change_photo": "Change photo",
  "settings_logout": "Sign Out",
  "settings_admin_panel": "Admin Panel",
  "settings_admin_subtitle": "Management & KPIs",
  "settings_language_section_title": "App language",
  "settings_language_section_subtitle": "Global UI and AI preference",
  "settings_main_game_title": "Main game",
  "settings_main_game_subtitle": "Defines active Coach and Sensi context",
  "settings_save_game": "Save game",
  "settings_back_to_hub": "Continue in Coach",
  "referral_title": "Refer & Earn",
  "referral_subtitle": "Earn 15% commission from every purchase your referral makes",
  "referral_subtitle_user": "Earn AI-Coins for every referral!",
  "referral_your_link": "Your referral link",
  "referral_share": "Share Link",
  "referral_referred": "Referred",
  "referral_earned": "Coins Earned",
  "referral_info": "Your friend gets +5 extra welcome coins. You earn 15% cash commission from every purchase they make.",
  "referral_info_user": "Your friend gets +5 extra welcome coins. You earn 5 AI-Coins for every confirmed referral.",
  "referral_share_text": "Use my link and get 5 extra AI-Coins welcome bonus!",
  "referral_share_now": "SHARE NOW",
  "pricing_title": "Recharge Your Coins",
  "pricing_subtitle": "Credits to use the AI Coach",
  "pricing_coins": "coins",
  "pricing_buy": "Buy",
  "pricing_popular": "Popular",
  "pricing_best": "Best Value",
  "pricing_processing": "Processando...",
  "pricing_page_title": "Plans & Pricing",
  "pricing_page_subtitle": "Choose the best plan for your pro journey",
  "pricing_tab_plans": "Monthly Plans",
  "pricing_tab_packages": "Coin Packs",
  "pricing_subscribe": "Subscribe",
  "pricing_current_plan": "Current Plan",
  "pricing_subscription_info": "Monthly subscription. Cancel anytime. Coins credited on renewal.",
  "pricing_cancel_sub": "Cancel Subscription",
  "pricing_cancel_confirm": "Are you sure? You will keep access until the end of the period.",
  "pricing_cancel_success": "Subscription will cancel at end of billing period.",
  "pricing_active_plan": "Active Plan",
  "pricing_next_renewal": "Next renewal",
  "pricing_access_until": "Access until",
  "pricing_status_canceling": "Cancellation scheduled",
  "pricing_manage_sub": "Manage Subscription",
  "error_credits_title": "Insufficient Credits",
  "error_credits_msg": "You need more AI-Coins to use this feature.",
  "error_credits_buy": "Buy AI-Coins",
  "error_credits_close": "Fechar",
  "error_analysis_title": "Analysis error",
  "error_retry": "Retry",
  "error_close": "Fechar",
  "error_upload_video": "Upload error",
  "error_analysis_unavailable": "Analysis unavailable",
  "admin_title": "Admin Panel",
  "admin_choose": "What would you like to view?",
  "admin_revenue": "Revenue & KPIs",
  "admin_revenue_desc": "Financial and performance metrics",
  "admin_users": "Manage Users",
  "admin_users_desc": "Access and credits control",
  "admin_back": "Back",
  "admin_kpis": "KPIs",
  "admin_total_users": "Total Users",
  "admin_total_revenue": "Total Revenue",
  "admin_total_analyses": "Total Analyses",
  "admin_avg_credits": "Avg Credits",
  "admin_user_list": "User List",
  "admin_search": "Search by email...",
  "admin_role": "Role",
  "admin_credits": "Credits",
  "admin_actions": "Actions",
  "admin_edit": "Editar",
  "admin_add_credits": "Add Credits",
  "admin_amount": "Amount",
  "admin_confirm": "Confirm",
  "loading_text": "Loading...",
  "common_game_pro_hub": "GAME PRO HUB",
  "lang_label": "Language",
  "language_updated": "Language updated",
  "language_update_failed": "Failed to update language.",
  "status_label_coach": "Coach",
  "status_label_sensi": "Sensi-IA",
  "status_unknown": "Status unavailable",
  "status_retest_required": "Retest recommended",
  "status_completed": "Completed",
  "status_processing": "Processing",
  "status_failed": "Failed",
  "status_pending": "Pending",
  "status_insufficient_evidence": "Insufficient evidence",
  "status_low_confidence": "Low confidence",
  "status_done": "Completed",
  "status_queued": "Queued",
  "status_uploading": "Uploading",
  "hub_stories_recent": "RECENT STORIES",
  "hub_stories_subtitle": "Review the key points from your analyses.",
  "hub_mi_plan": "MI PLAN",
  "hub_last_analysis": "LAST ANALYSIS",
  "hub_sensi_status": "SENSI STATUS",
  "hub_training_recommended": "RECOMMENDED TRAINING",
  "hub_real_evolution": "REAL EVOLUTION",
  "hub_recent_history": "RECENT HISTORY",
  "hub_quick_actions": "QUICK ACTIONS",
  "hub_no_recent_analysis": "No recent analysis",
  "hub_first_analysis_cta": "Run your first analysis",
  "hub_stories_empty": "Complete an analysis to generate performance stories.",
  "hub_plan_priority": "Current priority",
  "hub_plan_next_action": "Next action",
  "hub_plan_reason": "Reason",
  "hub_no_analysis_yet": "No analysis yet",
  "hub_last_activity": "Latest activities",
  "hub_summary_fast": "Quick summary",
  "hub_metrics_player": "Player metrics",
  "hub_choose_next_step": "Choose the next step",
  "hub_open_analysis": "Open analysis",
  "hub_view_all": "View all",
  "hub_focus": "Focus",
  "hub_why_this_training": "Why this training",
  "hub_confidence": "Confidence",
  "hub_retake_test": "Retake test",
  "hub_view_result": "View result",
  "hub_optimize_sensi": "Optimize sensi",
  "hub_start_now": "Start now",
  "hub_no_data_enough": "Not enough data",
  "hub_trainings_done": "Trainings completed",
  "hub_streak": "Streak",
  "hub_strongest_point": "Strongest point",
  "hub_weakest_point": "Weakest point",
  "hub_no_summary_available": "No summary available.",
  "hub_no_activity_yet": "No recent activity logged.",
  "hub_no_detailed_adjustments": "No detailed adjustments",
  "hub_no_analysis_release": "Send an analysis to unlock Mi diagnostics and recommendations.",
  "hub_first_analysis_plan": "Run your first analysis so Mi can build your plan.",
  "hub_first_analysis_history": "As soon as you finish an analysis, history appears here.",
  "hub_analyze_gameplay": "Analyze gameplay",
  "hub_start_training": "Start training",
  "hub_recharge_coins": "Recharge AI-Coins",
  "hub_send_analysis_for_mi": "Send a new analysis to receive Mi guidance.",
  "history_untitled": "Untitled analysis",
  "settings_language_saved": "Language updated.",
  "settings_display_name": "Display name",
  "settings_display_name_placeholder": "Your in-game name",
  "settings_profile_updated": "Profile updated!",
  "settings_empty_name": "Name cannot be empty!",
  "settings_connection_error": "Connection error.",
  "settings_max_photo_size": "Maximum 5MB.",
  "settings_main_game_updated": "Main game updated!",
  "settings_main_game_failed": "Failed to update main game.",
  "settings_account_preferences": "Account and Preferences",
  "settings_account_summary": "Account details",
  "settings_section_account": "Account",
  "settings_section_subscription": "Subscription",
  "settings_section_tools": "Tools",
  "settings_section_support": "Support",
  "settings_section_configuration": "Settings",
  "settings_active_subscription": "Active subscription",
  "settings_plan_payment": "Plan and payment",
  "settings_premium_status": "Premium status",
  "settings_payment_pending": "Payment pending",
  "settings_next_renewal": "Next renewal",
  "settings_processing": "Processing...",
  "settings_become_pro": "Become Pro",
  "settings_renew_pro": "Renew Pro",
  "settings_plan_free": "Free",
  "settings_plan_free_desc": "Free plan",
  "settings_plan_pro_monthly": "Pro Monthly",
  "settings_plan_pro_annual": "Pro Annual",
  "settings_plan_pro_lifetime": "Lifetime Supporter",
  "settings_plan_pro_lifetime_desc": "You have lifetime access to Game Pro Hub Pro resources.",
  "settings_plan_lifetime_status": "Permanent Pro access",
  "settings_lifetime_purchase_date": "Lifetime purchase",
  "settings_plan_pro_expired": "Pro expired",
  "settings_plan_pro_expired_desc": "Your Pro access has ended.",
  "settings_plan_single_payment": "One-time payment",
  "settings_plan_status_free": "Free",
  "settings_plan_status_expired": "Expired",
  "settings_logout_short": "Sign out",
  "email_verify_title": "Confirm your email",
  "email_verify_subtitle": "We sent an activation link to your account. Confirm your email to unlock access to Game Pro Hub.",
  "email_verify_sent_to": "Link sent to",
  "email_verify_instruction": "Open your inbox and click the confirmation link. If you can't find it, check spam or junk mail as well.",
  "email_verify_cta": "I have confirmed my email",
  "email_verify_resend": "Resend link",
  "email_verify_resent": "Link resent. Check your inbox.",
  "email_verify_back_login": "Back to login",
  "terms_title": "Legal terms",
  "terms_subtitle": "LGPD and security protocol",
  "terms_user_terms": "Terms of use",
  "terms_privacy": "Privacy",
  "terms_not_loaded": "Terms not loaded.",
  "terms_scroll_bottom": "Scroll to the end",
  "terms_acceptance_text": "I have read and fully accept the Terms of Use and Privacy Policy.",
  "terms_accept_continue": "Accept and continue",
  "terms_syncing": "Syncing terms...",
  "terms_accept_error": "Failed to accept terms.",
  "app_payment_confirmed": "Success! Payment was confirmed and your access is unlocked.",
  "app_payment_processing": "Payment is processing. Access will be unlocked as soon as Stripe completes it.",
  "app_payment_received": "Payment received! Your access will sync shortly.",
  "app_payment_error": "Error processing payment.",
  "app_subscription_error": "Error processing subscription.",
  "app_privileged_no_charge": "Admin/partner account has full free access. No charge is needed.",
  "app_privileged_no_subscription": "Admin/partner account has full free access. No subscription is needed.",
  "app_privileged_calculator_unlocked": "Admin/partner account has full free access. The calculator is already unlocked.",
  "app_privileged_no_purchase": "Admin/partner account has full free access. No purchase is needed.",
  "app_pubg_lifetime_error": "Error starting lifetime Calculator purchase.",
  "app_freefire_lifetime_error": "Error starting lifetime FPS Mobile (Beta) Calculator purchase.",
  "checkout_error_open": "Could not open checkout right now. Please try again.",
  "checkout_error_unavailable_product": "This product is not available right now.",
  "checkout_error_connection": "Connection failed. Check your internet and try again.",
  "app_video_too_large": "Video too large! The limit is 200MB (approx. 2 min).",
  "app_premium_required": "Premium access is required to continue.",
  "app_view_plans": "View plans",
  "app_pubg_calc_title": "FPS Mobile (Alpha) Calculator",
  "app_pubg_calc_subtitle": "Pro: 15 monthly uses. Lifetime: unlimited use.",
  "app_freefire_calc_title": "FPS Mobile (Beta) Calculator",
  "app_freefire_calc_subtitle": "Pro: 5 monthly uses. Lifetime: unlimited use.",
  "app_back": "Back",
  "app_analysis_starting": "Starting analysis protocols...",
  "app_file_too_large_title": "File too large",
  "app_coach_video_limit_message": "The Mi Coach video limit is {{maxMb}}MB to keep AI processing stable. Reduce or compress the video.",
  "app_mi_analysis_title": "Mi Analysis",
  "app_mi_analysis_ready": "Mi Analysis ready",
  "app_syncing_mi": "Syncing with Mi...",
  "app_insufficient_balance": "Insufficient balance.",
  "app_email_not_verified_title": "Email not verified",
  "app_email_not_verified_coach": "Verify your email before using Coach.",
  "app_coach_pro_required_message": "This analysis requires **Pro Access** to run.\n\n{{costMsg}}\n\nIt shows exactly where you need to improve.",
  "app_coach_credit_required_message": "This analysis costs **{{cost}} Pro Access**.\n\nYour current balance: **{{credits}} Pro Access**.\n\nGet more Pro Access to continue.",
  "app_coach_credit_error_message": "This analysis costs **{{cost}} Pro Access**.\n\n{{error}}\n\nGet more Pro Access to continue.",
  "app_analysis_background_sync": "The analysis is still running in the background. You can keep this screen open.",
  "app_analysis_in_progress_reason": "Analysis in progress ({{reason}})...",
  "app_analysis_monitor_fallback": "Fallback monitor: syncing analysis status...",
  "app_analysis_processing_failed": "Analysis processing failed.",
  "app_analyzing": "Analyzing...",
  "app_connection_restored_analysis": "Connection restored. Reconnecting analysis...",
  "app_connection_restored_sensi": "Connection restored. Reconnecting Sensi monitor...",
  "app_critical_error_detected": "Critical error detected.",
  "app_job_syncing": "Syncing status...",
  "app_mi_context_alert": "ALERT",
  "app_mi_context_analyzed": "ANALYZED",
  "app_mi_context_coach": "VIDEO ANALYSIS",
  "app_mi_context_hub": "MAIN HUB",
  "app_mi_context_tools": "TOOLS",
  "app_mi_context_os": "MI OS",
  "app_mi_context_processing": "PROCESSING",
  "app_mi_context_profile": "SETTINGS",
  "app_mi_context_sensi": "OPTIMIZER",
  "app_mi_context_syncing": "SYNCING",
  "app_mi_context_system": "OPERATING SYSTEM",
  "app_mi_context_training": "TRAINING MODULE",
  "app_mi_msg_coach": "Ready to review your match.",
  "app_mi_msg_hub": "Monitoring your performance...",
  "app_mi_msg_tools": "Choose a tool for the next step.",
  "app_mi_msg_profile": "Managing account protocols.",
  "app_mi_msg_sensi": "Calibrating ballistic patterns...",
  "app_mi_msg_training": "What should today's routine focus on?",
  "app_mi_syncing": "Mi is syncing...",
  "app_mi_waiting_for_you": "Mi is waiting for you.",
  "app_privileged_retry": "Privileged access detected. Try again.",
  "app_realtime_monitor_permission_fallback": "Real-time monitor permission failed. Using safe polling sync.",
  "app_realtime_monitor_polling_fallback": "Real-time monitor unavailable. Syncing by polling.",
  "app_reconnecting_after_return": "Reconnecting after returning to the app...",
  "app_reconnecting_analysis_count": "Reconnecting analysis... attempt {{count}}",
  "app_reconnecting_analysis_monitor": "Reconnecting analysis monitor...",
  "app_reconnecting_sensi_after_return": "Reconnecting Sensi after returning to the app...",
  "app_reconnecting_sensi_count": "Reconnecting Sensi... attempt {{count}}",
  "app_reconnecting_sensi_monitor": "Reconnecting Sensi monitor...",
  "app_sensi_background_sync": "Sensi-IA is still running in the background. Keep this screen open to sync.",
  "app_sensi_ballistic_start": "Starting ballistic calibration...",
  "app_sensi_diagnose_failed": "We could not generate the diagnosis right now.",
  "app_sensi_diagnosis_ready": "Sensi-IA diagnosis is ready.",
  "app_sensi_duplicate_processing": "A Sensi analysis is already processing.",
  "app_sensi_in_progress_reason": "Sensi in progress ({{reason}})...",
  "app_sensi_monitor_unavailable": "Sensi monitor unavailable.",
  "app_sensi_processing_failed": "Sensi processing failed.",
  "app_sensi_reading_report": "Mi is reading your report...",
  "app_sensi_refinement_ready": "Refinement ready.",
  "app_sensi_report_failed": "We could not complete the report-only analysis.",
  "app_sensi_select_video_or_no_video": "Select a video or continue without video.",
  "app_sensi_status_syncing": "Syncing Sensi-IA status...",
  "app_sensi_video_limit_message": "The Sensi-IA video limit is {{maxMb}}MB to keep processing stable.",
  "app_sensi_video_received_validation": "Video received. Validating and sending it for analysis...",
  "app_syncing": "Syncing...",
  "app_terms_acceptance_failed": "Failed to register terms acceptance ({{status}}).",
  "app_user_not_authenticated": "User is not authenticated.",
  "chat_connection_error_markdown": "I had a connection issue just now. Try again in a few seconds.",
  "chat_connection_error_short": "Connection error.",
  "chat_connection_retry": "Connection is unstable. Try again in a few seconds.",
  "chat_network_error": "Network error. Check your connection.",
  "chat_temporary_issue": "Sorry, I had a temporary issue. Try again.",
  "local_terms_privacy_content": "# Privacy Policy – Game Pro Hub\n\nLast updated: 04/01/2026\n\nThis policy explains how we process personal data to operate Game Pro Hub.\n\n## 1. Data collected\n* Name and email through Firebase Auth.\n* Payment information processed by Stripe. We do not store card data.\n* Gameplay videos and data sent for Mi analysis.\n* Training, analysis and progress history.\n\n## 2. Purpose\nWe use data to personalize recommendations, process payments, unlock access and generate progress reports.\n\n## 3. Sharing\nWe do not sell your data. We only share it with essential providers such as Google Cloud/Firebase, Stripe and AI services used for processing.\n\n## 4. Your rights\nYou may request access, correction, anonymization or deletion of your data under applicable law.\n\n## 5. Security\nWe use secure connections, access controls and protection practices to reduce misuse risk.",
  "local_terms_privacy_title": "Privacy Policy",
  "local_terms_user_content": "# Terms of Use – Game Pro Hub\n\nLast updated: 04/01/2026\n\nBy using Game Pro Hub, you confirm that you have read and agree to these terms.\n\n## 1. Purpose\nThe platform provides calculators, training, analysis and recommendations to improve performance in games such as FPS Mobile (Alpha), FPS Mobile (Beta) and FPS Mobile (Gamma).\n\n## 2. Account\nYou are responsible for the information you provide and for keeping your account secure. Sharing access or creating abusive accounts is not allowed.\n\n## 3. Payments\nSubscriptions and purchases are processed by Stripe. Cancellations stop future charges according to the rules of the selected plan.\n\n## 4. Conduct\nYou may not bypass systems, exploit bugs, copy content without permission or use the platform abusively.\n\n## 5. Intellectual property\nGame Pro Hub content, flows, methods and materials belong to the platform or its licensors.\n\n## 6. Privacy\nYour data is processed according to the privacy policy and applicable law.\n\n## 7. Acceptance\nContinued use of the platform confirms your acceptance of these terms.",
  "local_terms_user_title": "Terms of Use",
  "sensi_free_limit_message": "You used your free Sensi-IA analyses. Subscribe to Pro to continue.",
  "sensi_feedback_save_retry": "We could not save your feedback right now. Try again.",
  "sensi_refine_retry": "We could not generate the next adjustment right now. Try again.",
  "sensi_select_video_to_continue": "Select a video to continue.",
  "sensi_selected_problems": "Selected problems",
  "sensi_unsupported_video_format": "Unsupported format. Send an MP4, iPhone MOV or WebM.",
  "sensi_values_summary": "Values summary",
  "pricing_access": "Access",
  "pricing_auto_unlock": "Automatic unlock after confirmation",
  "pricing_benefits_summary": "Benefits summary",
  "pricing_buy_now": "Buy now",
  "pricing_clear_price": "Clear pricing, no surprises",
  "pricing_clear_cost_short": "Clear pricing",
  "pricing_coin_rate_suffix": "{{value}} coin/val",
  "pricing_fast_activation": "Fast activation",
  "pricing_freefire_lifetime_fallback_title": "Lifetime FPS Mobile (Beta) Calculator",
  "pricing_full_access": "Full access",
  "pricing_full_ai_calculator_access": "Full access to AI and Calculator",
  "pricing_gph_access": "Game Pro Hub access",
  "pricing_gph_plans": "Game Pro Hub plans",
  "pricing_no_plan_available": "No plan available right now.",
  "pricing_one_time_payment": "One-time payment",
  "pricing_one_time_purchase": "One-time purchase",
  "pricing_per_month_short": "/month",
  "pricing_plans_access": "Plans and access",
  "pricing_pro_access": "Pro Access",
  "pricing_pro_subscription": "Pro Subscription",
  "pricing_pubg_lifetime_fallback_title": "Lifetime FPS Mobile (Alpha) Calculator",
  "pricing_purchase_assurances": "Purchase assurances",
  "pricing_secure_checkout": "Secure checkout",
  "pricing_secure_stripe": "Secure payment via Stripe",
  "pricing_product_unavailable": "Unavailable right now",
  "pricing_amount_loading": "Loading price...",
  "pricing_amount_unavailable_retry": "Price unavailable right now. Please try again.",
  "pricing_catalog_error_notice": "Price unavailable right now. Please try again.",
  "pricing_value_description": "Pro subscription or lifetime FPS Mobile (Alpha) Calculator with a one-time payment.",
  "pricing_subscribe_pro": "Subscribe Pro",
  "pricing_equivalent_monthly": "Equivalent to {{value}}.",
  "sensi_access": "Access",
  "sensi_access_blocked": "Access blocked",
  "sensi_access_pro_released": "Pro use unlocked",
  "sensi_action_increase": "Increase",
  "sensi_action_increase_infinitive": "Increase",
  "sensi_action_reduce": "Reduce",
  "sensi_action_reduce_infinitive": "Reduce",
  "sensi_adjustment_count": "{{count}} adjustments",
  "sensi_aim_question": "What is wrong with your aim?",
  "sensi_aim_question_desc": "Select what you feel while aiming or spraying.",
  "sensi_aim_report": "Aim report",
  "sensi_already_processing": "Sensi analysis is already processing.",
  "sensi_analysis_slow_notice": "If this takes longer than usual, keep this screen open. Mi is still processing.",
  "sensi_analysis_stopped": "Analysis stopped",
  "sensi_analysis_stopped_desc": "We could not finish the analysis right now.",
  "sensi_analyze": "Analyze",
  "sensi_analyzing_sensitivity": "Analyzing your sensitivity",
  "sensi_analyzing_sensitivity_desc": "Mi is reading your report and preparing a safe adjustment.",
  "sensi_apply_only_this_adjustment": "Apply only this adjustment before testing again.",
  "sensi_attached": "Attached",
  "sensi_calibration_success": "Your calibration was completed successfully.",
  "sensi_change_sentence": "{{action}} {{field}} by {{points}} points.",
  "sensi_confidence_label": "{{label}} confidence",
  "sensi_confidence_plain": "Confidence",
  "sensi_context_desc": "Details about your gameplay and test scenario.",
  "sensi_context_title": "Test context",
  "sensi_continue": "Continue",
  "sensi_continue_without_video": "Continue without video",
  "sensi_continue_without_video_desc": "Mi uses your report to generate a safe adjustment.",
  "sensi_control_gyro": "Gyroscope",
  "sensi_control_method": "Control method",
  "sensi_control_touch": "Finger",
  "sensi_copy_adjust": "{{label}}: {{action}}",
  "sensi_copy_adjust_with_values": "{{label}}: {{action}} ({{current}} -> {{target}})",
  "sensi_copy_increase_points": "increase by {{points}} points",
  "sensi_copy_insufficient_evidence": "{{label}}: not enough evidence",
  "sensi_copy_keep_almost_same_values": "{{label}}: keep almost the same ({{current}} -> {{target}})",
  "sensi_copy_keep_as_is": "{{label}}: keep as is",
  "sensi_copy_reduce_points": "reduce by {{points}} points",
  "sensi_current_values": "Current values",
  "sensi_current_values_desc": "Fill in the fields you want to calibrate.",
  "sensi_diagnose": "Diagnose",
  "sensi_diagnosis_summary_default": "Mi found an aim pattern to test safely.",
  "sensi_diagnosis_title": "Sensi-IA Diagnosis",
  "sensi_do_not_close": "Do not close this screen during analysis.",
  "sensi_duration": "Duration",
  "sensi_duration_5_10": "5 to 10 minutes",
  "sensi_expected_coverage": "What the video should show",
  "sensi_expected_coverage_desc": "Show the aim, spray, and test distance to increase precision.",
  "sensi_feedback_heavy": "It feels heavy",
  "sensi_feedback_improved": "Improved",
  "sensi_feedback_slow": "It feels slow",
  "sensi_feedback_msg_improved": "Good. Keep this adjustment and do one more drill before changing anything else.",
  "sensi_feedback_msg_same": "Got it. This feedback helps Mi choose the next step.",
  "sensi_feedback_msg_worse": "Understood. Do not change anything else right now. Mi will use this for the next adjustment.",
  "sensi_feedback_notes_placeholder": "Optional: describe what you felt after the drill...",
  "sensi_feedback_now_drops": "Now it drops",
  "sensi_feedback_overshoots": "Passes the target",
  "sensi_feedback_question": "After the drill, how did your aim feel?",
  "sensi_feedback_same": "Stayed the same",
  "sensi_feedback_saving": "Saving...",
  "sensi_feedback_shakes": "Shakes",
  "sensi_feedback_shakes_strong": "Shakes a lot",
  "sensi_feedback_still_rises": "Still rises",
  "sensi_feedback_worse": "Got worse",
  "sensi_final_review": "Final review",
  "sensi_fine_tune_active": "Fine-tune active",
  "sensi_fine_tune_extra_weight": "Mi will give this feedback more weight.",
  "sensi_fine_tune_good": "Perfect, it feels good!",
  "sensi_fine_tune_good_value": "It feels good",
  "sensi_finish_failed": "We could not finish the analysis.",
  "sensi_flow_intro_item_scope_swap": "Use the same scope as the problem",
  "sensi_flow_intro_item_target": "Test on a fixed target",
  "sensi_flow_intro_item_video": "Video is optional",
  "sensi_flow_intro_item_wall": "Report the main symptom",
  "sensi_flow_intro_title": "Tune your aim with Mi",
  "sensi_focus_label": "Focus",
  "sensi_follow_protocol_before_recalibrate": "Follow this in-game protocol before recalibrating.",
  "sensi_free_limit_desc": "You reached the free Sensi-IA limit for this month.",
  "sensi_free_limit_title": "Free limit reached",
  "sensi_free_remaining": "{{remaining}}/{{limit}} free",
  "sensi_free_remaining_verbose": "{{remaining}} of {{limit}} free analyses available",
  "sensi_game_question": "Which game do you want to adjust?",
  "sensi_game_question_desc": "Choose the game so Mi can build the right context.",
  "sensi_generate_next_adjustment": "Generate Mi's next adjustment",
  "sensi_generating_next_adjustment": "Generating next adjustment...",
  "sensi_generic_sensitivity": "sensitivity",
  "sensi_goal_desc": "Choose the focus so the recommendation is more precise.",
  "sensi_goal_title": "What is the goal of this adjustment?",
  "sensi_guided_flow": "MiraIA guided flow",
  "sensi_high_confidence": "High confidence",
  "sensi_how_to_calibrate_aim": "How to calibrate your aim",
  "sensi_how_to_test": "How to test",
  "sensi_initial_card_1_desc": "Tell Mi what happens with your aim.",
  "sensi_initial_card_1_title": "Report the problem",
  "sensi_initial_card_2_desc": "Share weapon, scope, distance, and current values.",
  "sensi_initial_card_2_title": "Add context",
  "sensi_initial_card_3_desc": "Get a conservative adjustment and a practical drill.",
  "sensi_initial_card_3_title": "Test safely",
  "sensi_initial_subtitle": "Sensitivity adjustment by report or video",
  "sensi_initial_title_prefix": "Protocol",
  "sensi_insufficient_evidence": "not enough evidence",
  "sensi_jitter_stability": "Jitter / stability",
  "sensi_keep_current_adjustment": "Keep the current adjustment.",
  "sensi_keep_other_sensitivities": "Do not change other sensitivities in this cycle.",
  "sensi_keep_reason": "This prevents changing too many values at once.",
  "sensi_keep_specific_fields": "Do not change {{fields}} in this cycle.",
  "sensi_legacy_all_good_desc": "The analysis did not find major errors. We recommend keeping the current values and refining in training.",
  "sensi_legacy_all_good_title": "Base looks good",
  "sensi_legacy_conservative_desc": "The video did not provide perfect data. Mi recommended a safe base for you to start from.",
  "sensi_legacy_conservative_title": "Conservative adjustment",
  "sensi_legacy_feedback_desc": "This prepares Mi for the next calibration.",
  "sensi_legacy_feedback_title": "Tested it? How did it feel?",
  "sensi_legacy_increase_scope": "Increase this scope by {{points}} points to reduce target acquisition delay.",
  "sensi_legacy_micro_adjustment": "Fine micro-adjustment. Apply it and validate with a short confirmation sequence.",
  "sensi_legacy_reduce_scope": "Reduce this scope by {{points}} points to control excess movement and improve stability.",
  "sensi_legacy_result_desc": "Mi analyzed your profile and generated a precise recommendation based on your combat movement.",
  "sensi_legacy_result_title": "Your sensitivity was adjusted",
  "sensi_legacy_retest_hint": "Repeat this test with a dedicated, uncut spray video for safer calibration.",
  "sensi_legacy_stability_desc": "There was too much jitter and over-correction. This suggests sensitivity is slightly high for your current motor control.",
  "sensi_legacy_stability_title": "Stability issue with {{scope}}",
  "sensi_legacy_tracking_delay_desc": "Your aim took too long to follow the target. This usually indicates low sensitivity, forcing you to drag too much with finger/gyro.",
  "sensi_legacy_tracking_delay_title": "Target acquisition delay with {{scope}}",
  "sensi_location": "Location",
  "sensi_marked_count": "{{count}} selected",
  "sensi_mi_diagnosis": "Mi diagnosis",
  "sensi_missing": "Pending",
  "sensi_new_training": "New drill",
  "sensi_next_question_default": "After testing, say whether it improved, got worse, or stayed the same.",
  "sensi_no_numeric_values": "No numeric value was filled in.",
  "sensi_no_video": "No video",
  "sensi_not_informed": "Not provided",
  "sensi_number_placeholder": "Ex: 50",
  "sensi_objectives": "Objectives",
  "sensi_observe_prefix": "Observe",
  "sensi_opencv_tracking_confidence": "OpenCV tracking confidence:",
  "sensi_optional_placeholder": "Optional",
  "sensi_other_sensitivity_values": "other sensitivities",
  "sensi_points_label": "{{points}} points",
  "sensi_pubg_diagnosis": "FPS Mobile (Alpha) diagnosis",
  "sensi_pubg_precision_mode": "FPS Mobile (Alpha) precision mode",
  "sensi_pubg_precision_desc": "Mi cross-checked video, weapon, scope, distance, and your control mode.",
  "sensi_pull_precision": "Pull precision",
  "sensi_recalibrate_now": "Recalibrate now",
  "sensi_recording_protocol": "Recording protocol",
  "sensi_redo_diagnosis": "Redo diagnosis",
  "sensi_increased": "Increased",
  "sensi_reduced": "Reduced",
  "sensi_refinement_hero_desc": "Mi used your feedback to build the next safe adjustment.",
  "sensi_report_hero_desc": "Mi analyzed your report and built a safe adjustment to test now.",
  "sensi_report_only_mode": "No-video mode",
  "sensi_report_only_mode_desc": "The analysis will use only your report. You can go back and send a video if you want.",
  "sensi_return_later": "Come back later",
  "sensi_review": "Review",
  "sensi_save_and_copy_all": "Save and copy all",
  "sensi_saved_and_copied": "Saved and copied",
  "sensi_screen_subtitle": "Sensitivity adjustment by report or video",
  "sensi_send_video": "Send video to help Mi",
  "sensi_send_video_desc": "The video is used as extra evidence to increase precision.",
  "sensi_start_calibration": "Start calibration",
  "sensi_step_counter": "Step {{current}} of {{total}}",
  "sensi_step_game": "Game",
  "sensi_step_game_subtitle": "Choose the game to calibrate",
  "sensi_step_goal": "Report",
  "sensi_step_goal_subtitle": "Tell Mi what happens with your aim",
  "sensi_step_context": "Context",
  "sensi_step_context_subtitle": "Add weapon, scope, and distance",
  "sensi_step_values": "Values",
  "sensi_step_values_subtitle": "Share your current sensitivities",
  "sensi_step_video_optional": "Optional video",
  "sensi_step_video_optional_subtitle": "Choose analysis with or without video",
  "sensi_step_review": "Review",
  "sensi_step_review_subtitle": "Confirm everything before analysis",
  "sensi_step_prefix": "Step {{step}}: {{title}}",
  "sensi_success_criterion": "Success criterion",
  "sensi_success_criterion_desc": "Do 10 long sprays (40m to 60m). The setup is calibrated if at least 7 sprays keep most shots on the target torso.",
  "sensi_symptom_aim_drops": "My aim drops",
  "sensi_symptom_aim_rises": "My aim rises",
  "sensi_symptom_aim_shakes": "My aim shakes",
  "sensi_symptom_cannot_track_enemy": "My aim cannot track the enemy",
  "sensi_symptom_close_range_difficulty": "Close-range issue",
  "sensi_symptom_first_bullets_miss": "First bullets miss",
  "sensi_symptom_gyro_difficulty": "Difficulty with gyro",
  "sensi_symptom_long_range_difficulty": "Long-range issue",
  "sensi_symptom_mid_range_difficulty": "Mid-range issue",
  "sensi_symptom_mid_spray_lost": "I lose control mid-spray",
  "sensi_symptom_no_gyro_difficulty": "I do not use gyro",
  "sensi_symptom_overshoots_target": "My aim passes the enemy",
  "sensi_symptom_placeholder": "Ex: my aim rises after the first bullets...",
  "sensi_symptom_spray_opens_horizontal": "My spray opens sideways",
  "sensi_symptom_spray_opens_vertical": "My spray opens up/down",
  "sensi_tab_analysis": "Sensi-IA",
  "sensi_tab_analysis_desc": "Diagnosis",
  "sensi_tab_pubg_calc": "FPS Mobile (Alpha)",
  "sensi_tab_pubg_calc_desc": "Calculator",
  "sensi_tap_to_attach_video": "Tap to attach video",
  "sensi_technical_reason": "Technical reason",
  "sensi_test_and_return_later": "Test and come back later",
  "sensi_test_before_change": "Test before changing",
  "sensi_test_same_scenario": "Test in training or arena with the same scenario as your report.",
  "sensi_test_weapon": "Test weapon",
  "sensi_today_training": "Today's drill",
  "sensi_tracking_label": "Tracking",
  "sensi_training_mode": "Training Mode",
  "sensi_training_step_note": "Write down whether the aim rose, dropped, shook, or became stable.",
  "sensi_training_step_only_adjustment": "Apply only the recommended adjustment.",
  "sensi_training_step_reps": "Do 10 controlled reps.",
  "sensi_training_step_same_scope": "Use the same scope and distance from the test.",
  "sensi_tutorial_start": "Got it, let's start",
  "sensi_tutorial_step_keep_center": "Try to keep the crosshair fixed in the center of the target.",
  "sensi_tutorial_step_no_edits": "Avoid cuts or edits in the original video.",
  "sensi_tutorial_step_red_dot": "Do a 30-shot spray with Red Dot.",
  "sensi_tutorial_step_scopes": "Repeat the spray with 2x, 3x, 4x, and 6x.",
  "sensi_tutorial_step_weapon": "Equip your favorite weapon in training mode.",
  "sensi_validation_test": "Validation test",
  "sensi_validation_training": "Validation drill",
  "sensi_vertical_recoil": "Vertical recoil",
  "sensi_video": "Video",
  "sensi_video_confirmed_title": "What the video helped confirm",
  "sensi_video_effect_default": "The video was used as support to adjust analysis confidence.",
  "sensi_video_failed_continued": "The video failed, but analysis continued from your report",
  "sensi_video_fallback": "Video fallback",
  "sensi_video_hero_desc": "Mi analyzed your report with the video as support to increase precision.",
  "sensi_video_physical_measurement": "Physical video measurement",
  "sensi_video_question": "Want to send a video?",
  "sensi_video_question_desc": "You do not have to. But if you send one, Mi understands your aim better.",
  "sensi_video_selected": "Video selected",
  "sensi_video_support": "Video used as support",
  "sensi_waiting_evidence": "Waiting for evidence",
  "sensi_weapon_placeholder": "Ex: M416",
  "sensi_what_change": "What to change",
  "sensi_what_change_now": "What to change now",
  "sensi_what_changed": "What changed",
  "sensi_what_keep": "What not to change now",
  "sensi_what_mi_saw": "What Mi noticed",
  "sensi_what_mi_saw_now": "What Mi noticed now",
  "sensi_processing_received": "Report received",
  "sensi_processing_received_desc": "Mi is organizing your aim context.",
  "sensi_processing_validated": "Data validated",
  "sensi_processing_validated_desc": "Checking game, weapon, scope, and current values.",
  "sensi_processing_signals": "Aim signals",
  "sensi_processing_signals_desc": "Identifying the main symptom and correct channel.",
  "sensi_processing_stability": "Adjustment safety",
  "sensi_processing_stability_desc": "Limiting the recommendation so it does not change too many values.",
  "sensi_processing_recommendation": "Drill and adjustment",
  "sensi_processing_recommendation_desc": "Building today's adjustment and drill.",
  "sensi_processing_finalizing": "Finalizing",
  "sensi_processing_finalizing_desc": "Preparing your diagnosis.",
  "sensi_diag_vertical_under": "Your aim is rising during the spray.",
  "sensi_diag_vertical_over": "Your aim is dropping during the spray.",
  "sensi_diag_instability": "Your aim is shaking or unstable.",
  "sensi_diag_overshoot": "Your aim is passing the target.",
  "sensi_diag_tracking_lag": "Your aim is not tracking the enemy.",
  "sensi_diag_vertical_spread": "Your spray is opening vertically.",
  "sensi_diag_horizontal_issue": "Your spray is opening sideways.",
  "sensi_diag_first_bullets": "The error appears in the first bullets.",
  "sensi_diag_mid_spray": "You lose control mid-spray.",
  "sensi_diag_close_range": "The difficulty appears up close.",
  "sensi_diag_mid_range": "The difficulty appears at mid range.",
  "sensi_diag_long_range": "The difficulty appears at long range.",
  "sensi_diag_gyro_mismatch": "Gyro control needs fine-tuning.",
  "sensi_diag_no_gyro": "Non-gyro control needs a more stable base.",
  "sensi_diag_improved_keep": "The adjustment improved your aim.",
  "sensi_diag_still_rising": "The aim is still rising.",
  "sensi_diag_now_drops": "The aim started dropping.",
  "sensi_diag_after_shakes": "The aim started shaking.",
  "sensi_diag_too_heavy": "The aim feels heavy.",
  "sensi_diag_after_overshoot": "The aim passed the target after the adjustment.",
  "sensi_diag_same_symptom": "The symptom stayed the same.",
  "sensi_diag_worsened": "The previous adjustment made control worse.",
  "sensi_diag_default": "Mi found a pattern to test safely.",
  "sensi_evidence_strong": "strong evidence",
  "sensi_evidence_moderate": "moderate evidence",
  "sensi_evidence_limited": "limited evidence",
  "sensi_retest_recommended": "new test recommended",
  "sensi_limited_evidence_estimate": "limited-evidence estimate",
  "sensi_precise_calibration": "precise calibration",
  "sensi_no_data": "no data",
  "sensi_no_evidence": "no evidence",
  "sensi_overflick_detected": "overflick detected",
  "sensi_retest_hint_label": "retest tip",
  "sensi_spray_segments_detected": "spray segments detected",
  "sensi_insufficient_scope_metrics": "not enough metrics for this scope",
  "sensi_missing_scope_adjustment": "no adjustment data for this scope",
  "sensi_scope_not_detected_video": "this scope was not identified in the video",
  "sensi_few_spray_moments": "few firing moments detected",
  "sensi_reliable_evidence": "reliable evidence",
  "sensi_helper_pubg_camera_no_scope": "Camera speed without ADS. Affects pre-aim and target entry.",
  "sensi_helper_pubg_red_dot": "Main control for short and mid-range fights with Red Dot/Holo.",
  "sensi_helper_pubg_scope2x": "Adjusts tracking and recoil at mid range with 2x.",
  "sensi_helper_pubg_scope3x": "Important for mid-range sprays and lateral control.",
  "sensi_helper_pubg_scope4x": "Critical sensitivity for long sprays and recoil stability.",
  "sensi_helper_pubg_scope6x": "Use a conservative value to avoid shaking at long range.",
  "sensi_helper_pubg_scope8x": "Extreme precision field. Adjustments should be minimal.",
  "sensi_helper_pubg_ads": "Control while firing without magnified scope (hipfire/base ADS).",
  "sensi_helper_pubg_gyro": "General gyroscope response before and during initial alignment.",
  "sensi_helper_pubg_gyro_fire": "Gyroscope during spray. Prioritize it if recoil rises or oscillates while firing.",
  "sensi_helper_ff_general": "Base pull and general aim response in FPS Mobile (Beta).",
  "sensi_helper_ff_red_dot": "Most sensitive field for headshot pull and fine pull tuning.",
  "sensi_helper_ff_scope2x": "Tracking and control at mid range.",
  "sensi_helper_ff_scope4x": "Long range with a focus on stability.",
  "sensi_helper_ff_sniper": "AWM/sniper precision. Small adjustments prevent excess movement.",
  "sensi_helper_ff_free_look": "Camera movement for reading the environment (not recoil).",
  "sensi_helper_cod_camera_standard": "Camera speed without firing in standard mode.",
  "sensi_helper_cod_camera_ads": "Camera during ADS for target acquisition.",
  "sensi_helper_cod_camera_tactical": "Camera with tactical scope for mid range.",
  "sensi_helper_cod_camera_sniper": "Camera for sniper and fine alignment.",
  "sensi_helper_cod_firing_standard": "Sensitivity while firing without a special scope.",
  "sensi_helper_cod_firing_ads": "Firing in ADS. Main recoil field in FPS Mobile (Gamma).",
  "sensi_helper_cod_firing_tactical": "Firing with tactical scope.",
  "sensi_helper_cod_firing_sniper": "Sniper firing requires conservative micro-adjustments.",
  "sensi_helper_cod_gyro_standard": "Base gyro for standard camera.",
  "sensi_helper_cod_gyro_ads": "Gyro during ADS.",
  "sensi_helper_cod_gyro_tactical": "Gyro for tactical scope.",
  "sensi_helper_cod_gyro_sniper": "Gyro on sniper. Avoid aggressive values.",
  "sensi_helper_cod_fov": "Field of view. It can change perceived aim speed.",
  "app_cancel": "Cancel",
  "coach_access_blocked": "Access blocked",
  "coach_access_full_library": "Unlock tracks, full training sessions, and saved progress to improve with structure.",
  "coach_adjust_filters": "Adjust the filters to see other library drills.",
  "coach_all_categories": "All categories",
  "coach_all_levels": "All levels",
  "coach_all_statuses": "All statuses",
  "coach_any_duration": "Any duration",
  "coach_avoid": "Avoid",
  "coach_choose_game_library": "Choose a game to see published tracks and drills.",
  "coach_common_mistakes": "Common mistakes",
  "coach_complete_onboarding_tracks": "Complete onboarding to sort the tracks.",
  "coach_complete_training_question": "Complete drill?",
  "coach_completed": "Completed",
  "coach_completed_plural": "Completed",
  "coach_completed_tracks": "Completed tracks",
  "coach_completed_trainings": "Completed drills",
  "coach_completion_rate": "Completion rate",
  "coach_configure": "Configure",
  "coach_configure_profile": "Configure profile",
  "coach_configure_profile_hint": "Configure your profile for better recommendations.",
  "coach_configure_profile_tracks": "Configure your profile to receive tracks.",
  "coach_days_count": "{{count}} days",
  "coach_default_tip": "Do the drill slowly first. When it feels clean, increase the speed.",
  "coach_duration_medium": "21 to 30 min",
  "coach_duration_short": "Up to 20 min",
  "coach_error_load_library": "We could not load the Mi Coach library right now.",
  "coach_error_open_track": "We could not open this track right now.",
  "coach_error_open_training": "We could not open this drill right now.",
  "coach_error_save_profile": "We could not save your profile right now. Try again shortly.",
  "coach_error_sync_progress": "We could not sync your progress right now.",
  "coach_error_update_saved": "We could not update your saved drills right now.",
  "coach_error_load_state": "We could not load your Coach profile. Please try again.",
  "coach_error_load_state_title": "Coach profile unavailable",
  "coach_try_again": "Try again",
  "coach_expected_learning": "You should learn",
  "coach_filter_hint": "Filter by category, level, or status.",
  "coach_finish": "Finish",
  "coach_finished_training_tracks": "Finished training tracks",
  "coach_for_who": "Who this is for",
  "coach_for_you": "For you",
  "coach_free": "Free",
  "coach_first_training_free_badge": "First training unlocked",
  "coach_start_free_training": "Start free training",
  "coach_full_content": "full content",
  "coach_full_pubg_library": "Full access to Coach training",
  "coach_game_fallback": "Game",
  "coach_game_library": "Game library",
  "coach_goal_prefix": "Goal",
  "coach_greeting": "Hi, {{name}}!",
  "coach_tagline": "Workouts, tracks, and progression",
  "coach_tagline_mobile": "Workouts and evolution",
  "coach_continue_training": "Continue training",
  "coach_level_advanced": "Advanced",
  "coach_level_beginner": "Beginner",
  "coach_level_competitive": "Competitive",
  "coach_level_intermediate": "Intermediate",
  "coach_library_for_game": "{{game}} library",
  "coach_library_games": "Library games",
  "coach_loading_detail": "Loading details...",
  "coach_loading_subtitle": "Syncing library and progress.",
  "coach_loading_title": "Loading Mi Coach",
  "coach_manage_subscription": "Manage subscription",
  "coach_mark_completed": "Mark as completed",
  "coach_mark_pending": "Mark as pending",
  "coach_mark_pending_question": "Mark as pending?",
  "coach_mark_pending_short": "Mark pending",
  "coach_mi_coach_pro": "Mi Coach Pro",
  "coach_mi_tip": "Mi tip",
  "coach_minutes_per_day": "{{minutes}} min/day",
  "coach_month_suffix": "/month",
  "coach_nav_games": "Games",
  "coach_nav_home": "Home",
  "coach_nav_library": "Library",
  "coach_nav_more": "More",
  "coach_more_title": "More Coach options",
  "coach_more_desc_active": "Open shortcuts and tune your routine.",
  "coach_more_desc_free": "Your free drill stays available here. Advanced Coach tools are Pro.",
  "coach_more_profile": "My Coach profile",
  "coach_more_profile_desc": "See your current focus and recommended drill.",
  "coach_more_profile_setup_desc": "Set your first profile to get a track.",
  "coach_more_games_desc": "Change the library context by game.",
  "coach_more_progress_desc": "See progress, completions, and categories.",
  "coach_more_saved_desc": "Continue the drills you marked.",
  "coach_more_retake_desc": "Recalibrate the track with new answers.",
  "coach_more_retake_locked_desc": "Redoing your Coach profile and recalibrating the track is a Pro feature.",
  "coach_more_unlock": "Unlock Pro",
  "coach_nav_progress": "Progress",
  "coach_nav_saved": "Saved",
  "coach_nav_tracks": "Tracks",
  "coach_next": "Next",
  "coach_no_completed_trainings": "No completed drills yet",
  "coach_no_completed_trainings_desc": "Open a premium drill and mark it as completed after finishing the steps.",
  "coach_no_fixed_time": "No fixed time",
  "coach_no_training_found": "No drill found",
  "coach_nothing_saved": "Nothing saved yet",
  "coach_objective": "Objective",
  "coach_of_library": "of the library",
  "coach_of_total": "of {{total}}",
  "coach_open_training": "Open drill",
  "coach_open_training_eyebrow": "Open drill",
  "coach_open_youtube": "Open on YouTube",
  "coach_overall_evolution": "Overall evolution",
  "coach_pending_plural": "Pending",
  "coach_premium": "Premium",
  "coach_prerequisites": "Prerequisites",
  "coach_pro_active": "Pro active",
  "coach_pro_subscription": "Pro subscription",
  "coach_processing_answers": "Answers received",
  "coach_processing_libraries": "Game libraries mapped",
  "coach_processing_progress": "Progress ready to save",
  "coach_processing_title": "Analyzing your profile",
  "coach_processing_tracks": "Existing tracks selected",
  "coach_profile_pending": "Profile pending",
  "coach_progress_by_category": "Progress by category",
  "coach_progress_percent": "Progress {{percent}}%",
  "coach_progress_saved_hint": "Your history stays saved even without active premium access.",
  "coach_progress_trainings_count": "{{completed}}/{{total}} drills",
  "coach_published_trainings_count": "{{count}}+ published drills",
  "coach_reactivate_access": "Reactivate access",
  "coach_reactivate_full_access": "Reactivate to access the full library content.",
  "coach_recent_achievements": "Recent achievements",
  "coach_recommended": "Recommended",
  "coach_recommended_tracks": "Recommended tracks",
  "coach_redo_onboarding": "Redo onboarding",
  "coach_save_continue": "Save / continue",
  "coach_save_from_library": "Save drills from the library to continue later.",
  "coach_save_training": "Save drill",
  "coach_saved_continue": "Saved / continue",
  "coach_saved_trainings": "Saved drills",
  "coach_saved_trainings_desc": "Continue the drills you marked.",
  "coach_search_reference": "Search reference",
  "coach_search_training": "Search drill",
  "coach_sections_aria": "Mi Coach sections",
  "coach_sign_in_desc": "Use your Game Pro Hub account to save profile, progress, and drills.",
  "coach_sign_in_title": "Sign in to your account",
  "coach_start_now": "Start now",
  "coach_step_by_step": "Step by step",
  "coach_step_counter": "{{current}} of {{total}}",
  "coach_subscribe_now": "Unlock Coach Pro",
  "coach_subscription_inactive": "Your subscription is not active.",
  "coach_success_criteria": "How to know you did it right",
  "coach_support_material": "Support material",
  "coach_support_material_desc": "Use it before training to understand the concept and after training to correct details.",
  "coach_support_reference_avoid": "Avoid focusing only on sensitivity without understanding the logic behind the mechanic.",
  "coach_support_reference_label": "Reference",
  "coach_support_reference_learning": "Understand the strategic concept of the drill and apply it consciously in matches.",
  "coach_support_reference_title": "Search concept and checklist",
  "coach_support_reference_watch": "Study the theory behind this foundation, focusing on prior positioning, crosshair, and execution checklist.",
  "coach_support_unavailable": "Material unavailable for this drill.",
  "coach_support_video_avoid": "Avoid fast-edited highlights that hide the initial positioning.",
  "coach_support_video_label": "Technical video",
  "coach_support_video_learning": "Understand reaction timing and the physical adjustments needed during the drill.",
  "coach_support_video_title": "Watch practical demonstration",
  "coach_support_video_watch": "Watch the visual execution of the mechanic, focusing on aim position and firing rhythm.",
  "coach_total_mastered_trainings": "Total mastered drills",
  "coach_track_detail": "Track detail",
  "coach_track_trainings": "Track drills",
  "coach_tracks_and_progress": "Tracks and progress",
  "coach_tracks_label": "tracks",
  "coach_training_count_plus": "{{count}}+ drills",
  "coach_training_objective": "Drill objective",
  "coach_training_progress": "Training progress",
  "coach_trainings_found": "{{count}} drills found",
  "coach_trainings_label": "drills",
  "coach_updating_library": "Updating library...",
  "coach_view_all": "View all",
  "coach_welcome_eyebrow": "Smart training library",
  "coach_welcome_subtitle": "Choose a library, a track, or follow Mi's recommendations.",
  "coach_welcome_title": "Drills to improve your game.",
  "coach_what_to_watch": "What to watch",
  "coach_onboarding_game_eyebrow": "Game choice",
  "coach_onboarding_game_title": "Which game do you play?",
  "coach_onboarding_game_subtitle": "Choose the main library.",
  "coach_onboarding_game_pubg_desc": "Recoil, CQC, rotation, cover, and ranked.",
  "coach_onboarding_game_cod_desc": "Recoil, tracking, ranked MP, and battle royale.",
  "coach_onboarding_game_ff_desc": "Capa, rush, x1, shotgun, and ranked.",
  "coach_onboarding_level_eyebrow": "Current level",
  "coach_onboarding_level_title": "What is your current level?",
  "coach_onboarding_level_subtitle": "This calibrates track difficulty.",
  "coach_onboarding_level_beginner_desc": "I am just starting.",
  "coach_onboarding_level_intermediate_desc": "I have experience and want consistency.",
  "coach_onboarding_level_advanced_desc": "I play regularly and want fine tuning.",
  "coach_onboarding_level_competitive_desc": "I want performance in ranked or scrim.",
  "coach_onboarding_pain_eyebrow": "Main difficulty",
  "coach_onboarding_pain_title": "What is your biggest difficulty?",
  "coach_onboarding_pain_subtitle": "Choose the pain that appears most in matches.",
  "coach_pain_recoil": "Aim / Recoil",
  "coach_pain_recoil_desc": "Spray rises, shakes, or leaves the target.",
  "coach_pain_movement": "Movement",
  "coach_pain_movement_desc": "I lose fights because of entry or bad strafe.",
  "coach_pain_close_range": "CQC / Rush",
  "coach_pain_close_range_desc": "I die in houses, corridors, and close range.",
  "coach_pain_positioning": "Positioning",
  "coach_pain_positioning_desc": "I die in the open or without cover.",
  "coach_pain_decision": "Decision making",
  "coach_pain_decision_desc": "I force bad duels or take too long to reset.",
  "coach_pain_mental": "Focus / Tilt",
  "coach_pain_mental_desc": "I swing after a mistake or loss.",
  "coach_onboarding_objective_eyebrow": "Objective",
  "coach_onboarding_objective_title": "What is your objective?",
  "coach_onboarding_objective_subtitle": "The recommendation uses existing tracks.",
  "coach_objective_rank_up": "Rank up",
  "coach_objective_rank_up_desc": "Train to gain consistency in ranked.",
  "coach_objective_consistency": "Be more consistent",
  "coach_objective_consistency_desc": "Reduce swings between matches.",
  "coach_objective_better_kd": "Improve K/D",
  "coach_objective_better_kd_desc": "Win more duels without guaranteed promises.",
  "coach_objective_competitive": "Play competitive",
  "coach_objective_competitive_desc": "Adjust decision making, squad play, and pressure.",
  "coach_onboarding_time_eyebrow": "Available time",
  "coach_onboarding_time_title": "How much time can you train per day?",
  "coach_onboarding_time_subtitle": "Duration helps prioritize tracks.",
  "coach_time_30": "Up to 30 minutes",
  "coach_time_30_desc": "Short and focused blocks.",
  "coach_time_60": "30 to 60 minutes",
  "coach_time_60_desc": "Balanced routine.",
  "coach_time_90": "1 to 2 hours",
  "coach_time_90_desc": "More repetitions per category.",
  "coach_time_120": "2 hours or more",
  "coach_time_120_desc": "High training volume.",
  "coach_onboarding_setup_eyebrow": "Device / setup",
  "coach_onboarding_setup_title": "What is your device and setup?",
  "coach_onboarding_setup_subtitle": "Adjust for better recommendations.",
  "coach_setup_device": "Device",
  "coach_setup_mobile": "Phone",
  "coach_setup_fps": "Device FPS",
  "coach_setup_connection": "Connection",
  "coach_setup_mobile_data": "Mobile data",
  "coach_onboarding_style_eyebrow": "Play style",
  "coach_onboarding_style_title": "How do you usually play?",
  "coach_onboarding_style_subtitle": "This changes the order of the tracks.",
  "coach_style_aggressive": "Aggressive",
  "coach_style_aggressive_desc": "I look for entry and first contact.",
  "coach_style_balanced": "Balanced",
  "coach_style_balanced_desc": "I alternate fights, cover, and rotation.",
  "coach_style_tactical": "Tactical",
  "coach_style_tactical_desc": "I prioritize information, position, and zone.",
  "sensi_feedback_missing_session": "Sensi session not found to save feedback.",
  "sensi_feedback_auth_required": "Sign in again to save your feedback.",
  "sensi_feedback_save_failed": "We could not save your feedback right now.",
  "sensi_refine_missing_session": "Sensi session not found to generate refinement.",
  "sensi_refine_auth_required": "Sign in again to generate the next adjustment.",
  "sensi_refine_failed": "We could not generate the next adjustment right now.",
  "sensi_good_config_alert": "Configuration marked as good. Test it in real matches before recalibrating.",
  "mi_analysis_invalid_video_type": "Upload only MP4, MOV, or WEBM videos.",
  "mi_analysis_video_too_large": "The video exceeds the 200MB maximum limit.",
  "video_trim_timeout": "We could not trim this section. Try selecting a shorter segment.",
  "video_trim_failed": "Failed to process the video. Check your connection and try again.",
  "legal_terms_created": "Terms created successfully! Activate manually when ready.",
  "legal_terms_activated": "Version activated! All users will need to accept again.",
  "legal_error_prefix": "Error:",
  "legal_activate_confirm": "ATTENTION: Activating \"{{termType}} {{termVersion}}\" will force ALL users to accept again.\n\nDo you want to continue?",
  "settings_support_title": "Need help?",
  "settings_support_subtitle": "Talk to official Game Pro Hub support on WhatsApp.",
  "settings_support_cta": "Contact support",
  "settings_section_community": "Community",
  "settings_community_title": "Join the official community",
  "settings_community_desc": "Get news, drills, notices, and talk with other Game Pro Hub players.",
  "settings_community_cta": "Join the community",
  "settings_copy_link_prompt": "Copy your link:",
  "settings_partner_referrals": "Referrals",
  "settings_partner_earnings": "Earnings (R$)",
  "settings_control_panel": "Control Panel",
  "settings_control_panel_desc": "Manage system and network",
  "settings_partner_panel": "Partner Panel",
  "settings_partner_panel_desc": "Manage referrals and commissions",
  "arena_title": "Tools",
  "arena_subtitle": "Tactical tools for {{game}}.",
  "arena_coach_title": "Coach IA",
  "arena_coach_desc": "Library, tracks, and tactical analysis by game.",
  "arena_sensi_title": "Sensi-IA",
  "arena_sensi_desc": "Adjust your sensitivity by report or video.",
  "arena_pubg_calculator_title": "FPS Mobile (Alpha) Calculator",
  "arena_pubg_calculator_desc": "Calculate a sensitivity baseline for FPS Mobile (Alpha).",
  "arena_freefire_calculator_title": "FPS Mobile (Beta) Calculator",
  "arena_new_badge": "New",
  "arena_freefire_calculator_desc": "Calculate ideal sensitivity without AI.",
  "arena_mi_analysis_title": "Mi Analysis",
  "arena_mi_analysis_desc": "Send a gameplay clip and receive a diagnosis from Mi.",
  "arena_subscribe_pro": "Subscribe to Pro",
  "arena_subscribe_pro_desc": "Unlock the full Coach, Sensi-IA, and premium features.",
  "arena_pro_active": "Pro Plan Active",
  "arena_pro_active_desc": "Premium features unlocked.",
  "arena_recommended_title": "Recommended for You",
  "arena_tools_title": "Tools & Analysis",
  "arena_premium_title": "Subscription",
  "dashboard_no_records": "No records",
  "dashboard_now": "Just now",
  "dashboard_hours_ago": "{{count}}h ago",
  "dashboard_days_ago": "{{count}} days ago",
  "dashboard_recruit": "RECRUIT",
  "dashboard_pro_score": "Pro Score",
  "dashboard_points_abbr": "pts",
  "dashboard_progressive_system": "Progressive System",
  "dashboard_last_sessions": "Last 3 analyzed sessions",
  "dashboard_active_aim_telemetry": "Active aim telemetry",
  "dashboard_optimized": "Optimized",
  "dashboard_skill_matrix": "Skill Matrix",
  "dashboard_best_recorded": "Best recorded",
  "dashboard_syncing_sensors": "Syncing neural sensors...",
  "training_syncing_library": "Syncing library...",
  "training_library_title": "Mi Library",
  "training_recruit": "Recruit",
  "training_modules": "Modules",
  "training_completed": "Completed",
  "training_search_placeholder": "Search drills...",
  "training_completed_empty": "Complete drills to unlock favorites",
  "training_no_available": "No drills available for this game right now.",
  "training_back": "Back",
  "training_total_progress": "Total progress",
  "training_of": "of",
  "training_level": "Level",
  "training_not_found": "Drill not found",
  "training_level_1": "Beginner",
  "training_level_2": "Intermediate",
  "training_level_3": "Advanced",
  "training_mi_recommendation": "Mi recommendation",
  "training_focus_title": "What you will train",
  "training_focus_fallback": "Focus on perfect execution and correcting bad habits.",
  "training_why_title": "Why this matters",
  "training_why_fallback": "Small mistakes in this fundamental are a major cause of avoidable deaths in matches.",
  "training_how_title": "How to do it",
  "training_success_title": "How to know you did it right",
  "training_success_fallback": "The movement should flow smoothly and you should be able to eliminate the target without losing health.",
  "training_common_error_title": "Common mistake",
  "training_common_error_fallback": "Doing the movement too fast before focusing on precision.",
  "training_mi_tip": "Mi tip",
  "training_pro_reference": "Pro reference",
  "training_complete": "Complete training ✓",
  "training_mark_done": "Mark as done ⚡",
  "training_validate_execution": "Validate execution",
  "training_validate_execution_desc": "Send a video of your practice so Mi can validate your technique.",
  "training_analyze_with_mi": "Analyze with Mi",
  "training_group_core": "Core drills",
  "training_group_advanced": "Advanced skills",
  "training_group_competitive": "Competitive level",
  "training_group_system": "System and warmup",
  "training_cat_aim_name": "Aim and precision",
  "training_cat_aim_desc": "Flick shots, tracking, and micro-adjustments",
  "training_cat_recoil_name": "Recoil control",
  "training_cat_recoil_desc": "Spray control and recoil patterns",
  "training_cat_movement_name": "Movement",
  "training_cat_movement_desc": "Strafing, crouch, and jiggle peek",
  "training_cat_peek_name": "Peek and angles",
  "training_cat_peek_desc": "Shoulder peek and tactical angles",
  "training_cat_positioning_name": "Positioning",
  "training_cat_positioning_desc": "Cover, high ground, and zones",
  "training_cat_crosshair_name": "Crosshair Placement",
  "training_cat_crosshair_desc": "Pre-aim and crosshair position",
  "training_cat_prefire_name": "Pre-fire and reaction",
  "training_cat_prefire_desc": "Timing and reaction drills",
  "training_cat_cqb_name": "Close combat",
  "training_cat_cqb_desc": "CQB, hipfire, and room clearing",
  "training_cat_ranged_name": "Mid/long combat",
  "training_cat_ranged_desc": "DMR, sniper, and bullet drop",
  "training_cat_clutch_name": "Clutch scenarios",
  "training_cat_clutch_desc": "1vN and resource management",
  "training_cat_rotation_name": "Rotation and zone",
  "training_cat_rotation_desc": "Zone prediction and safer routes",
  "training_cat_entry_name": "Entry fragging",
  "training_cat_entry_desc": "First contact and trade kills",
  "training_cat_pressure_name": "High pressure",
  "training_cat_pressure_desc": "End-game and decisions under pressure",
  "training_cat_warmup_name": "Warmup",
  "training_cat_warmup_desc": "Complete pre-game routines",
  "training_cat_consistency_name": "Consistency",
  "training_cat_consistency_desc": "Error correction and habits",
  "training_impact": "Impact",
  "training_result_exceptional": "Exceptional",
  "training_result_very_good": "Very good",
  "training_result_good": "Good",
  "training_result_regular": "Regular",
  "training_result_needs_improvement": "Needs improvement",
  "training_result_critical": "Critical",
  "training_result_ai": "AI analysis result",
  "training_evaluated_skills": "Evaluated skills",
  "training_detailed_analysis": "Detailed analysis",
  "training_strengths": "Strengths",
  "training_weaknesses": "Weaknesses",
  "training_practical_corrections": "Practical corrections",
  "training_next_recommended": "Next recommended drill",
  "training_ask_coach": "Ask the Coach",
  "training_new_training": "New drill",
  "training_default_name": "drill",
  "training_coach_context": "I just completed the drill \"{{trainingName}}\" and received a {{score}}/100 score.\nMy weak points: {{weaknesses}}.\nI want to better understand what I can do to improve those points specifically.",
  "story_solid_performance": "Solid performance.",
  "story_room_to_improve": "There is room to improve.",
  "story_time_to_adjust": "Time to adjust.",
  "story_weakest_point": "Weakest point: {{label}}",
  "story_focus_first": "Focus here first to improve faster.",
  "story_main_insight": "Main insight",
  "story_no_detail": "No detailed analysis for this clip.",
  "story_metrics": "Your metrics",
  "story_second_insight": "Second insight",
  "story_train_weakest": "Train the weakest point.",
  "story_fix_now": "Ready to fix this now?",
  "story_previous": "Previous story",
  "story_continue": "Continue",
  "story_pause": "Pause",
  "story_next": "Next story",
  "story_paused": "Paused",
  "story_mi_summary": "Mi summary",
  "story_correction": "Correction",
  "story_action_fallback": "Apply the adjustment and validate it in a new test.",
  "kpi_aim": "Aim",
  "kpi_positioning": "Positioning",
  "kpi_decision": "Decision",
  "kpi_timing": "Timing",
  "kpi_movement": "Movement",
  "kpi_recoil": "Recoil",
  "pubg_calc_professional_title": "Professional calculator",
  "pubg_calc_professional_desc": "Use one baseline sensitivity and generate all other settings instantly.",
  "pubg_access_lifetime_active": "Lifetime active: unlimited use",
  "pubg_access_unlimited": "Access unlocked: unlimited",
  "pubg_access_pro_month": "{{count}}/15 calculations this month",
  "pubg_access_free_count": "{{count}}/2 free calculations",
  "pubg_access_free_weapons": "Free unlocks M416 and Honey Badger",
  "pubg_device_not_informed": "Device not provided",
  "pubg_control_gyro": "Gyro",
  "pubg_control_camera": "Scope / Camera while aiming",
  "pubg_control_mode": "Control mode",
  "pubg_primary_weapon": "Main weapon",
  "pubg_other_weapons": "Other weapons...",
  "pubg_base_scope": "Known base scope",
  "pubg_perfect_value": "Perfect sensitivity value",
  "pubg_device_model": "Device model",
  "pubg_optional_recommended": "Optional, recommended",
  "pubg_device_placeholder": "Ex: iPhone 17, Poco X6 Pro, Galaxy S26, Redmi Note 12...",
  "pubg_generating_panel": "Generating panel...",
  "pubg_calculate_config": "Calculate setup",
  "pubg_unlock_lifetime": "Unlock lifetime access",
  "pubg_generated": "Generated",
  "pubg_result_title": "FPS Mobile (Alpha) Result",
  "pubg_result_subtitle": "Values calculated from your base scope.",
  "pubg_recalculate": "Recalculate",
  "pubg_base_used": "Base used",
  "pubg_recommended_config": "Recommended setup",
  "pubg_scope": "Scope",
  "pubg_value": "Value",
  "pubg_type": "Type",
  "pubg_copy_config": "Copy setup",
  "pubg_fine_tune_sensi": "Fine tune with Sensi-IA",
  "pubg_test_tip": "Test the values in training for 5 min. If aim rises, drops, or shakes, use Sensi-IA to refine.",
  "pubg_calc_summary": "Calculation summary",
  "pubg_base_value": "Base value",
  "pubg_mode": "Mode",
  "pubg_weapon": "Weapon",
  "pubg_device": "Device",
  "pubg_tag_adjusted": "Adjusted",
  "pubg_tag_base": "Base",
  "pubg_tag_control": "Control",
  "pubg_tag_precision": "Precision",
  "pubg_tag_long_range": "Long range",
  "pubg_desc_rotation_precision": "Recommended for rotation and precision.",
  "pubg_desc_first_person": "Recommended for first-person control.",
  "pubg_desc_short_scope": "Main value for short scopes.",
  "pubg_desc_short_medium_spray": "Adjusted for short and medium spray.",
  "pubg_desc_mid_range": "Adjusted for medium-range control.",
  "pubg_desc_smooth_moves": "Use smoother movements.",
  "pubg_desc_stability": "Ideal for more stable control.",
  "pubg_desc_light_consistent": "Use light and consistent movements.",
  "pubg_desc_training_test": "Recommended value to test in training.",
  "pubg_desc_base_value": "Base value provided.",
  "pubg_pro_lifetime": "PRO / LIFETIME",
  "pubg_locked": "Locked",
  "pubg_error_value_range": "Perfect value must be between 1 and 500.",
  "pubg_error_scope_pro": "This scope is a Pro feature. Use Red Dot or 2x for free.",
  "pubg_error_access": "Failed to validate access. Please try again.",
  "pubg_error_calculate": "Error calculating. Please try again.",
  "pubg_notice_generated": "Dashboard generated successfully.",
  "pubg_error_session": "Session expired. Sign in again.",
  "pubg_error_connection": "Connection failed. Try again shortly.",
  "pubg_copy_title": "My FPS Mobile (Alpha) sensitivity - Game Pro Hub",
  "pubg_free_copy_note": "Only Red Dot and 2x are included in the Free trial. Get FPS Mobile (Alpha) Lifetime Calculator at Game Pro Hub for all scopes.",
  "pubg_notice_copied": "Values copied.",
  "pubg_error_copy": "Could not copy.",
  "security_eyebrow": "Security",
  "security_title": "Security at Game Pro Hub",
  "security_subtitle": "We protect your account, payments, and data so you can focus on improving in game.",
  "security_payments_title": "Secure payments",
  "security_payments_text": "Payments are processed by Stripe. Game Pro Hub does not store full card details.",
  "security_access_title": "Protected access",
  "security_access_text": "Authentication uses secure providers and we never ask for your game account password.",
  "security_data_title": "Responsible data use",
  "security_data_text": "We use data you send only to deliver analysis, training, history, and platform support.",
  "security_infra_title": "Monitored infrastructure",
  "security_infra_text": "The backend runs on monitored services and validated webhook flows before access is unlocked.",
  "security_transparency_title": "Transparency",
  "security_transparency_text": "Stripe identifiers stay on the backend and paid access depends on validated confirmation, never only on the success page.",
  "security_privacy_title": "Privacy best practices",
  "security_privacy_text": "Avoid sending sensitive data in videos. If you have questions, contact official support.",
  "security_notice_title": "Honest notice",
  "security_notice_text": "No system can promise absolute security, but we work to reduce risks and fix issues quickly.",
  "security_faq_title": "Quick questions",
  "security_faq_account_q": "Do I need to connect my game account?",
  "security_faq_account_a": "No. Game Pro Hub works without connecting your game account.",
  "security_faq_payment_q": "Who processes payment?",
  "security_faq_payment_a": "Stripe processes checkout and sends secure confirmations to the backend.",
  "security_faq_support_q": "How do I contact support?",
  "security_faq_support_a": "Use the support card in Profile or the official Game Pro Hub WhatsApp.",
  "security_cta_badge": "Ready to improve",
  "security_cta_title": "Create your account safely.",
  "security_cta_text": "Enter the hub and use Mi to train better without giving access to your game account.",
  "security_cta": "Create account safely",
  "security_have_account": "Already have an account?",
  "security_back_app": "Return to the app.",
  "mi_analysis_paywall_desc": "Send a short match and receive tactical diagnosis, mistakes by moment, and next recommended drills.",
  "mi_analysis_subscribe_pro": "Subscribe to Pro",
  "mi_analysis_processing_title": "Mi Analysis in progress",
  "mi_analysis_waiting_queue": "Waiting in the processing queue...",
  "mi_analysis_header_subtitle": "Technical gameplay diagnosis for {{game}}",
  "mi_analysis_upload_title": "Send your gameplay",
  "mi_analysis_upload_desc": "Use a clip with real combat, tactical decision-making, or a mistake you want to understand.",
  "mi_analysis_select_video": "Select video",
  "mi_analysis_formats": "MP4, MOV, or WEBM up to 200MB",
  "mi_analysis_confirm_title": "Confirm upload",
  "mi_analysis_confirm_desc": "Mi will analyze video, game context, and recent history.",
  "mi_analysis_file_size": "Size: {{size}} MB",
  "mi_analysis_change_video": "Change video",
  "mi_analysis_sending": "Sending...",
  "mi_analysis_send": "Send to Mi Analysis",
  "mi_analysis_history_title": "Mi Analysis history",
  "mi_analysis_no_date": "No date",
  "mi_analysis_history_fallback": "Gameplay analysis",
  "mi_analysis_report": "Report",
  "mi_analysis_empty": "No previous analysis recorded. Send your first video above.",
  "mi_analysis_back_arena": "Tools",
  "celebration_training_complete": "Training complete!",
  "celebration_next_training": "Next drill",
  "celebration_close": "Close"
};
const esES = {

  "landing_hero_badge": "IA para jugadores competitivos de FPS mobile",
  "landing_hero_title": "Deja de jugar como bot.",
  "landing_hero_subtitle": "Mi descubre el error de tu mira, indica el ajuste y te guía en el próximo entreno.",
  "landing_primary_cta": "Suscribir Pro por R$29,99",
  "landing_secondary_cta": "Probar gratis",
  "landing_hero_microcopy": "Menos que un snack. Más útil que cambiar sensibilidad por 14ª vez.",
  "landing_badge_diag": "Diagnóstico de mira",
  "landing_badge_sensi": "Ajuste de sensibilidad",
  "landing_badge_training": "Entreno guiado",
  "landing_badge_analysis": "Análisis de gameplay",
  "landing_pain_title": "El problema no es jugar poco. Es entrenar a ciegas.",
  "landing_pain_1_title": "La mira sube en el spray",
  "landing_pain_1_desc": "Compensas con el dedo, pero no sabes si el error es control o sensibilidad.",
  "landing_pain_2_title": "La sensibilidad cambia a cada rato",
  "landing_pain_2_desc": "Hoy 120, mañana 95, luego copias la de otro. Estrategia cero.",
  "landing_pain_3_title": "Entreno sin dirección",
  "landing_pain_3_desc": "Juegas mucho, pero repites el mismo error como si fuera calentamiento.",
  "landing_solution_title": "Mi corta las adivinanzas.",
  "landing_solution_desc": "Game Pro Hub conecta diagnóstico, sensibilidad, entreno y análisis en un flujo simple.",
  "landing_sol_step_1": "1. Di el problema",
  "landing_sol_step_2": "2. Recibe diagnóstico",
  "landing_sol_step_3": "3. Ajusta tu base",
  "landing_sol_step_4": "4. Entrena el punto débil",
  "landing_sol_step_5": "5. Analiza tu gameplay",
  "landing_sol_cta": "Empezar ahora",
  "landing_pro_title": "Free muestra el inicio. Pro libera el ciclo completo.",
  "landing_pro_value": "Pro por R$29,99/mes",
  "landing_pro_value_sub": "R$29,99/mes",
  "landing_pro_b1": "Diagnóstico con IA",
  "landing_pro_b2": "Ajustes de sensibilidad",
  "landing_pro_b3": "Entrenos guiados por Mi",
  "landing_pro_b4": "Análisis de gameplay",
  "landing_pro_b5": "Comunidad oficial en WhatsApp",
  "landing_pro_b6": "Soporte y Comunidad",
  "landing_pro_microcopy": "Si ya gastaste más que eso en skins, puedes invertir en tu mira.",
  "landing_7day_title": "7 días para dejar de disparar a ciegas.",
  "landing_7day_desc": "Un plan simple para romper el ciclo: perder, cambiar sensibilidad, repetir.",
  "landing_7d_1": "Día 1 — Descubre el error",
  "landing_7d_2": "Día 2 — Ajusta tu base",
  "landing_7d_3": "Día 3 — Entrena el punto débil",
  "landing_7d_4": "Día 4 — Valida en la práctica",
  "landing_7d_5": "Día 5 — Analiza gameplay",
  "landing_7d_6": "Día 6 — Corrije el error principal",
  "landing_7d_7": "Día 7 — Repite con más precisión",
  "landing_7day_cta": "Empezar mi plan Pro",
  "landing_community_title": "No tienes que descubrirlo todo solo.",
  "landing_community_desc": "Únete a la comunidad oficial de Game Pro Hub en WhatsApp, resuelve dudas y sigue actualizaciones.",
  "landing_comm_btn": "Entrar a la comunidad",
  "landing_comm_whatsapp_title": "Comunidad oficial en WhatsApp",
  "landing_comm_whatsapp_desc": "Intercambia ideas con otros jugadores competitivos de FPS mobile.",
  "landing_comm_support_title": "Soporte Prioritario",
  "landing_comm_support_desc": "Resuelve dudas y recibe orientación continua en el ecosistema.",
  "landing_faq_title": "Preguntas frecuentes",
  "landing_faq_q1": "¿Sirve para cualquier FPS mobile?",
  "landing_faq_a1": "Sí. El enfoque es mira, sensibilidad, entrenos y análisis de gameplay.",
  "landing_faq_q2": "¿Necesito ser avanzado?",
  "landing_faq_a2": "No. Tú dices el problema y Mi indica el siguiente paso.",
  "landing_faq_q3": "¿Cuánto cuesta el Pro?",
  "landing_faq_a3": "R$29,99 por mes.",
  "landing_faq_q4": "¿Puedo cancelar?",
  "landing_faq_a4": "Sí, según el flujo estándar de la plataforma.",
  "landing_faq_q5": "¿Tiene soporte?",
  "landing_faq_a5": "Sí. Cuentas con la comunidad oficial en WhatsApp y soporte prioritario para resolver dudas.",
  "landing_final_title": "Deja de cambiar sensibilidad por desesperación.",
  "landing_final_subtitle": "Entra a Game Pro Hub, sigue el plan de Mi y entrena con dirección.",
  "landing_final_cta_sec": "Crear cuenta gratis",
  "auth_title": "Accede a tu cuenta",
  "auth_subtitle": "Entra o crea tu cuenta para continuar.",
  "auth_player_name": "Nombre de Jugador",
  "auth_your_nickname": "Tu Nickname",
  "auth_email": "Correo",
  "auth_password": "Contraseña",
  "auth_login": "Entrar",
  "auth_create_account": "Crear Cuenta",
  "auth_or": "O",
  "auth_continue_google": "Continuar con Google",
  "auth_new_account": "Crear Nueva Cuenta",
  "auth_have_account": "Ya tengo cuenta",
  "auth_title_sign_in": "Entrar",
  "auth_title_register": "Crear cuenta",
  "auth_subtitle_sign_in": "Accede a tu cuenta",
  "auth_subtitle_register": "Completa para comenzar",
  "auth_email_placeholder": "Tu correo",
  "auth_password_placeholder": "Tu contraseña",
  "auth_missing_credentials": "Completa todos los campos.",
  "auth_sync_error": "Error de sincronización.",
  "auth_invalid_credentials": "Credenciales inválidas.",
  "auth_already_have_account": "¿Ya tienes cuenta? Entrar",
  "auth_no_account": "¿No tienes cuenta? Crear una",
  "auth_secure_access": "ACCESO SEGURO",
  "auth_error_generic": "No pudimos iniciar sesión ahora. Inténtalo de nuevo.",
  "auth_error_fill_email_password": "Completa tu e-mail y contraseña.",
  "auth_error_email_in_use": "Este e-mail ya tiene una cuenta. Usa Entrar con e-mail.",
  "auth_error_check_credentials": "No pudimos iniciar sesión ahora. Revisa tus datos e inténtalo de nuevo.",
  "auth_error_weak_password": "Usa una contraseña de al menos 6 caracteres.",
  "auth_error_invalid_email": "Escribe un e-mail válido.",
  "auth_error_reset_email_required": "Escribe tu e-mail para recuperar la contraseña.",
  "auth_error_user_not_found": "No encontramos una cuenta con ese e-mail.",
  "auth_error_reset_failed": "No pudimos enviar el e-mail ahora. Inténtalo de nuevo.",
  "auth_safety_badge": "Seguro, directo y sin contraseña del juego",
  "auth_headline": "Entrena para evolucionar, evoluciona para ganar",
  "auth_subheadline": "Entra, elige tu juego y recibe ayuda para ajustar tu mira y entrenar mejor.",
  "auth_benefits_aria": "Beneficios de Game Pro Hub",
  "auth_benefit_aim": "Corrige tu mira",
  "auth_benefit_training": "Recibe entrenamientos simples",
  "auth_benefit_progress": "Acompaña tu evolución",
  "auth_microcopy": "Mi te ayuda a entender qué cambiar y cómo entrenar.",
  "auth_panel_aria": "Login y registro",
  "auth_reset_eyebrow": "Recuperar contraseña",
  "auth_reset_title": "Te enviaremos un enlace",
  "auth_reset_desc": "Escribe el e-mail de tu cuenta para recibir las instrucciones.",
  "auth_sending": "Enviando...",
  "auth_send_link": "Enviar enlace",
  "auth_email_sent_title": "E-mail enviado",
  "auth_email_sent_desc": "Revisa tu bandeja de entrada y spam.",
  "auth_back_to_login": "Volver al login",
  "auth_free_account": "Cuenta gratis",
  "auth_welcome_back": "Bienvenido de vuelta",
  "auth_create_free_account": "Crear cuenta gratis",
  "auth_email_login": "Entrar con e-mail",
  "auth_register_desc": "Empieza con Google o usa e-mail y contraseña.",
  "auth_login_desc": "Continúa tu evolución en Game Pro Hub.",
  "auth_google": "Entrar con Google",
  "auth_or_email": "o usa e-mail",
  "auth_hide_password": "Ocultar contraseña",
  "auth_show_password": "Mostrar contraseña",
  "auth_forgot_password": "¿Olvidaste la contraseña?",
  "auth_entering": "Entrando...",
  "auth_switch_aria": "Alternar login y registro",
  "auth_create_account_short": "Crear cuenta",
  "auth_login_short": "Entrar",
  "auth_terms_microcopy": "Al continuar, aceptas los términos de la plataforma.",
  "auth_trust_note": "Nunca pedimos la contraseña del juego ni acceso externo a tu cuenta.",
  "auth_errors": {
    "auth/email-already-in-use": "Este correo ya está registrado. Inicia sesión.",
    "auth/invalid-email": "Correo inválido.",
    "auth/user-not-found": "Usuario no encontrado. Crea una cuenta.",
    "auth/wrong-password": "Contraseña incorrecta.",
    "auth/weak-password": "Contraseña débil. Usa al menos 6 caracteres.",
    "auth/too-many-requests": "Demasiados intentos. Intenta más tarde.",
    "auth/network-request-failed": "Error de conexión. Verifica tu internet.",
    "auth/user-disabled": "Cuenta desactivada. Contacta soporte.",
    "auth/invalid-credential": "Correo o contraseña incorrectos.",
    "auth/operation-not-allowed": "Operación no permitida.",
    "auth/account-exists-with-different-credential": "Este correo ya está en uso con otro método de acceso.",
    "default": "Error al procesar. Intenta nuevamente."
  },
  "hub_welcome": "Bienvenido,",
  "hub_subtitle": "Tu camino al nivel pro",
  "hub_analyses": "Análisis",
  "hub_coins": "Acesso Premium",
  "hub_average": "Promedio",
  "hub_analyze_new": "Analizar Nueva Partida",
  "hub_recharge": "Recargar Acesso Premium",
  "hub_recent": "Análisis Recientes",
  "hub_today": "Hoy",
  "nav_home": "Inicio",
  "nav_hub": "Inicio",
  "nav_coach": "Coach",
  "nav_sensi": "Sensi-IA",
  "nav_sensi_short": "Sensi",
  "nav_tools": "Herramientas",
  "nav_tools_short": "Herram.",
  "nav_training": "Entrenos",
  "nav_chat": "Chat",
  "nav_history": "Evolución",
  "nav_profile": "Perfil",
  "nav_pricing": "Planes",
  "onboarding_step_game": "Paso 1 de 3",
  "onboarding_step_problem": "Paso 2 de 3",
  "onboarding_step_action": "Paso 3 de 3",
  "onboarding_game_question": "Que juego quieres mejorar?",
  "onboarding_game_subtitle": "Mi usa esto para abrir la herramienta correcta en tu primer acceso.",
  "onboarding_game_pubg": "FPS Mobile (Alpha)",
  "onboarding_game_freefire": "FPS Mobile (Beta)",
  "onboarding_game_codm": "FPS Mobile (Gamma)",
  "onboarding_problem_question": "Cual es tu mayor problema hoy?",
  "onboarding_problem_subtitle": "Elige el sintoma principal. La app sugerira el primer paso.",
  "onboarding_problem_shaking": "Mira temblando",
  "onboarding_problem_spray": "Spray subiendo",
  "onboarding_problem_sensitivity": "Sensibilidad rara",
  "onboarding_problem_training": "No se como entrenar",
  "onboarding_problem_analysis": "Quiero analizar mi gameplay",
  "onboarding_action_question": "Que quieres hacer ahora?",
  "onboarding_action_subtitle": "Vamos directo a una herramienta con valor.",
  "onboarding_action_adjust": "Ajustar sensibilidad",
  "onboarding_action_diagnose": "Diagnosticar mi mira",
  "onboarding_action_train": "Entrenar mecanica",
  "onboarding_action_analyze": "Analizar gameplay",
  "onboarding_action_guide": "Guiame",
  "home_guided_title": "Inicio",
  "home_guided_subtitle": "Cuenta el problema. Mi indica el proximo paso.",
  "home_next_step_badge": "Proximo paso",
  "home_next_step_title": "Tu proximo paso",
  "home_next_step_desc": "Mejora tu mira empezando por el ajuste mas importante ahora.",
  "home_next_step_cta": "Iniciar diagnostico",
  "home_checkpoint_account_created": "Vamos a encontrar el mejor camino para tu mira.",
  "home_checkpoint_first_result": "Ya generaste valor",
  "home_first_result_desc": "Continua el ciclo: ajustar, diagnosticar, entrenar y analizar.",
  "home_aha_badge": "Aha moment en minutos",
  "home_hero_title": "Plan rapido de Mi.",
  "home_hero_desc": "Diagnostico primero. Entreno despues. Analisis cuando haga falta.",
  "home_start_free_adjustment": "Empezar mi ajuste gratis",
  "home_continue_evolution": "Continuar mi evolucion",
  "home_mi_guide_title": "Que esta pasando con tu mira?",
  "home_mi_guide_subtitle": "Escribe pocas palabras o toca un sintoma.",
  "home_mi_guide_placeholder": "Ej: spray sube, mira tiembla, no se entrenar...",
  "home_mi_guide_cta": "Generar plan de Mi",
  "home_mi_guide_quick_chips": "Sintomas rapidos",
  "home_chip_aim_rising": "Mira sube",
  "home_chip_aim_shaking": "Mira tiembla",
  "home_chip_bad_spray": "Spray malo",
  "home_chip_training": "No se entrenar",
  "home_chip_analysis": "Analizar gameplay",
  "home_mi_plan_title": "Plan de Mi",
  "home_mi_plan_quick_title": "Plan rapido de Mi",
  "home_mi_plan_default": "Empieza por Sensi-IA. Luego valida tu base y entrena el ajuste.",
  "home_mi_plan_continue": "Continua por Sensi-IA. Luego entrena el ajuste en Coach.",
  "home_mi_plan_sensitivity": "Crea una base segura. Luego validala con Sensi-IA.",
  "home_mi_plan_training": "Abre un entrenamiento recomendado. Luego valida ejecucion con Mi Analisis.",
  "home_mi_plan_analysis": "Envia gameplay, encuentra el punto debil y abre un entrenamiento.",
  "home_mi_plan_aim": "Diagnostica la mira primero. Si hace falta, recalculamos la base despues.",
  "home_quick_tools_title": "Herramientas rapidas",
  "home_tool_sensi_title": "Sensi-IA",
  "home_tool_sensi_desc": "Descubre el error de mira.",
  "home_tool_calculator_title": "Calculadora",
  "home_tool_calculator_desc": "Crea una base segura.",
  "home_tool_coach_title": "Coach",
  "home_tool_coach_desc": "Entrena el punto debil.",
  "home_tool_analysis_title": "Mi Analisis",
  "home_tool_analysis_desc": "Analiza gameplay.",
  "home_plan_tool_calculator": "Calculadora",
  "home_plan_short_base": "Crear base",
  "home_plan_short_validate": "Validar ajuste",
  "home_plan_short_train": "Entrenar ajuste",
  "home_plan_short_training": "Abrir entreno",
  "home_plan_short_analysis": "Validar ejecucion",
  "home_plan_short_adjust_if_needed": "Ajustar si hace falta",
  "home_plan_short_send_video": "Enviar gameplay",
  "home_plan_short_weakness": "Encontrar punto debil",
  "home_plan_short_open_training": "Abrir entreno",
  "home_plan_short_diagnose": "Diagnosticar",
  "home_plan_short_recalculate": "Recalcular base",
  "home_open_sensi": "Abrir Sensi-IA",
  "home_open_calculator": "Abrir Calculadora",
  "home_open_coach": "Abrir Coach",
  "home_open_analysis": "Abrir Mi Analisis",
  "home_cycle_label": "Ciclo Game Pro Hub",
  "home_cycle_adjust": "Ajustar",
  "home_cycle_diagnose": "Diagnosticar",
  "home_cycle_train": "Entrenar",
  "home_cycle_analyze": "Analizar",
  "home_intent_title": "Que quieres mejorar hoy?",
  "home_intent_subtitle": "Una eleccion. Un proximo paso claro.",
  "home_intent_adjust_sensitivity": "Ajustar sensibilidad",
  "home_intent_adjust_sensitivity_desc": "Crea una base segura para tu juego.",
  "home_intent_find_aim_issue": "Descubrir error de mira",
  "home_intent_find_aim_issue_desc": "Usa Sensi-IA para entender que cambiar.",
  "home_intent_train_mechanics": "Entrenar mecanica",
  "home_intent_train_mechanics_desc": "Abre Coach y sigue una rutina corta.",
  "home_intent_analyze_gameplay": "Analizar gameplay",
  "home_intent_analyze_gameplay_desc": "Envia un video y recibe lectura de Mi.",
  "home_intent_guide_me": "Guiame",
  "home_intent_guide_me_desc": "Empieza por el diagnostico de mayor valor.",
  "home_evolution_plan_title": "Tu plan de evolucion",
  "home_evolution_plan_subtitle": "Ajustar -> diagnosticar -> entrenar -> analizar -> repetir.",
  "home_plan_step_adjust": "Ajustar sensibilidad",
  "home_plan_tools_calculators": "Calculadora FPS Mobile (Alpha) / FPS Mobile (Beta)",
  "home_plan_step_diagnose": "Diagnosticar tu mira",
  "home_plan_tool_sensi": "Sensi-IA",
  "home_plan_step_train": "Entrenar con Mi Coach",
  "home_plan_tool_coach": "Mi Coach",
  "home_plan_step_analyze": "Analizar tu gameplay",
  "home_plan_tool_mi_analysis": "Mi Analisis",
  "home_status_available": "Disponible",
  "home_status_initial_free": "Inicial gratis",
  "home_status_preview": "Preview gratis",
  "home_status_preview_pro": "Preview gratis / completo en Pro",
  "home_status_pro": "Pro",
  "home_status_pro_active": "Pro activo",
  "home_status_recommended": "Recomendado",
  "home_status_sensi": "Via Sensi-IA",
  "home_first_value_title": "Primer valor",
  "home_first_value_desc": "Recibe una recomendacion util antes de cualquier paywall contextual.",
  "home_pro_strip_title": "Plan completo de evolucion",
  "home_pro_strip_desc": "Ya encuentras el primer ajuste gratis. Pro desbloquea el ciclo completo: Sensi-IA, Mi Coach y Mi Analisis.",
  "home_pro_strip_cta": "Desbloquear Pro",
  "community_cta_title": "Comunidad Game Pro Hub",
  "community_cta_description": "Tienes dudas sobre que ajuste usar? Entra en la comunidad oficial.",
  "community_cta_button": "Entrar",
  "chat_title": "Mi • Coach",
  "chat_subtitle": "Consultoría técnica en tiempo real",
  "chat_cost": "1 coin por mensaje",
  "chat_placeholder": "Escribe tu duda táctica...",
  "chat_empty_title": "Mi • Coach Lista",
  "chat_empty_subtitle": "Pregunta sobre estratégias, puntería, posicionamiento y más.",
  "analysis_title": "Análisis de Gameplay",
  "analysis_upload_title": "Sube tu Video",
  "analysis_upload_subtitle": "MP4, MOV, AVI, MKV - hasta 100MB",
  "analysis_upload_btn": "Seleccionar Video",
  "analysis_cost": "Costo: 3 Acesso Premium por análisis",
  "analysis_analyzing": "Analizando tu gameplay...",
  "analysis_wait": "La IA • está procesando tu video. Esto puede tardar unos minutos.",
  "analysis_start": "Analizar Gameplay",
  "analysis_result_title": "Resultado del Análisis",
  "analysis_new": "Nuevo Análisis",
  "analysis_see_details": "Ver detalles",
  "history_title": "Evolución",
  "history_subtitle": "Revisa tu evolución",
  "history_empty": "Sin análisis aún",
  "history_unknown_date": "Fecha desconocida",
  "settings_profile": "Perfil",
  "settings_role_admin": "Administrador",
  "settings_role_user": "Jugador",
  "settings_edit": "Editar",
  "settings_save": "Guardar",
  "settings_cancel": "Cancelar",
  "settings_name": "Nombre",
  "settings_photo_url": "URL de foto",
  "settings_change_photo": "Cambiar foto",
  "settings_logout": "Cerrar sesión",
  "settings_admin_panel": "Panel Admin",
  "settings_admin_subtitle": "Gestión y KPIs",
  "settings_language_section_title": "Idioma de la app",
  "settings_language_section_subtitle": "Preferencia global de interfaz e IA",
  "settings_main_game_title": "Juego principal",
  "settings_main_game_subtitle": "Define Coach y Sensi activos",
  "settings_save_game": "Guardar juego",
  "settings_back_to_hub": "Continuar en Coach",
  "referral_title": "Invita y Gana",
  "referral_subtitle": "Gana 15% de comisión por cada compra de tus referidos",
  "referral_subtitle_user": "Gana Acesso Premium por cada referido!",
  "referral_your_link": "Tu enlace de referido",
  "referral_share": "Compartir enlace",
  "referral_referred": "Referidos",
  "referral_earned": "Coins ganados",
  "referral_info": "Tu amigo gana +5 coins de bienvenida. Tu recibes 15% de comisión en cada compra.",
  "referral_info_user": "Tu amigo gana +5 coins de bienvenida. Tu recibes 5 Acesso Premium por referido confirmado.",
  "referral_share_text": "Usa mi enlace y gana 5 Acesso Premium extra de bienvenida!",
  "referral_share_now": "COMPARTIR AHORA",
  "pricing_title": "Recarga tus Coins",
  "pricing_subtitle": "Créditos para usar Mi Coach",
  "pricing_coins": "coins",
  "pricing_buy": "Comprar",
  "pricing_popular": "Popular",
  "pricing_best": "Mejor valor",
  "pricing_processing": "Processando...",
  "pricing_page_title": "Planes y Valores",
  "pricing_page_subtitle": "Elige el mejor plan para tu camino pro",
  "pricing_tab_plans": "Planes Mensuales",
  "pricing_tab_packages": "Paquetes Rápidos",
  "pricing_subscribe": "Suscribirse",
  "pricing_current_plan": "Plan actual",
  "pricing_subscription_info": "Suscripción mensual. Cancela cuando quieras. Coins acreditados en la renovación.",
  "pricing_cancel_sub": "Cancelar suscripción",
  "pricing_cancel_confirm": "Seguro? Mantendrás acceso hasta el final del periodo.",
  "pricing_cancel_success": "La suscripción se cancelará al final del periodo.",
  "pricing_active_plan": "Plan activo",
  "pricing_next_renewal": "Próxima renovación",
  "pricing_access_until": "Acceso hasta",
  "pricing_status_canceling": "Cancelación programada",
  "pricing_manage_sub": "Gestionar suscripción",
  "error_credits_title": "Créditos insuficientes",
  "error_credits_msg": "Necesitas más Acesso Premium para usar este recurso.",
  "error_credits_buy": "Comprar Acesso Premium",
  "error_credits_close": "Cerrar",
  "error_analysis_title": "Error en el análisis",
  "error_retry": "Reintentar",
  "error_close": "Cerrar",
  "error_upload_video": "Error al subir video",
  "error_analysis_unavailable": "Análisis no disponible",
  "admin_title": "Panel Admin",
  "admin_choose": "Que deseas ver?",
  "admin_revenue": "Ingresos y KPIs",
  "admin_revenue_desc": "Métricas financieras y de rendimiento",
  "admin_users": "Gestionar usuarios",
  "admin_users_desc": "Control de accesos y créditos",
  "admin_back": "Voltar",
  "admin_kpis": "KPIs",
  "admin_total_users": "Total usuarios",
  "admin_total_revenue": "Ingresos totales",
  "admin_total_analyses": "Total análisis",
  "admin_avg_credits": "Promedio de créditos",
  "admin_user_list": "Lista de usuarios",
  "admin_search": "Buscar por correo...",
  "admin_role": "Role",
  "admin_credits": "Créditos",
  "admin_actions": "Acciones",
  "admin_edit": "Editar",
  "admin_add_credits": "Agregar créditos",
  "admin_amount": "Cantidad",
  "admin_confirm": "Confirmar",
  "loading_text": "Cargando...",
  "common_game_pro_hub": "GAME PRO HUB",
  "lang_label": "Idioma",
  "language_updated": "Idioma actualizado",
  "language_update_failed": "No se pudo actualizar el idioma.",
  "status_label_coach": "Coach",
  "status_label_sensi": "Sensi-IA",
  "status_unknown": "Estado no disponible",
  "status_retest_required": "Nueva prueba recomendada",
  "status_completed": "Completado",
  "status_processing": "Procesando",
  "status_failed": "Fallo",
  "status_pending": "Pendiente",
  "status_insufficient_evidence": "Evidencia insuficiente",
  "status_low_confidence": "Baja confianza",
  "status_done": "Completado",
  "status_queued": "En cola",
  "status_uploading": "Subiendo",
  "hub_stories_recent": "STORIES RECENTES",
  "hub_stories_subtitle": "Revisa los puntos clave de tus análisis.",
  "hub_mi_plan": "PLAN DE MI",
  "hub_last_analysis": "ÚLTIMA ANÁLISE",
  "hub_sensi_status": "ESTADO SENSI",
  "hub_training_recommended": "ENTRENO RECOMENDADO",
  "hub_real_evolution": "EVOLUCIÓN REAL",
  "hub_recent_history": "HISTORIAL RECIENTE",
  "hub_quick_actions": "AÇÕES RÁPIDAS",
  "hub_no_recent_analysis": "Sin análisis reciente",
  "hub_first_analysis_cta": "Haz tu primer análisis",
  "hub_stories_empty": "Completa un análisis para generar stories de rendimiento.",
  "hub_plan_priority": "Prioridad actual",
  "hub_plan_next_action": "Próxima acción",
  "hub_plan_reason": "Motivo",
  "hub_no_analysis_yet": "Sin análisis aún",
  "hub_last_activity": "Últimas atividades",
  "hub_summary_fast": "Resumo rápido",
  "hub_metrics_player": "Métricas do jogador",
  "hub_choose_next_step": "Elige el siguiente paso",
  "hub_open_analysis": "Abrir análisis",
  "hub_view_all": "Ver todo",
  "hub_focus": "Foco",
  "hub_why_this_training": "Por que este entreno",
  "hub_confidence": "Confianza",
  "hub_retake_test": "Repetir prueba",
  "hub_view_result": "Ver resultado",
  "hub_optimize_sensi": "Optimizar sensi",
  "hub_start_now": "Iniciar ahora",
  "hub_no_data_enough": "Sin datos suficientes",
  "hub_trainings_done": "Entrenos completados",
  "hub_streak": "Racha",
  "hub_strongest_point": "Punto más fuerte",
  "hub_weakest_point": "Ponto mais fraco",
  "hub_no_summary_available": "Sin resumen disponible.",
  "hub_no_activity_yet": "Sin actividad reciente registrada.",
  "hub_no_detailed_adjustments": "Sin ajustes detalhados",
  "hub_no_analysis_release": "Envía un análisis para desbloquear diagnóstico y recomendaciones de Mi.",
  "hub_first_analysis_plan": "Haz tu primer análisis para que Mi cree tu plan.",
  "hub_first_analysis_history": "Cuando completes un análisis, el historial aparecerá aquí.",
  "hub_analyze_gameplay": "Analizar gameplay",
  "hub_start_training": "Iniciar entreno",
  "hub_recharge_coins": "Recarregar Acesso Premium",
  "hub_send_analysis_for_mi": "Envía un nuevo análisis para recibir orientación de Mi.",
  "history_untitled": "Análisis sin título",
  "settings_language_saved": "Idioma atualizado.",
  "settings_display_name": "Nome de exibição",
  "settings_display_name_placeholder": "Seu nome no game",
  "settings_profile_updated": "Perfil atualizado!",
  "settings_empty_name": "Nome não pode estar vazio!",
  "settings_connection_error": "Erro de conexão.",
  "settings_max_photo_size": "Máximo 5MB.",
  "settings_main_game_updated": "Jogo principal atualizado!",
  "settings_main_game_failed": "Falha ao atualizar jogo principal.",
  "settings_account_preferences": "Cuenta y preferencias",
  "settings_account_summary": "Datos de la cuenta",
  "settings_section_account": "Cuenta",
  "settings_section_subscription": "Suscripción",
  "settings_section_tools": "Herramientas",
  "settings_section_support": "Soporte",
  "settings_section_configuration": "Configuración",
  "settings_active_subscription": "Assinatura ativa",
  "settings_plan_payment": "Plano e pagamento",
  "settings_premium_status": "Status premium",
  "settings_payment_pending": "Pagamento pendente",
  "settings_next_renewal": "Próxima renovación",
  "settings_processing": "Procesando...",
  "settings_become_pro": "Hazte Pro",
  "settings_renew_pro": "Renovar Pro",
  "settings_plan_free": "Free",
  "settings_plan_free_desc": "Plan gratuito",
  "settings_plan_pro_monthly": "Pro mensual",
  "settings_plan_pro_annual": "Pro anual",
  "settings_plan_pro_lifetime": "Apoiador vitalicio",
  "settings_plan_pro_lifetime_desc": "Tienes acceso vitalicio a los recursos Pro de Game Pro Hub.",
  "settings_plan_lifetime_status": "Acceso Pro permanente",
  "settings_lifetime_purchase_date": "Compra vitalicia",
  "settings_plan_pro_expired": "Pro expirado",
  "settings_plan_pro_expired_desc": "Tu acceso Pro terminó.",
  "settings_plan_single_payment": "Pago único",
  "settings_plan_status_free": "Free",
  "settings_plan_status_expired": "Expirado",
  "settings_logout_short": "Salir",
  "email_verify_title": "Confirma tu correo",
  "email_verify_subtitle": "Enviamos un enlace de activación a tu cuenta. Confirma tu correo para desbloquear el acceso a Game Pro Hub.",
  "email_verify_sent_to": "Enlace enviado a",
  "email_verify_instruction": "Abre tu bandeja de entrada y haz clic en el enlace de confirmación. Si no lo encuentras, revisa también el correo no deseado o spam.",
  "email_verify_cta": "Ya confirmé mi correo",
  "email_verify_resend": "Reenviar enlace",
  "email_verify_resent": "Enlace reenviado. Revisa tu bandeja de entrada.",
  "email_verify_back_login": "Volver al inicio",
  "terms_title": "Termos legais",
  "terms_subtitle": "Protocolo LGPD e segurança",
  "terms_user_terms": "Termos de uso",
  "terms_privacy": "Privacidade",
  "terms_not_loaded": "Termos não carregados.",
  "terms_scroll_bottom": "Role até o final",
  "terms_acceptance_text": "Li e aceito integralmente os Termos de Uso e a Política de Privacidade.",
  "terms_accept_continue": "Aceitar e continuar",
  "terms_syncing": "Sincronizando termos...",
  "terms_accept_error": "Erro ao aceitar os termos.",
  "app_payment_confirmed": "¡Listo! El pago fue confirmado y tu acceso está liberado.",
  "app_payment_processing": "El pago está en proceso. El acceso se liberará cuando Stripe lo concluya.",
  "app_payment_received": "¡Pago recibido! Tu acceso se sincronizará en instantes.",
  "app_payment_error": "Error al procesar el pago.",
  "app_subscription_error": "Error al procesar la suscripción.",
  "app_privileged_no_charge": "La cuenta ADM/SOCIO tiene acceso total gratuito. No se necesita cobro.",
  "app_privileged_no_subscription": "La cuenta ADM/SOCIO tiene acceso total gratuito. No se necesita suscripción.",
  "app_privileged_calculator_unlocked": "La cuenta ADM/SOCIO tiene acceso total gratuito. La calculadora ya está liberada.",
  "app_privileged_no_purchase": "La cuenta ADM/SOCIO tiene acceso total gratuito. No se necesita compra.",
  "app_pubg_lifetime_error": "Error al iniciar la compra vitalicia de la Calculadora.",
  "app_freefire_lifetime_error": "Error al iniciar la compra vitalicia de la Calculadora FPS Mobile (Beta).",
  "checkout_error_open": "No se pudo abrir el checkout ahora. Intentalo de nuevo.",
  "checkout_error_unavailable_product": "Este producto no esta disponible en este momento.",
  "checkout_error_connection": "Fallo la conexion. Revisa tu internet e intentalo de nuevo.",
  "app_video_too_large": "¡Video demasiado grande! El límite es de 200MB (aprox. 2 min).",
  "app_premium_required": "Se necesita acceso premium para continuar.",
  "app_view_plans": "Ver planes",
  "app_pubg_calc_title": "Calculadora FPS Mobile (Alpha)",
  "app_pubg_calc_subtitle": "Pro: 15 usos mensuales. Vitalicio: uso ilimitado.",
  "app_freefire_calc_title": "Calculadora FPS Mobile (Beta)",
  "app_freefire_calc_subtitle": "Pro: 5 usos mensuales. Vitalicio: uso ilimitado.",
  "app_back": "Volver",
  "app_analysis_starting": "Iniciando protocolos de análisis...",
  "app_file_too_large_title": "Archivo demasiado grande",
  "app_coach_video_limit_message": "El límite de videos en Mi Coach es de {{maxMb}}MB para mantener estable el procesamiento de IA. Reduce o comprime el video.",
  "app_mi_analysis_title": "Mi Análisis",
  "app_mi_analysis_ready": "Mi Análisis listo",
  "app_syncing_mi": "Sincronizando con Mi...",
  "app_insufficient_balance": "Saldo insuficiente.",
  "app_email_not_verified_title": "Correo no verificado",
  "app_email_not_verified_coach": "Verifica tu correo antes de usar Coach.",
  "app_coach_pro_required_message": "Este análisis necesita **Acceso Pro** para ejecutarse.\n\n{{costMsg}}\n\nMuestra exactamente dónde necesitas mejorar.",
  "app_coach_credit_required_message": "Este análisis cuesta **{{cost}} Acceso Pro**.\n\nTu saldo actual: **{{credits}} Acceso Pro**.\n\nObtén más Acceso Pro para continuar.",
  "app_coach_credit_error_message": "Este análisis cuesta **{{cost}} Acceso Pro**.\n\n{{error}}\n\nObtén más Acceso Pro para continuar.",
  "app_analysis_background_sync": "El análisis sigue en segundo plano. Puedes mantener esta pantalla abierta.",
  "app_analysis_in_progress_reason": "Análisis en curso ({{reason}})...",
  "app_analysis_monitor_fallback": "Monitor en fallback: sincronizando estado del análisis...",
  "app_analysis_processing_failed": "Falló el procesamiento del análisis.",
  "app_analyzing": "Analizando...",
  "app_connection_restored_analysis": "Conexión restaurada. Reconectando análisis...",
  "app_connection_restored_sensi": "Conexión restaurada. Reconectando monitor de Sensi...",
  "app_critical_error_detected": "Error crítico detectado.",
  "app_job_syncing": "Sincronizando estado...",
  "app_mi_context_alert": "ALERTA",
  "app_mi_context_analyzed": "ANALIZADO",
  "app_mi_context_coach": "ANÁLISIS DE VIDEO",
  "app_mi_context_hub": "HUB CENTRAL",
  "app_mi_context_tools": "HERRAMIENTAS",
  "app_mi_context_os": "MI OS",
  "app_mi_context_processing": "PROCESANDO",
  "app_mi_context_profile": "CONFIGURACIÓN",
  "app_mi_context_sensi": "OPTIMIZADOR",
  "app_mi_context_syncing": "SINCRONIZANDO",
  "app_mi_context_system": "SISTEMA OPERATIVO",
  "app_mi_context_training": "MÓDULO DE ENTRENAMIENTO",
  "app_mi_msg_coach": "Lista para revisar tu partida.",
  "app_mi_msg_hub": "Monitoreando tu rendimiento...",
  "app_mi_msg_tools": "Elige una herramienta para el proximo paso.",
  "app_mi_msg_profile": "Gestionando protocolos de cuenta.",
  "app_mi_msg_sensi": "Calibrando patrones balísticos...",
  "app_mi_msg_training": "¿Cuál será el foco de la rutina de hoy?",
  "app_mi_syncing": "Mi está sincronizando...",
  "app_mi_waiting_for_you": "Mi te está esperando.",
  "app_privileged_retry": "Acceso privilegiado detectado. Inténtalo de nuevo.",
  "app_realtime_monitor_permission_fallback": "Falló el permiso del monitor en tiempo real. Usando sincronización segura por polling.",
  "app_realtime_monitor_polling_fallback": "Monitor en tiempo real no disponible. Sincronizando por polling.",
  "app_reconnecting_after_return": "Reconectando después de volver a la app...",
  "app_reconnecting_analysis_count": "Reconectando análisis... intento {{count}}",
  "app_reconnecting_analysis_monitor": "Reconectando monitor de análisis...",
  "app_reconnecting_sensi_after_return": "Reconectando Sensi después de volver a la app...",
  "app_reconnecting_sensi_count": "Reconectando Sensi... intento {{count}}",
  "app_reconnecting_sensi_monitor": "Reconectando monitor de Sensi...",
  "app_sensi_background_sync": "Sensi-IA sigue en segundo plano. Mantén esta pantalla abierta para sincronizar.",
  "app_sensi_ballistic_start": "Iniciando calibración balística...",
  "app_sensi_diagnose_failed": "No pudimos generar el diagnóstico ahora.",
  "app_sensi_diagnosis_ready": "Diagnóstico de Sensi-IA listo.",
  "app_sensi_duplicate_processing": "Ya hay un análisis de sensi en proceso.",
  "app_sensi_in_progress_reason": "Sensi en curso ({{reason}})...",
  "app_sensi_monitor_unavailable": "Monitor de Sensi no disponible.",
  "app_sensi_processing_failed": "Falló el procesamiento de sensi.",
  "app_sensi_reading_report": "Mi está leyendo tu reporte...",
  "app_sensi_refinement_ready": "Refinamiento listo.",
  "app_sensi_report_failed": "No pudimos completar el análisis por relato.",
  "app_sensi_select_video_or_no_video": "Selecciona un video o continúa sin video.",
  "app_sensi_status_syncing": "Sincronizando estado de Sensi-IA...",
  "app_sensi_video_limit_message": "El límite para videos de Sensi-IA es de {{maxMb}}MB para mantener estable el procesamiento.",
  "app_sensi_video_received_validation": "Video recibido. Validando y enviando para análisis...",
  "app_syncing": "Sincronizando...",
  "app_terms_acceptance_failed": "Falló el registro de aceptación de términos ({{status}}).",
  "app_user_not_authenticated": "Usuario no autenticado.",
  "chat_connection_error_markdown": "Tuve un problema de conexión ahora. Inténtalo de nuevo en unos segundos.",
  "chat_connection_error_short": "Error de conexión.",
  "chat_connection_retry": "Conexión inestable. Inténtalo de nuevo en unos segundos.",
  "chat_network_error": "Error de red. Revisa tu conexión.",
  "chat_temporary_issue": "Lo siento, tuve un problema temporal. Inténtalo de nuevo.",
  "local_terms_privacy_content": "# Política de Privacidad – Game Pro Hub\n\nÚltima actualización: 01/04/2026\n\nEsta política explica cómo tratamos tus datos personales para operar Game Pro Hub.\n\n## 1. Datos recopilados\n* Nombre y correo mediante Firebase Auth.\n* Información de pago procesada por Stripe. No almacenamos datos de tarjeta.\n* Videos y datos de gameplay enviados para análisis de Mi.\n* Historial de entrenamientos, análisis y evolución.\n\n## 2. Finalidad\nUsamos los datos para personalizar recomendaciones, procesar pagos, liberar acceso y generar reportes de evolución.\n\n## 3. Compartir datos\nNo vendemos tus datos. Solo los compartimos con proveedores esenciales como Google Cloud/Firebase, Stripe y servicios de IA usados en el procesamiento.\n\n## 4. Tus derechos\nPuedes solicitar acceso, corrección, anonimización o eliminación de tus datos según la ley aplicable.\n\n## 5. Seguridad\nUsamos conexiones seguras, controles de acceso y prácticas de protección para reducir riesgos de uso indebido.",
  "local_terms_privacy_title": "Política de Privacidad",
  "local_terms_user_content": "# Términos de Uso – Game Pro Hub\n\nÚltima actualización: 01/04/2026\n\nAl usar Game Pro Hub, confirmas que leíste y aceptas estos términos.\n\n## 1. Objeto\nLa plataforma ofrece calculadoras, entrenamientos, análisis y recomendaciones para mejorar el rendimiento en juegos como FPS Mobile (Alpha), FPS Mobile (Beta) y FPS Mobile (Gamma).\n\n## 2. Cuenta\nEres responsable por la información que proporcionas y por mantener segura tu cuenta. No se permite compartir acceso ni crear cuentas para abuso.\n\n## 3. Pagos\nLas suscripciones y compras son procesadas por Stripe. Las cancelaciones detienen cobros futuros según las reglas del plan contratado.\n\n## 4. Conducta\nNo puedes intentar burlar sistemas, explotar fallas, copiar contenido sin autorización ni usar la plataforma de forma abusiva.\n\n## 5. Propiedad intelectual\nLos contenidos, flujos, métodos y materiales de Game Pro Hub pertenecen a la plataforma o a sus licenciantes.\n\n## 6. Privacidad\nTus datos se tratan según la política de privacidad y la ley aplicable.\n\n## 7. Aceptación\nEl uso continuado de la plataforma confirma tu aceptación de estos términos.",
  "local_terms_user_title": "Términos de Uso",
  "sensi_free_limit_message": "Usaste tus análisis gratis de Sensi-IA. Suscríbete al Pro para continuar.",
  "sensi_feedback_save_retry": "No pudimos guardar tu feedback ahora. Inténtalo de nuevo.",
  "sensi_refine_retry": "No pudimos generar el próximo ajuste ahora. Inténtalo de nuevo.",
  "sensi_select_video_to_continue": "Selecciona un video para continuar.",
  "sensi_selected_problems": "Problemas seleccionados",
  "sensi_unsupported_video_format": "Formato no compatible. Envía un MP4, MOV de iPhone o WebM.",
  "sensi_values_summary": "Resumen de valores",
  "pricing_access": "Acceso",
  "pricing_auto_unlock": "Liberación automática después de confirmar",
  "pricing_benefits_summary": "Resumen de beneficios",
  "pricing_buy_now": "Comprar ahora",
  "pricing_clear_price": "Precio claro, sin sorpresas",
  "pricing_clear_cost_short": "Precio claro",
  "pricing_coin_rate_suffix": "{{value}} coin/val",
  "pricing_fast_activation": "Activación rápida",
  "pricing_freefire_lifetime_fallback_title": "Calculadora FPS Mobile (Beta) vitalicia",
  "pricing_full_access": "Acceso completo",
  "pricing_full_ai_calculator_access": "Acceso total a IA y Calculadora",
  "pricing_gph_access": "Acceso Game Pro Hub",
  "pricing_gph_plans": "Planes Game Pro Hub",
  "pricing_no_plan_available": "No hay planes disponibles ahora.",
  "pricing_one_time_payment": "Pago único",
  "pricing_one_time_purchase": "Compra única",
  "pricing_per_month_short": "/mes",
  "pricing_plans_access": "Planes y acceso",
  "pricing_pro_access": "Acceso Pro",
  "pricing_pro_subscription": "Suscripción Pro",
  "pricing_pubg_lifetime_fallback_title": "Calculadora FPS Mobile (Alpha) vitalicia",
  "pricing_purchase_assurances": "Garantías de compra",
  "pricing_secure_checkout": "Checkout seguro",
  "pricing_secure_stripe": "Pago seguro por Stripe",
  "pricing_product_unavailable": "No disponible en este momento",
  "pricing_amount_loading": "Cargando precio...",
  "pricing_amount_unavailable_retry": "Precio no disponible en este momento. Intentalo de nuevo.",
  "pricing_catalog_error_notice": "Precio no disponible en este momento. Intentalo de nuevo.",
  "pricing_value_description": "Suscripción Pro o Calculadora FPS Mobile (Alpha) vitalicia con pago único.",
  "pricing_subscribe_pro": "Suscribir Pro",
  "pricing_equivalent_monthly": "Equivale a {{value}}.",
  "sensi_access": "Acceso",
  "sensi_access_blocked": "Acceso bloqueado",
  "sensi_access_pro_released": "Uso Pro liberado",
  "sensi_action_increase": "Aumenta",
  "sensi_action_increase_infinitive": "Aumentar",
  "sensi_action_reduce": "Reduce",
  "sensi_action_reduce_infinitive": "Reducir",
  "sensi_adjustment_count": "{{count}} ajustes",
  "sensi_aim_question": "¿Qué está mal con tu mira?",
  "sensi_aim_question_desc": "Marca lo que sientes al apuntar o controlar el spray.",
  "sensi_aim_report": "Reporte de mira",
  "sensi_already_processing": "El análisis de sensi ya está en proceso.",
  "sensi_analysis_slow_notice": "Si tarda más de lo normal, mantén esta pantalla abierta. Mi sigue procesando.",
  "sensi_analysis_stopped": "Análisis detenido",
  "sensi_analysis_stopped_desc": "No pudimos completar el análisis ahora.",
  "sensi_analyze": "Analizar",
  "sensi_analyzing_sensitivity": "Analizando tu sensibilidad",
  "sensi_analyzing_sensitivity_desc": "Mi está leyendo tu reporte y preparando un ajuste seguro.",
  "sensi_apply_only_this_adjustment": "Aplica solo este ajuste antes de probar nuevamente.",
  "sensi_attached": "Adjunto",
  "sensi_calibration_success": "Tu calibración se completó con éxito.",
  "sensi_change_sentence": "{{action}} {{field}} en {{points}} puntos.",
  "sensi_confidence_label": "Confianza {{label}}",
  "sensi_confidence_plain": "Confianza",
  "sensi_context_desc": "Detalles sobre tu gameplay y el escenario de prueba.",
  "sensi_context_title": "Contexto de la prueba",
  "sensi_continue": "Continuar",
  "sensi_continue_without_video": "Continuar sin video",
  "sensi_continue_without_video_desc": "Mi usa tu reporte para generar un ajuste seguro.",
  "sensi_control_gyro": "Giroscopio",
  "sensi_control_method": "Método de control",
  "sensi_control_touch": "Dedo",
  "sensi_copy_adjust": "{{label}}: {{action}}",
  "sensi_copy_adjust_with_values": "{{label}}: {{action}} ({{current}} -> {{target}})",
  "sensi_copy_increase_points": "aumentar {{points}} puntos",
  "sensi_copy_insufficient_evidence": "{{label}}: sin evidencia suficiente",
  "sensi_copy_keep_almost_same_values": "{{label}}: mantener casi igual ({{current}} -> {{target}})",
  "sensi_copy_keep_as_is": "{{label}}: mantener como está",
  "sensi_copy_reduce_points": "reducir {{points}} puntos",
  "sensi_current_values": "Valores actuales",
  "sensi_current_values_desc": "Completa los campos que quieres calibrar.",
  "sensi_diagnose": "Diagnosticar",
  "sensi_diagnosis_summary_default": "Mi encontró un patrón de mira para probar con seguridad.",
  "sensi_diagnosis_title": "Diagnóstico de Sensi-IA",
  "sensi_do_not_close": "No cierres esta pantalla durante el análisis.",
  "sensi_duration": "Duración",
  "sensi_duration_5_10": "5 a 10 minutos",
  "sensi_expected_coverage": "Qué debe mostrar el video",
  "sensi_expected_coverage_desc": "Muestra la mira, el spray y la distancia de prueba para aumentar la precisión.",
  "sensi_feedback_heavy": "Quedó pesada",
  "sensi_feedback_improved": "Mejoró",
  "sensi_feedback_slow": "Quedó lenta",
  "sensi_feedback_msg_improved": "Bien. Mantén este ajuste y haz otro entrenamiento antes de cambiar algo más.",
  "sensi_feedback_msg_same": "Perfecto. Este retorno ayuda a Mi a elegir el próximo paso.",
  "sensi_feedback_msg_worse": "Entendido. No cambies nada más ahora. Mi usará esto en el próximo ajuste.",
  "sensi_feedback_notes_placeholder": "Opcional: cuenta qué sentiste después del entrenamiento...",
  "sensi_feedback_now_drops": "Ahora baja",
  "sensi_feedback_overshoots": "Pasa del objetivo",
  "sensi_feedback_question": "Después del entrenamiento, ¿cómo quedó tu mira?",
  "sensi_feedback_same": "Quedó igual",
  "sensi_feedback_saving": "Guardando...",
  "sensi_feedback_shakes": "Tiembla",
  "sensi_feedback_shakes_strong": "Tiembla mucho",
  "sensi_feedback_still_rises": "Todavía sube",
  "sensi_feedback_worse": "Empeoró",
  "sensi_final_review": "Revisión final",
  "sensi_fine_tune_active": "Ajuste fino activo",
  "sensi_fine_tune_extra_weight": "Mi dará más peso a este retorno.",
  "sensi_fine_tune_good": "Perfecto, quedó buena!",
  "sensi_fine_tune_good_value": "Quedó buena",
  "sensi_finish_failed": "No pudimos completar el análisis.",
  "sensi_flow_intro_item_scope_swap": "Usa el mismo scope del problema",
  "sensi_flow_intro_item_target": "Prueba en un objetivo fijo",
  "sensi_flow_intro_item_video": "El video es opcional",
  "sensi_flow_intro_item_wall": "Reporta el síntoma principal",
  "sensi_flow_intro_title": "Ajusta tu mira con Mi",
  "sensi_focus_label": "Foco",
  "sensi_follow_protocol_before_recalibrate": "Sigue este protocolo en el juego antes de recalibrar.",
  "sensi_free_limit_desc": "Alcanzaste el límite gratis de Sensi-IA este mes.",
  "sensi_free_limit_title": "Límite gratis alcanzado",
  "sensi_free_remaining": "{{remaining}}/{{limit}} gratis",
  "sensi_free_remaining_verbose": "{{remaining}} de {{limit}} análisis gratis disponibles",
  "sensi_game_question": "¿Qué juego quieres ajustar?",
  "sensi_game_question_desc": "Elige el juego para que Mi arme el contexto correcto.",
  "sensi_generate_next_adjustment": "Generar próximo ajuste de Mi",
  "sensi_generating_next_adjustment": "Generando próximo ajuste...",
  "sensi_generic_sensitivity": "sensibilidad",
  "sensi_goal_desc": "Elige el foco para que la recomendación sea más precisa.",
  "sensi_goal_title": "¿Cuál es el objetivo del ajuste?",
  "sensi_guided_flow": "Flujo guiado MiraIA",
  "sensi_high_confidence": "Alta confianza",
  "sensi_how_to_calibrate_aim": "Cómo calibrar tu mira",
  "sensi_how_to_test": "Cómo probar",
  "sensi_initial_card_1_desc": "Cuenta qué pasa con tu mira.",
  "sensi_initial_card_1_title": "Reporta el problema",
  "sensi_initial_card_2_desc": "Informa arma, scope, distancia y valores actuales.",
  "sensi_initial_card_2_title": "Agrega contexto",
  "sensi_initial_card_3_desc": "Recibe un ajuste conservador y un entrenamiento práctico.",
  "sensi_initial_card_3_title": "Prueba con seguridad",
  "sensi_initial_subtitle": "Ajuste de sensibilidad por reporte o video",
  "sensi_initial_title_prefix": "Protocolo",
  "sensi_insufficient_evidence": "sin evidencia suficiente",
  "sensi_jitter_stability": "Temblor / estabilidad",
  "sensi_keep_current_adjustment": "Mantén el ajuste actual.",
  "sensi_keep_other_sensitivities": "No cambies otras sensibilidades en este ciclo.",
  "sensi_keep_reason": "Esto evita cambiar demasiados valores a la vez.",
  "sensi_keep_specific_fields": "No cambies {{fields}} en este ciclo.",
  "sensi_legacy_all_good_desc": "El análisis no encontró errores grandes. Recomendamos mantener los valores actuales y refinar en entrenamiento.",
  "sensi_legacy_all_good_title": "La base está bien",
  "sensi_legacy_conservative_desc": "No conseguimos datos perfectos en el video. Mi recomendó una base segura para comenzar.",
  "sensi_legacy_conservative_title": "Ajuste conservador",
  "sensi_legacy_feedback_desc": "Esto prepara a Mi para la próxima calibración.",
  "sensi_legacy_feedback_title": "¿Lo probaste? ¿Cómo quedó?",
  "sensi_legacy_increase_scope": "Aumenta {{points}} puntos en esta mira para reducir el atraso al entrar al objetivo.",
  "sensi_legacy_micro_adjustment": "Microajuste fino. Aplícalo y valida con una secuencia corta de confirmación.",
  "sensi_legacy_reduce_scope": "Reduce {{points}} puntos en esta mira para controlar el exceso y mejorar estabilidad.",
  "sensi_legacy_result_desc": "Mi analizó tu perfil y generó una recomendación precisa basada en tus movimientos de combate.",
  "sensi_legacy_result_title": "Tu sensi fue ajustada",
  "sensi_legacy_retest_hint": "Repite esta prueba con un video de spray dedicado y sin cortes para calibrar con seguridad.",
  "sensi_legacy_stability_desc": "Hubo mucho temblor y exceso de corrección. Esto indica una sensibilidad un poco alta para tu control motor actual.",
  "sensi_legacy_stability_title": "Falta de estabilidad con {{scope}}",
  "sensi_legacy_tracking_delay_desc": "Tu mira tardó en acompañar el objetivo. Esto suele indicar sensibilidad baja, obligándote a arrastrar demasiado con dedo/gyro.",
  "sensi_legacy_tracking_delay_title": "Atraso al entrar al objetivo con {{scope}}",
  "sensi_location": "Lugar",
  "sensi_marked_count": "{{count}} marcados",
  "sensi_mi_diagnosis": "Diagnóstico de Mi",
  "sensi_missing": "Pendiente",
  "sensi_new_training": "Nuevo entrenamiento",
  "sensi_next_question_default": "Después de probar, di si mejoró, empeoró o quedó igual.",
  "sensi_no_numeric_values": "No se completó ningún valor numérico.",
  "sensi_no_video": "Sin video",
  "sensi_not_informed": "No informado",
  "sensi_number_placeholder": "Ej: 50",
  "sensi_objectives": "Objetivos",
  "sensi_observe_prefix": "Observa",
  "sensi_opencv_tracking_confidence": "Confianza del rastreo OpenCV:",
  "sensi_optional_placeholder": "Opcional",
  "sensi_other_sensitivity_values": "otras sensibilidades",
  "sensi_points_label": "{{points}} puntos",
  "sensi_pubg_diagnosis": "Diagnóstico FPS Mobile (Alpha)",
  "sensi_pubg_precision_mode": "Modo de precisión FPS Mobile (Alpha)",
  "sensi_pubg_precision_desc": "Mi cruzó video, arma, scope, distancia y tu modo de control.",
  "sensi_pull_precision": "Precisión de la puxada",
  "sensi_recalibrate_now": "Recalibrar ahora",
  "sensi_recording_protocol": "Protocolo de grabación",
  "sensi_redo_diagnosis": "Rehacer diagnóstico",
  "sensi_increased": "Aumentó",
  "sensi_reduced": "Reducido",
  "sensi_refinement_hero_desc": "Mi usó tu feedback para armar el próximo ajuste seguro.",
  "sensi_report_hero_desc": "Mi analizó tu reporte y armó un ajuste seguro para probar ahora.",
  "sensi_report_only_mode": "Modo sin video",
  "sensi_report_only_mode_desc": "El análisis seguirá solo con tu reporte. Puedes volver y enviar video si quieres.",
  "sensi_return_later": "Después vuelve",
  "sensi_review": "Revisar",
  "sensi_save_and_copy_all": "Guardar y copiar todo",
  "sensi_saved_and_copied": "Guardado y copiado",
  "sensi_screen_subtitle": "Ajuste de sensibilidad por reporte o video",
  "sensi_send_video": "Enviar video para ayudar a Mi",
  "sensi_send_video_desc": "El video entra como evidencia extra para aumentar la precisión.",
  "sensi_start_calibration": "Comenzar calibración",
  "sensi_step_counter": "Paso {{current}} de {{total}}",
  "sensi_step_game": "Juego",
  "sensi_step_game_subtitle": "Elige el juego para calibrar",
  "sensi_step_goal": "Reporte",
  "sensi_step_goal_subtitle": "Cuenta qué pasa con tu mira",
  "sensi_step_context": "Contexto",
  "sensi_step_context_subtitle": "Informa arma, scope y distancia",
  "sensi_step_values": "Valores",
  "sensi_step_values_subtitle": "Pasa tus sensibilidades actuales",
  "sensi_step_video_optional": "Video opcional",
  "sensi_step_video_optional_subtitle": "Elige analizar con o sin video",
  "sensi_step_review": "Revisión",
  "sensi_step_review_subtitle": "Confirma todo antes del análisis",
  "sensi_step_prefix": "Paso {{step}}: {{title}}",
  "sensi_success_criterion": "Criterio de éxito",
  "sensi_success_criterion_desc": "Haz 10 sprays largos (40m a 60m). La configuración está calibrada si al menos 7 sprays concentran la mayoría de los tiros en el torso del objetivo.",
  "sensi_symptom_aim_drops": "Mi mira baja",
  "sensi_symptom_aim_rises": "Mi mira sube",
  "sensi_symptom_aim_shakes": "Mi mira tiembla",
  "sensi_symptom_cannot_track_enemy": "Mi mira no acompaña al enemigo",
  "sensi_symptom_close_range_difficulty": "Error de cerca",
  "sensi_symptom_first_bullets_miss": "Error en las primeras balas",
  "sensi_symptom_gyro_difficulty": "Dificultad con gyro",
  "sensi_symptom_long_range_difficulty": "Error de lejos",
  "sensi_symptom_mid_range_difficulty": "Error a media distancia",
  "sensi_symptom_mid_spray_lost": "Pierdo el control a mitad del spray",
  "sensi_symptom_no_gyro_difficulty": "No uso gyro",
  "sensi_symptom_overshoots_target": "Mi mira pasa del enemigo",
  "sensi_symptom_placeholder": "Ej: mi mira sube después de las primeras balas...",
  "sensi_symptom_spray_opens_horizontal": "Mi spray abre hacia los lados",
  "sensi_symptom_spray_opens_vertical": "Mi spray abre hacia arriba/abajo",
  "sensi_tab_analysis": "Sensi-IA",
  "sensi_tab_analysis_desc": "Diagnóstico",
  "sensi_tab_pubg_calc": "FPS Mobile (Alpha)",
  "sensi_tab_pubg_calc_desc": "Calculadora",
  "sensi_tap_to_attach_video": "Toca para adjuntar video",
  "sensi_technical_reason": "Justificación técnica",
  "sensi_test_and_return_later": "Probar y volver después",
  "sensi_test_before_change": "Prueba antes de cambiar",
  "sensi_test_same_scenario": "Prueba en entrenamiento o arena manteniendo el mismo escenario del reporte.",
  "sensi_test_weapon": "Arma en prueba",
  "sensi_today_training": "Entrenamiento de hoy",
  "sensi_tracking_label": "Tracking",
  "sensi_training_mode": "Modo Entrenamiento",
  "sensi_training_step_note": "Anota si la mira subió, bajó, tembló o quedó estable.",
  "sensi_training_step_only_adjustment": "Aplica solo el ajuste recomendado.",
  "sensi_training_step_reps": "Haz 10 repeticiones controladas.",
  "sensi_training_step_same_scope": "Usa el mismo scope y la misma distancia de la prueba.",
  "sensi_tutorial_start": "Entendido, vamos a empezar",
  "sensi_tutorial_step_keep_center": "Intenta mantener la mira fija en el centro del objetivo.",
  "sensi_tutorial_step_no_edits": "Evita cortes o ediciones en el video original.",
  "sensi_tutorial_step_red_dot": "Haz un spray de 30 tiros con Red Dot.",
  "sensi_tutorial_step_scopes": "Repite el spray con 2x, 3x, 4x y 6x.",
  "sensi_tutorial_step_weapon": "Equipa tu arma favorita en modo entrenamiento.",
  "sensi_validation_test": "Prueba de validación",
  "sensi_validation_training": "Entrenamiento de validación",
  "sensi_vertical_recoil": "Recoil vertical",
  "sensi_video": "Video",
  "sensi_video_confirmed_title": "Lo que el video ayudó a confirmar",
  "sensi_video_effect_default": "El video se usó como apoyo para ajustar la confianza del análisis.",
  "sensi_video_failed_continued": "El video falló, pero el análisis continuó por tu reporte",
  "sensi_video_fallback": "Video en fallback",
  "sensi_video_hero_desc": "Mi analizó tu reporte con el video como apoyo para aumentar la precisión.",
  "sensi_video_physical_measurement": "Medición física del video",
  "sensi_video_question": "¿Quieres enviar un video?",
  "sensi_video_question_desc": "No es obligatorio. Pero si lo envías, Mi entiende mejor tu mira.",
  "sensi_video_selected": "Video seleccionado",
  "sensi_video_support": "Video usado como apoyo",
  "sensi_waiting_evidence": "Esperando evidencia",
  "sensi_weapon_placeholder": "Ej: M416",
  "sensi_what_change": "Qué cambiar",
  "sensi_what_change_now": "Qué cambiar ahora",
  "sensi_what_changed": "Qué cambió",
  "sensi_what_keep": "Qué no cambiar ahora",
  "sensi_what_mi_saw": "Lo que Mi notó",
  "sensi_what_mi_saw_now": "Lo que Mi notó ahora",
  "sensi_processing_received": "Reporte recibido",
  "sensi_processing_received_desc": "Mi está organizando tu contexto de mira.",
  "sensi_processing_validated": "Datos validados",
  "sensi_processing_validated_desc": "Revisando juego, arma, scope y valores actuales.",
  "sensi_processing_signals": "Señales de mira",
  "sensi_processing_signals_desc": "Identificando el síntoma principal y el canal correcto.",
  "sensi_processing_stability": "Seguridad del ajuste",
  "sensi_processing_stability_desc": "Limitando la recomendación para no cambiar demasiados valores.",
  "sensi_processing_recommendation": "Entrenamiento y ajuste",
  "sensi_processing_recommendation_desc": "Armando el ajuste y el entrenamiento de hoy.",
  "sensi_processing_finalizing": "Finalizando",
  "sensi_processing_finalizing_desc": "Preparando tu diagnóstico.",
  "sensi_diag_vertical_under": "Tu mira está subiendo durante el spray.",
  "sensi_diag_vertical_over": "Tu mira está bajando durante el spray.",
  "sensi_diag_instability": "Tu mira está temblando o inestable.",
  "sensi_diag_overshoot": "Tu mira está pasando del objetivo.",
  "sensi_diag_tracking_lag": "Tu mira no acompaña al enemigo.",
  "sensi_diag_vertical_spread": "Tu spray está abriendo en vertical.",
  "sensi_diag_horizontal_issue": "Tu spray está abriendo hacia los lados.",
  "sensi_diag_first_bullets": "El error aparece en las primeras balas.",
  "sensi_diag_mid_spray": "Pierdes el control a mitad del spray.",
  "sensi_diag_close_range": "La dificultad aparece de cerca.",
  "sensi_diag_mid_range": "La dificultad aparece a media distancia.",
  "sensi_diag_long_range": "La dificultad aparece de lejos.",
  "sensi_diag_gyro_mismatch": "El control con gyro necesita ajuste fino.",
  "sensi_diag_no_gyro": "El control sin gyro necesita una base más estable.",
  "sensi_diag_improved_keep": "El ajuste mejoró tu mira.",
  "sensi_diag_still_rising": "La mira todavía sube.",
  "sensi_diag_now_drops": "La mira empezó a bajar.",
  "sensi_diag_after_shakes": "La mira empezó a temblar.",
  "sensi_diag_too_heavy": "La mira quedó pesada.",
  "sensi_diag_after_overshoot": "La mira pasó del objetivo después del ajuste.",
  "sensi_diag_same_symptom": "El síntoma continuó igual.",
  "sensi_diag_worsened": "El ajuste anterior empeoró el control.",
  "sensi_diag_default": "Mi encontró un patrón para probar con seguridad.",
  "sensi_evidence_strong": "evidencia fuerte",
  "sensi_evidence_moderate": "evidencia moderada",
  "sensi_evidence_limited": "evidencia limitada",
  "sensi_retest_recommended": "nueva prueba recomendada",
  "sensi_limited_evidence_estimate": "estimación con evidencia limitada",
  "sensi_precise_calibration": "calibración precisa",
  "sensi_no_data": "sin datos",
  "sensi_no_evidence": "sin evidencia",
  "sensi_overflick_detected": "exceso de flick detectado",
  "sensi_retest_hint_label": "consejo de nueva prueba",
  "sensi_spray_segments_detected": "segmentos de spray detectados",
  "sensi_insufficient_scope_metrics": "métricas insuficientes para esta mira",
  "sensi_missing_scope_adjustment": "sin datos de ajuste para esta mira",
  "sensi_scope_not_detected_video": "esta mira no fue identificada en el video",
  "sensi_few_spray_moments": "pocos momentos de disparo detectados",
  "sensi_reliable_evidence": "evidencia confiable",
  "sensi_helper_pubg_camera_no_scope": "Velocidad de cámara sin ADS. Afecta la pre-mira y entrada al objetivo.",
  "sensi_helper_pubg_red_dot": "Control principal para combate corto y medio con Red Dot/Holo.",
  "sensi_helper_pubg_scope2x": "Ajusta tracking y recoil a media distancia con 2x.",
  "sensi_helper_pubg_scope3x": "Importante para sprays a media distancia y control lateral.",
  "sensi_helper_pubg_scope4x": "Sensibilidad crítica para sprays largos y estabilidad del recoil.",
  "sensi_helper_pubg_scope6x": "Usa un valor conservador para evitar temblor a larga distancia.",
  "sensi_helper_pubg_scope8x": "Campo de precisión extrema. Los ajustes deben ser mínimos.",
  "sensi_helper_pubg_ads": "Control durante disparo sin mira ampliada (hipfire/ADS base).",
  "sensi_helper_pubg_gyro": "Respuesta general del giroscopio antes y durante la alineación inicial.",
  "sensi_helper_pubg_gyro_fire": "Giroscopio durante spray. Priorízalo si el recoil sube u oscila al disparar.",
  "sensi_helper_ff_general": "Base de la puxada y respuesta general de la mira en FPS Mobile (Beta).",
  "sensi_helper_ff_red_dot": "Campo más sensible para capa y ajuste fino de puxada.",
  "sensi_helper_ff_scope2x": "Tracking y control a media distancia.",
  "sensi_helper_ff_scope4x": "Larga distancia con foco en estabilidad.",
  "sensi_helper_ff_sniper": "Precisión de AWM/sniper. Ajustes pequeños evitan exceso.",
  "sensi_helper_ff_free_look": "Movimiento de cámara para leer el entorno (no es recoil).",
  "sensi_helper_cod_camera_standard": "Velocidad de cámara sin disparo en modo estándar.",
  "sensi_helper_cod_camera_ads": "Cámara durante ADS para adquisición de objetivo.",
  "sensi_helper_cod_camera_tactical": "Cámara con mira táctica/scope para media distancia.",
  "sensi_helper_cod_camera_sniper": "Cámara para sniper y alineación fina.",
  "sensi_helper_cod_firing_standard": "Sensibilidad durante disparo sin mira especial.",
  "sensi_helper_cod_firing_ads": "Disparo en ADS. Campo principal de recoil en FPS Mobile (Gamma).",
  "sensi_helper_cod_firing_tactical": "Disparo con mira táctica/scope.",
  "sensi_helper_cod_firing_sniper": "Disparo sniper, exige microajuste conservador.",
  "sensi_helper_cod_gyro_standard": "Gyro base para cámara estándar.",
  "sensi_helper_cod_gyro_ads": "Gyro durante ADS.",
  "sensi_helper_cod_gyro_tactical": "Gyro para mira táctica/scope.",
  "sensi_helper_cod_gyro_sniper": "Gyro en sniper. Evita valores agresivos.",
  "sensi_helper_cod_fov": "Campo de visión. Puede cambiar la percepción de velocidad de la mira.",
  "app_cancel": "Cancelar",
  "coach_access_blocked": "Acceso bloqueado",
  "coach_access_full_library": "Desbloquea rutas, entrenamientos completos y progreso guardado para mejorar con estructura.",
  "coach_adjust_filters": "Ajusta los filtros para ver otros entrenamientos de la biblioteca.",
  "coach_all_categories": "Todas las categorías",
  "coach_all_levels": "Todos los niveles",
  "coach_all_statuses": "Todos los estados",
  "coach_any_duration": "Cualquier duración",
  "coach_avoid": "Evita",
  "coach_choose_game_library": "Elige un juego para ver rutas y entrenamientos publicados.",
  "coach_common_mistakes": "Errores comunes",
  "coach_complete_onboarding_tracks": "Completa el onboarding para ordenar las rutas.",
  "coach_complete_training_question": "¿Concluir entrenamiento?",
  "coach_completed": "Concluido",
  "coach_completed_plural": "Concluidos",
  "coach_completed_tracks": "Rutas completadas",
  "coach_completed_trainings": "Entrenamientos concluidos",
  "coach_completion_rate": "Tasa de conclusión",
  "coach_configure": "Configurar",
  "coach_configure_profile": "Configurar perfil",
  "coach_configure_profile_hint": "Configura tu perfil para mejores recomendaciones.",
  "coach_configure_profile_tracks": "Configura tu perfil para recibir rutas.",
  "coach_greeting": "¡Hola, {{name}}!",
  "coach_tagline": "Entrenamientos, rutas y evolución",
  "coach_tagline_mobile": "Entrenamientos y evolución",
  "coach_continue_training": "Continuar entrenamiento",
  "coach_days_count": "{{count}} días",
  "coach_default_tip": "Haz el entrenamiento lento primero. Cuando salga limpio, aumenta la velocidad.",
  "coach_duration_medium": "21 a 30 min",
  "coach_duration_short": "Hasta 20 min",
  "coach_error_load_library": "No pudimos cargar la biblioteca de Mi Coach ahora.",
  "coach_error_open_track": "No pudimos abrir esta ruta ahora.",
  "coach_error_open_training": "No pudimos abrir este entrenamiento ahora.",
  "coach_error_save_profile": "No pudimos guardar tu perfil ahora. Intenta nuevamente en unos instantes.",
  "coach_error_sync_progress": "No pudimos sincronizar tu progreso ahora.",
  "coach_error_update_saved": "No pudimos actualizar tus guardados ahora.",
  "coach_error_load_state": "No pudimos cargar tu perfil de Coach. Intenta nuevamente.",
  "coach_error_load_state_title": "Perfil de Coach no disponible",
  "coach_try_again": "Intentar nuevamente",
  "coach_expected_learning": "Debes aprender",
  "coach_filter_hint": "Filtra por categoría, nivel o estado.",
  "coach_finish": "Concluir",
  "coach_finished_training_tracks": "Rutas de entrenamiento finalizadas",
  "coach_for_who": "Para quién es",
  "coach_for_you": "Para ti",
  "coach_free": "Free",
  "coach_first_training_free_badge": "Primer entrenamiento liberado",
  "coach_start_free_training": "Empezar entrenamiento gratis",
  "coach_full_content": "contenido completo",
  "coach_full_pubg_library": "Acceso total a los entrenamientos de Coach",
  "coach_game_fallback": "Juego",
  "coach_game_library": "Biblioteca de juegos",
  "coach_goal_prefix": "Meta",
  "coach_level_advanced": "Avanzado",
  "coach_level_beginner": "Inicial",
  "coach_level_competitive": "Competitivo",
  "coach_level_intermediate": "Intermedio",
  "coach_library_for_game": "Biblioteca {{game}}",
  "coach_library_games": "Juegos de la biblioteca",
  "coach_loading_detail": "Cargando detalle...",
  "coach_loading_subtitle": "Sincronizando biblioteca y progreso.",
  "coach_loading_title": "Cargando Mi Coach",
  "coach_manage_subscription": "Gestionar suscripción",
  "coach_mark_completed": "Marcar como concluido",
  "coach_mark_pending": "Marcar como pendiente",
  "coach_mark_pending_question": "¿Marcar como pendiente?",
  "coach_mark_pending_short": "Marcar pendiente",
  "coach_mi_coach_pro": "Mi Coach Pro",
  "coach_mi_tip": "Consejo de Mi",
  "coach_minutes_per_day": "{{minutes}} min/día",
  "coach_month_suffix": "/mes",
  "coach_nav_games": "Juegos",
  "coach_nav_home": "Inicio",
  "coach_nav_library": "Biblioteca",
  "coach_nav_more": "Más",
  "coach_more_title": "Más opciones de Coach",
  "coach_more_desc_active": "Abre accesos directos y ajusta tu rutina.",
  "coach_more_desc_free": "Tu entrenamiento gratis sigue aquí. Los recursos avanzados son Pro.",
  "coach_more_profile": "Mi perfil de Coach",
  "coach_more_profile_desc": "Mira tu foco actual y el entrenamiento recomendado.",
  "coach_more_profile_setup_desc": "Configura tu primer perfil para recibir una ruta.",
  "coach_more_games_desc": "Cambia el contexto de la biblioteca por juego.",
  "coach_more_progress_desc": "Mira progreso, completados y categorías.",
  "coach_more_saved_desc": "Continúa los entrenamientos que marcaste.",
  "coach_more_retake_desc": "Recalibra la ruta con nuevas respuestas.",
  "coach_more_retake_locked_desc": "Rehacer el perfil de Coach y recalibrar la ruta es recurso Pro.",
  "coach_more_unlock": "Desbloquear Pro",
  "coach_nav_progress": "Progreso",
  "coach_nav_saved": "Guardados",
  "coach_nav_tracks": "Rutas",
  "coach_next": "Siguiente",
  "coach_no_completed_trainings": "Aún no hay entrenamientos concluidos",
  "coach_no_completed_trainings_desc": "Abre un entrenamiento premium y márcalo como concluido cuando termines los pasos.",
  "coach_no_fixed_time": "Sin tiempo fijo",
  "coach_no_training_found": "No se encontró ningún entrenamiento",
  "coach_nothing_saved": "Nada guardado por ahora",
  "coach_objective": "Objetivo",
  "coach_of_library": "de la biblioteca",
  "coach_of_total": "de {{total}}",
  "coach_open_training": "Abrir entrenamiento",
  "coach_open_training_eyebrow": "Entrenamiento abierto",
  "coach_open_youtube": "Abrir en YouTube",
  "coach_overall_evolution": "Evolución general",
  "coach_pending_plural": "Pendientes",
  "coach_premium": "Premium",
  "coach_prerequisites": "Requisitos previos",
  "coach_pro_active": "Pro activo",
  "coach_pro_subscription": "Suscripción Pro",
  "coach_processing_answers": "Respuestas recibidas",
  "coach_processing_libraries": "Bibliotecas por juego mapeadas",
  "coach_processing_progress": "Progreso listo para guardar",
  "coach_processing_title": "Analizando tu perfil",
  "coach_processing_tracks": "Rutas existentes seleccionadas",
  "coach_profile_pending": "Perfil pendiente",
  "coach_progress_by_category": "Progreso por categoría",
  "coach_progress_percent": "Progreso {{percent}}%",
  "coach_progress_saved_hint": "Tu historial queda guardado incluso sin acceso premium activo.",
  "coach_progress_trainings_count": "{{completed}}/{{total}} entrenamientos",
  "coach_published_trainings_count": "{{count}}+ entrenamientos publicados",
  "coach_reactivate_access": "Reactivar acceso",
  "coach_reactivate_full_access": "Reactiva para acceder al contenido completo de la biblioteca.",
  "coach_recent_achievements": "Logros recientes",
  "coach_recommended": "Recomendada",
  "coach_recommended_tracks": "Rutas recomendadas",
  "coach_redo_onboarding": "Rehacer onboarding",
  "coach_save_continue": "Guardar / continuar",
  "coach_save_from_library": "Guarda entrenamientos de la biblioteca para continuar después.",
  "coach_save_training": "Guardar entrenamiento",
  "coach_saved_continue": "Guardados / continuar",
  "coach_saved_trainings": "Entrenamientos guardados",
  "coach_saved_trainings_desc": "Continúa los entrenamientos que marcaste.",
  "coach_search_reference": "Buscar referencia",
  "coach_search_training": "Buscar entrenamiento",
  "coach_sections_aria": "Secciones de Mi Coach",
  "coach_sign_in_desc": "Usa tu cuenta Game Pro Hub para guardar perfil, progreso y entrenamientos.",
  "coach_sign_in_title": "Entra en tu cuenta",
  "coach_start_now": "Comenzar ahora",
  "coach_step_by_step": "Paso a paso",
  "coach_step_counter": "{{current}} de {{total}}",
  "coach_subscribe_now": "Desbloquear Coach Pro",
  "coach_subscription_inactive": "Tu suscripción no está activa.",
  "coach_success_criteria": "Cómo saber si lo hiciste bien",
  "coach_support_material": "Material de apoyo",
  "coach_support_material_desc": "Úsalo antes del entrenamiento para entender el fundamento y después para corregir detalles.",
  "coach_support_reference_avoid": "Evita enfocarte solo en sensibilidad sin comprender la lógica detrás de la mecánica.",
  "coach_support_reference_label": "Referencia",
  "coach_support_reference_learning": "Comprender el concepto estratégico del entrenamiento y aplicarlo conscientemente en partidas.",
  "coach_support_reference_title": "Buscar concepto y checklist",
  "coach_support_reference_watch": "Estudia la teoría de este fundamento, enfocándote en posicionamiento previo, retícula y checklist de ejecución.",
  "coach_support_unavailable": "Material no disponible para este entrenamiento.",
  "coach_support_video_avoid": "Evita highlights con ediciones rápidas que impiden ver el posicionamiento inicial.",
  "coach_support_video_label": "Video técnico",
  "coach_support_video_learning": "Entender el tiempo de reacción y los ajustes físicos necesarios durante el entrenamiento.",
  "coach_support_video_title": "Ver demostración práctica",
  "coach_support_video_watch": "Observa la ejecución visual de la mecánica, enfocándote en posición de mira y ritmo de disparos.",
  "coach_total_mastered_trainings": "Total de entrenamientos dominados",
  "coach_track_detail": "Detalle de la ruta",
  "coach_track_trainings": "Entrenamientos de la ruta",
  "coach_tracks_and_progress": "Rutas y progreso",
  "coach_tracks_label": "rutas",
  "coach_training_count_plus": "{{count}}+ entrenamientos",
  "coach_training_objective": "Objetivo del entrenamiento",
  "coach_training_progress": "Progreso de entrenamiento",
  "coach_trainings_found": "{{count}} entrenamientos encontrados",
  "coach_trainings_label": "entrenamientos",
  "coach_updating_library": "Actualizando biblioteca...",
  "coach_view_all": "Ver todas",
  "coach_welcome_eyebrow": "Biblioteca inteligente de entrenamientos",
  "coach_welcome_subtitle": "Elige una biblioteca, una ruta o sigue las recomendaciones de Mi.",
  "coach_welcome_title": "Entrenamientos para evolucionar en tu juego.",
  "coach_what_to_watch": "Qué observar",
  "coach_onboarding_game_eyebrow": "Elección del juego",
  "coach_onboarding_game_title": "¿Qué juego juegas?",
  "coach_onboarding_game_subtitle": "Elige la biblioteca principal.",
  "coach_onboarding_game_pubg_desc": "Recoil, CQC, rotación, cover y ranked.",
  "coach_onboarding_game_cod_desc": "Recoil, tracking, ranked MP y battle royale.",
  "coach_onboarding_game_ff_desc": "Capa, rush, x1, shotgun y ranked.",
  "coach_onboarding_level_eyebrow": "Nivel actual",
  "coach_onboarding_level_title": "¿Cuál es tu nivel actual?",
  "coach_onboarding_level_subtitle": "Esto calibra la dificultad de las rutas.",
  "coach_onboarding_level_beginner_desc": "Estoy comenzando ahora.",
  "coach_onboarding_level_intermediate_desc": "Tengo experiencia y quiero consistencia.",
  "coach_onboarding_level_advanced_desc": "Juego regularmente y busco ajuste fino.",
  "coach_onboarding_level_competitive_desc": "Busco rendimiento en ranked o scrim.",
  "coach_onboarding_pain_eyebrow": "Mayor dificultad",
  "coach_onboarding_pain_title": "¿Cuál es tu mayor dificultad?",
  "coach_onboarding_pain_subtitle": "Elige el dolor que aparece más en las partidas.",
  "coach_pain_recoil": "Mira / Recoil",
  "coach_pain_recoil_desc": "El spray sube, tiembla o se sale del objetivo.",
  "coach_pain_movement": "Movimiento",
  "coach_pain_movement_desc": "Pierdo duelos por entrada o strafe malo.",
  "coach_pain_close_range": "CQC / Rush",
  "coach_pain_close_range_desc": "Muero en casas, pasillos y corta distancia.",
  "coach_pain_positioning": "Posicionamiento",
  "coach_pain_positioning_desc": "Muero abierto o sin cover.",
  "coach_pain_decision": "Toma de decisión",
  "coach_pain_decision_desc": "Fuerzo duelos malos o tardo en resetear.",
  "coach_pain_mental": "Foco / Tilt",
  "coach_pain_mental_desc": "Oscilo después de un error o derrota.",
  "coach_onboarding_objective_eyebrow": "Objetivo",
  "coach_onboarding_objective_title": "¿Cuál es tu objetivo?",
  "coach_onboarding_objective_subtitle": "La recomendación usa rutas existentes.",
  "coach_objective_rank_up": "Subir de rango",
  "coach_objective_rank_up_desc": "Entrenar para ganar consistencia en ranked.",
  "coach_objective_consistency": "Ser más consistente",
  "coach_objective_consistency_desc": "Reducir oscilación entre partidas.",
  "coach_objective_better_kd": "Mejorar K/D",
  "coach_objective_better_kd_desc": "Ganar más duelos sin promesa garantizada.",
  "coach_objective_competitive": "Jugar competitivo",
  "coach_objective_competitive_desc": "Ajustar decisión, squad y presión.",
  "coach_onboarding_time_eyebrow": "Tiempo disponible",
  "coach_onboarding_time_title": "¿Cuánto tiempo puedes entrenar por día?",
  "coach_onboarding_time_subtitle": "La duración ayuda a priorizar rutas.",
  "coach_time_30": "Hasta 30 minutos",
  "coach_time_30_desc": "Bloques cortos y objetivos.",
  "coach_time_60": "30 a 60 minutos",
  "coach_time_60_desc": "Rutina equilibrada.",
  "coach_time_90": "1 a 2 horas",
  "coach_time_90_desc": "Más repeticiones por categoría.",
  "coach_time_120": "2 horas o más",
  "coach_time_120_desc": "Volumen alto de entrenamiento.",
  "coach_onboarding_setup_eyebrow": "Dispositivo / setup",
  "coach_onboarding_setup_title": "¿Cuál es tu dispositivo y configuración?",
  "coach_onboarding_setup_subtitle": "Ajuste para recomendaciones ideales.",
  "coach_setup_device": "Dispositivo",
  "coach_setup_mobile": "Celular",
  "coach_setup_fps": "FPS del dispositivo",
  "coach_setup_connection": "Conexión",
  "coach_setup_mobile_data": "Datos móviles",
  "coach_onboarding_style_eyebrow": "Estilo de juego",
  "coach_onboarding_style_title": "¿Cómo sueles jugar?",
  "coach_onboarding_style_subtitle": "Esto cambia el orden de las rutas.",
  "coach_style_aggressive": "Agresivo",
  "coach_style_aggressive_desc": "Busco entrada y primer contacto.",
  "coach_style_balanced": "Equilibrado",
  "coach_style_balanced_desc": "Alterno pelea, cover y rotación.",
  "coach_style_tactical": "Táctico",
  "coach_style_tactical_desc": "Priorizo información, posición y zona.",
  "sensi_feedback_missing_session": "No se encontró la sesión Sensi para guardar feedback.",
  "sensi_feedback_auth_required": "Inicia sesión nuevamente para guardar tu feedback.",
  "sensi_feedback_save_failed": "No pudimos guardar tu feedback ahora.",
  "sensi_refine_missing_session": "No se encontró la sesión Sensi para generar refinamiento.",
  "sensi_refine_auth_required": "Inicia sesión nuevamente para generar el próximo ajuste.",
  "sensi_refine_failed": "No pudimos generar el próximo ajuste ahora.",
  "sensi_good_config_alert": "Configuración marcada como buena. Pruébala en partidas reales antes de recalibrar.",
  "mi_analysis_invalid_video_type": "Envía solo videos MP4, MOV o WEBM.",
  "mi_analysis_video_too_large": "El video excede el límite máximo de 200MB.",
  "video_trim_timeout": "No pudimos cortar este tramo. Intenta seleccionar un tramo más corto.",
  "video_trim_failed": "Error al procesar el video. Verifica tu conexión e intenta nuevamente.",
  "legal_terms_created": "¡Términos creados con éxito! Actívalos manualmente cuando estén listos.",
  "legal_terms_activated": "¡Versión activada! Todos los usuarios deberán aceptar nuevamente.",
  "legal_error_prefix": "Error:",
  "legal_activate_confirm": "ATENCIÓN: Activar \"{{termType}} {{termVersion}}\" obligará a TODOS los usuarios a aceptar nuevamente.\n\n¿Deseas continuar?",
  "settings_support_title": "¿Necesitas ayuda?",
  "settings_support_subtitle": "Habla con el soporte oficial de Game Pro Hub por WhatsApp.",
  "settings_support_cta": "Contactar soporte",
  "settings_section_community": "Comunidad",
  "settings_community_title": "Entra en la comunidad oficial",
  "settings_community_desc": "Recibe novedades, entrenamientos, avisos y conversa con otros players de Game Pro Hub.",
  "settings_community_cta": "Entrar en la comunidad",
  "settings_copy_link_prompt": "Copia tu enlace:",
  "settings_partner_referrals": "Referidos",
  "settings_partner_earnings": "Ganancias (R$)",
  "settings_control_panel": "Panel de Control",
  "settings_control_panel_desc": "Gestionar sistema y red",
  "settings_partner_panel": "Panel del Socio",
  "settings_partner_panel_desc": "Gestionar referidos y comisiones",
  "arena_title": "Herramientas",
  "arena_subtitle": "Herramientas tácticas para {{game}}.",
  "arena_coach_title": "Coach IA",
  "arena_coach_desc": "Biblioteca, rutas y análisis táctico por juego.",
  "arena_sensi_title": "Sensi-IA",
  "arena_sensi_desc": "Ajusta tu sensibilidad por relato o video.",
  "arena_pubg_calculator_title": "Calculadora FPS Mobile (Alpha)",
  "arena_pubg_calculator_desc": "Calcula una base de sensibilidad para FPS Mobile (Alpha).",
  "arena_freefire_calculator_title": "Calculadora FPS Mobile (Beta)",
  "arena_new_badge": "Nuevo",
  "arena_freefire_calculator_desc": "Calcula la sensibilidad ideal sin usar IA.",
  "arena_mi_analysis_title": "Mi Análisis",
  "arena_mi_analysis_desc": "Envía un clip de tu gameplay y recibe un diagnóstico de Mi.",
  "arena_subscribe_pro": "Suscribirse a Pro",
  "arena_subscribe_pro_desc": "Desbloquea Coach completo, Sensi-IA y recursos premium.",
  "arena_pro_active": "Plan Pro Activo",
  "arena_pro_active_desc": "Recursos premium desbloqueados.",
  "arena_recommended_title": "Recomendado para ti",
  "arena_tools_title": "Herramientas y Análisis",
  "arena_premium_title": "Suscripción",
  "dashboard_no_records": "Sin registros",
  "dashboard_now": "Ahora mismo",
  "dashboard_hours_ago": "hace {{count}}h",
  "dashboard_days_ago": "hace {{count}} días",
  "dashboard_recruit": "RECLUTA",
  "dashboard_pro_score": "Pro Score",
  "dashboard_points_abbr": "pts",
  "dashboard_progressive_system": "Sistema Progresivo",
  "dashboard_last_sessions": "Últimas 3 sesiones analizadas",
  "dashboard_active_aim_telemetry": "Telemetría de mira activa",
  "dashboard_optimized": "Optimizado",
  "dashboard_skill_matrix": "Matriz de Habilidades",
  "dashboard_best_recorded": "Mejor registro",
  "dashboard_syncing_sensors": "Sincronizando sensores neurales...",
  "training_syncing_library": "Sincronizando biblioteca...",
  "training_library_title": "Biblioteca Mi",
  "training_recruit": "Recluta",
  "training_modules": "Módulos",
  "training_completed": "Completados",
  "training_search_placeholder": "Buscar entrenamiento...",
  "training_completed_empty": "Completa entrenamientos para desbloquear favoritos",
  "training_no_available": "No hay entrenamientos disponibles para este juego ahora.",
  "training_back": "Volver",
  "training_total_progress": "Progreso total",
  "training_of": "de",
  "training_level": "Nivel",
  "training_not_found": "Entrenamiento no encontrado",
  "training_level_1": "Principiante",
  "training_level_2": "Intermedio",
  "training_level_3": "Avanzado",
  "training_mi_recommendation": "Recomendación de Mi",
  "training_focus_title": "Qué vas a entrenar",
  "training_focus_fallback": "Enfócate en ejecutar perfecto el movimiento y corregir malos hábitos.",
  "training_why_title": "Por qué importa",
  "training_why_fallback": "Pequeños errores en este fundamento causan muchas muertes evitables durante las partidas.",
  "training_how_title": "Cómo hacerlo",
  "training_success_title": "Cómo saber si lo hiciste bien",
  "training_success_fallback": "El movimiento debe fluir sin trabarse y debes poder eliminar el objetivo sin perder vida.",
  "training_common_error_title": "Error común",
  "training_common_error_fallback": "Hacer el movimiento demasiado rápido antes de enfocarte en la precisión.",
  "training_mi_tip": "Consejo de Mi",
  "training_pro_reference": "Referencia Pro",
  "training_complete": "Completar entrenamiento ✓",
  "training_mark_done": "Marcar como hecho ⚡",
  "training_validate_execution": "Validar ejecución",
  "training_validate_execution_desc": "Envía un video de tu práctica para que Mi valide tu técnica.",
  "training_analyze_with_mi": "Analizar con Mi",
  "training_group_core": "Entrenamientos Core",
  "training_group_advanced": "Habilidades avanzadas",
  "training_group_competitive": "Nivel competitivo",
  "training_group_system": "Sistema y calentamiento",
  "training_cat_aim_name": "Mira y precisión",
  "training_cat_aim_desc": "Flick shots, tracking y microajustes",
  "training_cat_recoil_name": "Control de recoil",
  "training_cat_recoil_desc": "Spray control y patrones de recoil",
  "training_cat_movement_name": "Movimiento",
  "training_cat_movement_desc": "Strafing, crouch y jiggle peek",
  "training_cat_peek_name": "Peek y ángulos",
  "training_cat_peek_desc": "Shoulder peek y ángulos tácticos",
  "training_cat_positioning_name": "Posicionamiento",
  "training_cat_positioning_desc": "Cover, terreno elevado y zonas",
  "training_cat_crosshair_name": "Crosshair Placement",
  "training_cat_crosshair_desc": "Pre-aim y posición de mira",
  "training_cat_prefire_name": "Pre-fire y reacción",
  "training_cat_prefire_desc": "Timing y reaction drills",
  "training_cat_cqb_name": "Combate cercano",
  "training_cat_cqb_desc": "CQB, hipfire y room clearing",
  "training_cat_ranged_name": "Combate medio/largo",
  "training_cat_ranged_desc": "DMR, sniper y bullet drop",
  "training_cat_clutch_name": "Escenarios de clutch",
  "training_cat_clutch_desc": "1vN y gestión de recursos",
  "training_cat_rotation_name": "Rotación y zona",
  "training_cat_rotation_desc": "Zone prediction y rutas seguras",
  "training_cat_entry_name": "Entry fragging",
  "training_cat_entry_desc": "Primer contacto y trade kills",
  "training_cat_pressure_name": "Alta presión",
  "training_cat_pressure_desc": "End-game y decisiones bajo presión",
  "training_cat_warmup_name": "Calentamiento",
  "training_cat_warmup_desc": "Rutinas pre-game completas",
  "training_cat_consistency_name": "Consistencia",
  "training_cat_consistency_desc": "Corrección de errores y hábitos",
  "training_impact": "Impacto",
  "training_result_exceptional": "Excepcional",
  "training_result_very_good": "Muy bueno",
  "training_result_good": "Bueno",
  "training_result_regular": "Regular",
  "training_result_needs_improvement": "Necesita mejorar",
  "training_result_critical": "Crítico",
  "training_result_ai": "Resultado del análisis IA",
  "training_evaluated_skills": "Skills evaluadas",
  "training_detailed_analysis": "Análisis detallado",
  "training_strengths": "Puntos fuertes",
  "training_weaknesses": "Puntos débiles",
  "training_practical_corrections": "Correcciones prácticas",
  "training_next_recommended": "Próximo entrenamiento recomendado",
  "training_ask_coach": "Preguntar al Coach",
  "training_new_training": "Nuevo entrenamiento",
  "training_default_name": "entrenamiento",
  "training_coach_context": "Acabo de hacer el entrenamiento \"{{trainingName}}\" y recibí score {{score}}/100.\nMis puntos débiles: {{weaknesses}}.\nQuiero entender mejor qué puedo hacer para mejorar específicamente esos puntos.",
  "story_solid_performance": "Rendimiento sólido.",
  "story_room_to_improve": "Hay espacio para mejorar.",
  "story_time_to_adjust": "Hora de ajustar.",
  "story_weakest_point": "Punto más débil: {{label}}",
  "story_focus_first": "Enfócate aquí primero para mejorar más rápido.",
  "story_main_insight": "Insight principal",
  "story_no_detail": "Sin análisis detallado para este clip.",
  "story_metrics": "Tus métricas",
  "story_second_insight": "Segundo insight",
  "story_train_weakest": "Entrena el punto más débil.",
  "story_fix_now": "¿Listo para corregir esto ahora?",
  "story_previous": "Story anterior",
  "story_continue": "Continuar",
  "story_pause": "Pausar",
  "story_next": "Próximo story",
  "story_paused": "Pausado",
  "story_mi_summary": "Resumen de Mi",
  "story_correction": "Corrección",
  "story_action_fallback": "Aplica el ajuste y valídalo en una nueva prueba.",
  "kpi_aim": "Mira",
  "kpi_positioning": "Posicionamiento",
  "kpi_decision": "Decisión",
  "kpi_timing": "Timing",
  "kpi_movement": "Movimiento",
  "kpi_recoil": "Recoil",
  "pubg_calc_professional_title": "Calculadora profesional",
  "pubg_calc_professional_desc": "Usa una sensibilidad base y genera todas las demás configuraciones al instante.",
  "pubg_access_lifetime_active": "Vitalicio activo: uso ilimitado",
  "pubg_access_unlimited": "Acceso liberado: ilimitado",
  "pubg_access_pro_month": "{{count}}/15 cálculos este mes",
  "pubg_access_free_count": "{{count}}/2 cálculos gratis",
  "pubg_access_free_weapons": "Free libera M416 y Honey Badger",
  "pubg_device_not_informed": "Dispositivo no informado",
  "pubg_control_gyro": "Gyro",
  "pubg_control_camera": "Lente / Cámara al apuntar",
  "pubg_control_mode": "Modo de control",
  "pubg_primary_weapon": "Arma principal",
  "pubg_other_weapons": "Otras armas...",
  "pubg_base_scope": "Mira base conocida",
  "pubg_perfect_value": "Valor de sensibilidad perfecta",
  "pubg_device_model": "Modelo del dispositivo",
  "pubg_optional_recommended": "Opcional, recomendado",
  "pubg_device_placeholder": "Ej: iPhone 17, Poco X6 Pro, Galaxy S26, Redmi Note 12...",
  "pubg_generating_panel": "Generando panel...",
  "pubg_calculate_config": "Calcular configuración",
  "pubg_unlock_lifetime": "Desbloquear acceso vitalicio",
  "pubg_generated": "Generado",
  "pubg_result_title": "Resultado FPS Mobile (Alpha)",
  "pubg_result_subtitle": "Valores calculados desde tu mira base.",
  "pubg_recalculate": "Recalcular",
  "pubg_base_used": "Base usada",
  "pubg_recommended_config": "Configuración recomendada",
  "pubg_scope": "Mira",
  "pubg_value": "Valor",
  "pubg_type": "Tipo",
  "pubg_copy_config": "Copiar configuración",
  "pubg_fine_tune_sensi": "Ajuste fino con Sensi-IA",
  "pubg_test_tip": "Prueba los valores en entrenamiento por 5 min. Si la mira sube, baja o tiembla, usa Sensi-IA para refinar.",
  "pubg_calc_summary": "Resumen del cálculo",
  "pubg_base_value": "Valor base",
  "pubg_mode": "Modo",
  "pubg_weapon": "Arma",
  "pubg_device": "Dispositivo",
  "pubg_tag_adjusted": "Ajustado",
  "pubg_tag_base": "Base",
  "pubg_tag_control": "Control",
  "pubg_tag_precision": "Precisión",
  "pubg_tag_long_range": "Larga distancia",
  "pubg_desc_rotation_precision": "Recomendado para rotación y precisión.",
  "pubg_desc_first_person": "Recomendado para control en primera persona.",
  "pubg_desc_short_scope": "Valor principal para mira corta.",
  "pubg_desc_short_medium_spray": "Ajustado para spray corto y medio.",
  "pubg_desc_mid_range": "Ajustado para control en media distancia.",
  "pubg_desc_smooth_moves": "Usa movimientos más suaves.",
  "pubg_desc_stability": "Ideal para control más estable.",
  "pubg_desc_light_consistent": "Usa movimientos leves y consistentes.",
  "pubg_desc_training_test": "Valor recomendado para probar en entrenamiento.",
  "pubg_desc_base_value": "Valor base informado.",
  "pubg_pro_lifetime": "PRO / VITALICIO",
  "pubg_locked": "Bloqueado",
  "pubg_error_value_range": "El valor perfecto debe estar entre 1 y 500.",
  "pubg_error_scope_pro": "Esta mira es una función Pro. Usa Red Dot o 2x gratis.",
  "pubg_error_access": "Fallo al validar acceso. Intenta de nuevo.",
  "pubg_error_calculate": "Error al calcular. Intenta nuevamente.",
  "pubg_notice_generated": "Panel generado con éxito.",
  "pubg_error_session": "Sesión expirada. Inicia sesión nuevamente.",
  "pubg_error_connection": "Fallo de conexión. Intenta de nuevo en breve.",
  "pubg_copy_title": "Mi sensibilidad FPS Mobile (Alpha) - Game Pro Hub",
  "pubg_free_copy_note": "Solo Red Dot y 2x están incluidas en la prueba Free. Adquiere la Calculadora FPS Mobile (Alpha) Vitalicia en Game Pro Hub para todas las miras.",
  "pubg_notice_copied": "Valores copiados.",
  "pubg_error_copy": "No se pudo copiar.",
  "security_eyebrow": "Seguridad",
  "security_title": "Seguridad en Game Pro Hub",
  "security_subtitle": "Protegemos tu cuenta, tus pagos y tus datos para que te enfoques en mejorar en el juego.",
  "security_payments_title": "Pagos seguros",
  "security_payments_text": "Los pagos son procesados por Stripe. Game Pro Hub no almacena datos completos de tarjeta.",
  "security_access_title": "Acceso protegido",
  "security_access_text": "La autenticación usa proveedores seguros y nunca pedimos la contraseña de tu cuenta del juego.",
  "security_data_title": "Datos usados con responsabilidad",
  "security_data_text": "Usamos los datos que envías solo para entregar análisis, entrenamiento, historial y soporte de la plataforma.",
  "security_infra_title": "Infraestructura monitoreada",
  "security_infra_text": "El backend opera con servicios monitoreados y webhooks validados antes de desbloquear acceso.",
  "security_transparency_title": "Transparencia",
  "security_transparency_text": "Los identificadores de Stripe quedan en el backend y el acceso pago depende de confirmación validada, nunca solo de la página de éxito.",
  "security_privacy_title": "Buenas prácticas de privacidad",
  "security_privacy_text": "Evita enviar datos sensibles en videos. Si tienes dudas, contacta al soporte oficial.",
  "security_notice_title": "Aviso honesto",
  "security_notice_text": "Ningún sistema puede prometer seguridad absoluta, pero trabajamos para reducir riesgos y corregir problemas rápido.",
  "security_faq_title": "Preguntas rápidas",
  "security_faq_account_q": "¿Necesito conectar mi cuenta del juego?",
  "security_faq_account_a": "No. Game Pro Hub funciona sin conectar tu cuenta del juego.",
  "security_faq_payment_q": "¿Quién procesa el pago?",
  "security_faq_payment_a": "Stripe procesa el checkout y envía confirmaciones seguras al backend.",
  "security_faq_support_q": "¿Cómo contacto soporte?",
  "security_faq_support_a": "Usa el card de soporte en Perfil o el WhatsApp oficial de Game Pro Hub.",
  "security_cta_badge": "Listo para mejorar",
  "security_cta_title": "Crea tu cuenta con seguridad.",
  "security_cta_text": "Entra al hub y usa Mi para entrenar mejor sin dar acceso a tu cuenta del juego.",
  "security_cta": "Crear cuenta con seguridad",
  "security_have_account": "¿Ya tienes cuenta?",
  "security_back_app": "Volver al app.",
  "mi_analysis_paywall_desc": "Envía una partida corta y recibe diagnóstico táctico, errores por momento y próximos entrenamientos recomendados.",
  "mi_analysis_subscribe_pro": "Suscribirse a Pro",
  "mi_analysis_processing_title": "Mi Análisis en proceso",
  "mi_analysis_waiting_queue": "Esperando en la cola de procesamiento...",
  "mi_analysis_header_subtitle": "Diagnóstico técnico de gameplay para {{game}}",
  "mi_analysis_upload_title": "Envía tu gameplay",
  "mi_analysis_upload_desc": "Usa un clip con combate real, decisión táctica o un error que quieras entender.",
  "mi_analysis_select_video": "Seleccionar video",
  "mi_analysis_formats": "MP4, MOV o WEBM hasta 200MB",
  "mi_analysis_confirm_title": "Confirmar envío",
  "mi_analysis_confirm_desc": "Mi analizará video, contexto del juego e historial reciente.",
  "mi_analysis_file_size": "Tamaño: {{size}} MB",
  "mi_analysis_change_video": "Cambiar video",
  "mi_analysis_sending": "Enviando...",
  "mi_analysis_send": "Enviar a Mi Análisis",
  "mi_analysis_history_title": "Historial de Mi Análisis",
  "mi_analysis_no_date": "Sin fecha",
  "mi_analysis_history_fallback": "Análisis de gameplay",
  "mi_analysis_report": "Informe",
  "mi_analysis_empty": "No hay análisis anteriores registrados. Envía tu primer video arriba.",
  "mi_analysis_back_arena": "Herramientas",
  "celebration_training_complete": "¡Entrenamiento completo!",
  "celebration_next_training": "Próximo entrenamiento",
  "celebration_close": "Cerrar"
};

export const translations = { 'pt-BR': ptBR, 'en-US': enUS, 'es-ES': esES };
export const TRANSLATIONS = translations;

export function normalizeLocale(raw) {
  const input = String(raw || '').trim();
  if (!input) return DEFAULT_LANGUAGE;
  if (translations[input]) return input;
  const lowered = input.toLowerCase();
  if (LEGACY_TO_CANONICAL[lowered]) return LEGACY_TO_CANONICAL[lowered];
  if (lowered.startsWith('pt')) return 'pt-BR';
  if (lowered.startsWith('en')) return 'en-US';
  if (lowered.startsWith('es')) return 'es-ES';
  return DEFAULT_LANGUAGE;
}

const normalizeLanguage = normalizeLocale;

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    return normalizeLanguage(saved);
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, language);
    localStorage.setItem(STORAGE_SHORT_KEY, CANONICAL_TO_SHORT[language] || 'pt');
    document.documentElement.lang = language;
  }, [language]);

  const t = useCallback((key, params = {}) => {
    const dict = translations[language] || translations[DEFAULT_LANGUAGE];
    let text = dict[key];
    if (text === undefined) {
      text = `[missing:${language}:${key}]`;
      if (process.env.NODE_ENV !== 'test') {
        console.error(`[i18n] Missing translation key "${key}" for "${language}"`);
      }
    }
    if (typeof text !== 'string') return text;
    Object.entries(params).forEach(([k, v]) => {
      text = text.replace(new RegExp(`\\{\\{ ${k} \\}\\}`, 'g'), v);
      text = text.replace(new RegExp(`\\{\\{${k}\\}\\}`, 'g'), v);
    });
    return text;
  }, [language]);

  const changeLanguage = useCallback((newLang) => {
    const normalized = normalizeLanguage(newLang);
    setLanguage(normalized);
  }, []);

  const value = useMemo(() => ({
    language, lang: language, t, changeLanguage, supportedLanguages: SUPPORTED_LANGUAGES
  }), [language, t, changeLanguage]);

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) throw new Error('useLanguage must be used within a LanguageProvider');
  return context;
}

export const useLang = useLanguage;
export const LangProvider = LanguageProvider;
